import angular from 'angular';

angular.module('commonServices').constant('zipCodes', [
  {
    code: '0612',
    name: 'Sinterklaas',
  },
  {
    code: '1000',
    name: 'Brussel',
    nameNL: 'Brussel',
    nameFR: 'Bruxelles',
  },
  {
    code: '1005',
    name: 'Verenigde Vergadering van de Gemeenschappelijke Gemeenschapscommissie',

    nameFR: 'Assemblée Réunie de la Commission Communautaire Commune',
  },
  {
    code: '1005',
    name: 'Brussels Hoofdstedelijk Parlement',

    nameFR: 'Parlement de la Région de Bruxelles-Capitale',
  },
  {
    code: '1006',
    name: 'Raad van de Vlaamse Gemeenschapscommissie',

    nameFR: 'Conseil de la Commission communautaire flamande',
  },
  {
    code: '1007',
    name: 'Raad van de Franse Gemeenschapscommissie',

    nameFR: 'Assemblée de la Commission Communautaire Française',
  },
  {
    code: '1008',
    name: 'Kamer van Volksvertegenwoordigers',

    nameFR: 'Chambre des Représentants',
  },
  {
    code: '1009',
    name: 'Belgische Senaat',

    nameFR: 'Senat de Belgique',
  },
  {
    code: '1011',
    name: 'Vlaams Parlement',

    nameFR: 'Parlement flamand',
  },
  {
    code: '1012',
    name: 'Parlement van de Franse Gemeenschap',

    nameFR: 'Parlement de la Communauté française',
  },
  {
    code: '1020',
    name: 'Laken',

    nameFR: 'Laeken',
  },
  {
    code: '1030',
    name: 'Schaarbeek',

    nameFR: 'Schaerbeek',
  },
  {
    code: '1031',
    name: 'Christelijke Sociale Organisaties',

    nameFR: 'Organisations Sociales Chrétiennes',
  },
  {
    code: '1033',
    name: 'Rtl-Tvi',
  },
  {
    code: '1035',
    name: 'Ministerie van het Brussels Hoofdstedelijk Gewest',

    nameFR: 'Ministère de la Région de Bruxelles Capitale',
  },
  {
    code: '1040',
    name: 'Etterbeek',
  },
  {
    code: '1041',
    name: 'International press center',
  },
  {
    code: '1043',
    name: 'Vrt',
  },
  {
    code: '1044',
    name: 'Rtbf',
  },
  {
    code: '1045',
    name: 'D.I.V.',
  },
  {
    code: '1046',
    name: 'European External Action Service',
  },
  {
    code: '1047',
    name: 'Europees Parlement',

    nameFR: 'Parlement Européen',
  },
  {
    code: '1048',
    name: 'Europese unie - Raad',

    nameFR: 'Union Européenne - Conseil',
  },
  {
    code: '1049',
    name: 'Europese unie - Commissie',

    nameFR: 'Union Européenne - Commission',
  },
  {
    code: '1050',
    name: 'Elsene',
    nameNL: 'Elsene',
    nameFR: 'Ixelles',
  },
  {
    code: '1060',
    name: 'Sint-Gillis',
    nameNL: 'Sint-Gillis',
    nameFR: 'Saint-Gilles',
  },
  {
    code: '1070',
    name: 'Anderlecht',
  },
  {
    code: '1080',
    name: 'Sint-Jans-Molenbeek',

    nameFR: 'Molenbeek-Sint-Jean',
  },
  {
    code: '1081',
    name: 'Koekelberg',
  },
  {
    code: '1082',
    name: 'Sint-Agatha-Berchem',

    nameFR: 'Berchem-Sainte-Agathe',
  },
  {
    code: '1083',
    name: 'Ganshoren',
  },
  {
    code: '1090',
    name: 'Jette',
  },
  {
    code: '1099',
    name: 'Brussel X',

    nameFR: 'Bruxelles X',
  },
  {
    code: '1100',
    name: 'Postcheque',

    nameFR: 'Chèques postaux',
  },
  {
    code: '1101',
    name: 'Scanning',
  },
  {
    code: '1105',
    name: 'Sociale Dienst van Bpost (SOC)',

    nameFR: 'Service social de la Poste (SOC)',
  },
  {
    code: '1110',
    name: 'Navo',

    nameFR: 'OTAN',
  },
  {
    code: '1120',
    name: 'Neder-Over-Heembeek',
  },
  {
    code: '1130',
    name: 'Haren',
  },
  {
    code: '1140',
    name: 'Evere',
  },
  {
    code: '1150',
    name: 'Sint-Pieters-Woluwe',
    nameNL: 'Sint-Pieters-Woluwe',
    nameFR: 'Woluwe-Saint-Pierre',
  },
  {
    code: '1160',
    name: 'Oudergem',
    nameNL: 'Oudergem',
    nameFR: 'Auderghem',
  },
  {
    code: '1170',
    name: 'Watermaal-Bosvoorde',
    nameNL: 'Watermaal-Bosvoorde',
    nameFR: 'Watermael-Boitsfort',
  },
  {
    code: '1180',
    name: 'Ukkel',
    nameNL: 'Ukkel',
    nameFR: 'Uccle',
  },
  {
    code: '1190',
    name: 'Vorst',
    nameNL: 'Vorst',
    nameFR: 'Forest',
  },
  {
    code: '1200',
    name: 'Sint-Lambrechts-Woluwe',
    nameNL: 'Sint-Lambrechts-Woluwe',
    nameFR: 'Woluwe-Saint-Lambert',
  },
  {
    code: '1210',
    name: 'Sint-Joost-ten-Node',
    nameNL: 'Sint-Joost-ten-Node',
    nameFR: 'Saint-Josse-ten-Noode',
  },
  {
    code: '1212',
    name: 'FOD Mobiliteit',

    nameFR: 'SPF Mobilité',
  },
  {
    code: '1300',
    name: 'Limal',
  },
  {
    code: '1300',
    name: 'Wavre',
    nameNL: 'Waver',
    nameFR: 'Wavre',
  },
  {
    code: '1301',
    name: 'Bierges',
  },
  {
    code: '1310',
    name: 'La Hulpe',
    nameNL: 'Terhulpen',
    nameFR: 'La Hulpe',
  },
  {
    code: '1315',
    name: 'Glimes',
  },
  {
    code: '1315',
    name: 'Incourt',
  },
  {
    code: '1315',
    name: 'Opprebais',
  },
  {
    code: '1315',
    name: 'Piètrebais',
  },
  {
    code: '1315',
    name: 'Roux-Miroir',
  },
  {
    code: '1320',
    name: 'Beauvechain',
    nameNL: 'Bevekom',
    nameFR: 'Beauvechain',
  },
  {
    code: '1320',
    name: 'Hamme-Mille',
  },
  {
    code: '1320',
    name: "L'Ecluse",
    nameNL: 'Sluizen',
    nameFR: "l'Ecluse",
  },
  {
    code: '1320',
    name: 'Nodebais',
  },
  {
    code: '1320',
    name: 'Tourinnes-La-Grosse',
    nameNL: 'Deurne',
    nameFR: 'Tourinnes-la-Grosse',
  },
  {
    code: '1325',
    name: 'Bonlez',
  },
  {
    code: '1325',
    name: 'Chaumont-Gistoux',
  },
  {
    code: '1325',
    name: 'Corroy-Le-Grand',
  },
  {
    code: '1325',
    name: 'Dion-Valmont',
  },
  {
    code: '1325',
    name: 'Longueville',
  },
  {
    code: '1330',
    name: 'Rixensart',
  },
  {
    code: '1331',
    name: 'Rosières',
  },
  {
    code: '1332',
    name: 'Genval',
  },
  {
    code: '1340',
    name: 'Ottignies',
  },
  {
    code: '1340',
    name: 'Ottignies-Louvain-La-Neuve',
  },
  {
    code: '1341',
    name: 'Céroux-Mousty',
  },
  {
    code: '1342',
    name: 'Limelette',
  },
  {
    code: '1348',
    name: 'Louvain-La-Neuve',
  },
  {
    code: '1350',
    name: 'Enines',
  },
  {
    code: '1350',
    name: 'Folx-Les-Caves',
  },
  {
    code: '1350',
    name: 'Jandrain-Jandrenouille',
  },
  {
    code: '1350',
    name: 'Jauche',
    nameNL: 'Geten',
    nameFR: 'Jauche',
  },
  {
    code: '1350',
    name: 'Marilles',
  },
  {
    code: '1350',
    name: 'Noduwez',
  },
  {
    code: '1350',
    name: 'Orp-Jauche',
  },
  {
    code: '1350',
    name: 'Orp-Le-Grand',
  },
  {
    code: '1357',
    name: 'Hélecine',
  },
  {
    code: '1357',
    name: 'Linsmeau',
    nameNL: 'Linsmeel',
    nameFR: 'Linsmeau',
  },
  {
    code: '1357',
    name: 'Neerheylissem',
  },
  {
    code: '1357',
    name: 'Opheylissem',
  },
  {
    code: '1360',
    name: 'Malèves-Sainte-Marie-Wastines',
  },
  {
    code: '1360',
    name: 'Orbais',
  },
  {
    code: '1360',
    name: 'Perwez',
    nameNL: 'Perwijs',
    nameFR: 'Perwez',
  },
  {
    code: '1360',
    name: 'Thorembais-Les-Béguines',
  },
  {
    code: '1360',
    name: 'Thorembais-Saint-Trond',
  },
  {
    code: '1367',
    name: 'Autre-Eglise',
  },
  {
    code: '1367',
    name: 'Bomal',
  },
  {
    code: '1367',
    name: 'Geest-Gérompont-Petit-Rosière',
  },
  {
    code: '1367',
    name: 'Gérompont',
  },
  {
    code: '1367',
    name: 'Grand-Rosière-Hottomont',
  },
  {
    code: '1367',
    name: 'Huppaye',
  },
  {
    code: '1367',
    name: 'Mont-Saint-André',
  },
  {
    code: '1367',
    name: 'Ramilies',
  },
  {
    code: '1370',
    name: 'Dongelberg',
  },
  {
    code: '1370',
    name: 'Jauchelette',
  },
  {
    code: '1370',
    name: 'Jodoigne',
    nameNL: 'Geldenaken',
    nameFR: 'Jodoigne',
  },
  {
    code: '1370',
    name: 'Jodoigne-Souveraine',
    nameNL: 'Opgeldenaken',
    nameFR: 'Jodoigne-Souveraine',
  },
  {
    code: '1370',
    name: 'Lathuy',
  },
  {
    code: '1370',
    name: 'Mélin',
    nameNL: 'Malen',
    nameFR: 'Mélin',
  },
  {
    code: '1370',
    name: 'Piétrain',
    nameNL: 'Petrem',
    nameFR: 'Piétrain',
  },
  {
    code: '1370',
    name: 'Saint-Jean-Geest',
    nameNL: 'Sint-Jans-Geest',
    nameFR: 'Saint-Jean-Geest',
  },
  {
    code: '1370',
    name: 'Saint-Remy-Geest',
    nameNL: 'Sant-Remigius-Geeest',
    nameFR: 'Saint-Remy-Geest',
  },
  {
    code: '1370',
    name: 'Zétrud-Lumay',
    nameNL: 'Zittert-Lummen',
    nameFR: 'Zétrud-Lumay',
  },
  {
    code: '1380',
    name: 'Couture-Saint-Germain',
  },
  {
    code: '1380',
    name: 'Lasne',
  },
  {
    code: '1380',
    name: 'Lasne-Chapelle-Saint-Lambert',
  },
  {
    code: '1380',
    name: 'Maransart',
  },
  {
    code: '1380',
    name: 'Ohain',
  },
  {
    code: '1380',
    name: 'Plancenoit',
  },
  {
    code: '1390',
    name: 'Archennes',
    nameNL: 'Eerken',
    nameFR: 'Archennes',
  },
  {
    code: '1390',
    name: 'Biez',
  },
  {
    code: '1390',
    name: 'Bossut-Gottechain',
  },
  {
    code: '1390',
    name: 'Grez-Doiceau',
    nameNL: 'Graven',
    nameFR: 'Grez-Doiceau',
  },
  {
    code: '1390',
    name: 'Nethen',
  },
  {
    code: '1400',
    name: 'Monstreux',
  },
  {
    code: '1400',
    name: 'Nivelles',
    nameNL: 'Nijvel',
    nameFR: 'Nivelles',
  },
  {
    code: '1401',
    name: 'Baulers',
  },
  {
    code: '1402',
    name: 'Thines',
  },
  {
    code: '1404',
    name: 'Bornival',
  },
  {
    code: '1410',
    name: 'Waterloo',
  },
  {
    code: '1420',
    name: "Braine-l'Alleud",
    nameNL: 'Eigenbrakel',
    nameFR: "Braine-l'Alleud",
  },
  {
    code: '1421',
    name: 'Ophain-Bois-Seigneur-Isaac',
  },
  {
    code: '1428',
    name: 'Lillois-Witterzée',
  },
  {
    code: '1430',
    name: 'Bierghes',
    nameNL: 'Bierk',
  },
  {
    code: '1430',
    name: 'Quenast',
  },
  {
    code: '1430',
    name: 'Rebecq',
  },
  {
    code: '1430',
    name: 'Rebecq-Rognon',
    nameNL: 'Roosbeek',
    nameFR: 'Rebecq-Rognon',
  },
  {
    code: '1435',
    name: 'Corbais',
  },
  {
    code: '1435',
    name: 'Hévillers',
  },
  {
    code: '1435',
    name: 'Mont-Saint-Guibert',
  },
  {
    code: '1440',
    name: 'Braine-Le-Château',
    nameNL: 'Kasteelbrakel',
    nameFR: 'Braine-le-Château',
  },
  {
    code: '1440',
    name: 'Wauthier-Braine',
    nameNL: 'Woutersbrakel',
    nameFR: 'Wauthier-Braine',
  },
  {
    code: '1450',
    name: 'Chastre',
  },
  {
    code: '1450',
    name: 'Chastre-Villeroux-Blanmont',
  },
  {
    code: '1450',
    name: 'Cortil-Noirmont',
  },
  {
    code: '1450',
    name: 'Gentinnes',
  },
  {
    code: '1450',
    name: 'Saint-Géry',
    nameNL: 'Sint-Goriks',
    nameFR: 'Saint-Géry',
  },
  {
    code: '1457',
    name: 'Nil-Saint-Vincent-Saint-Martin',
  },
  {
    code: '1457',
    name: 'Tourinnes-Saint-Lambert',
  },
  {
    code: '1457',
    name: 'Walhain',
  },
  {
    code: '1457',
    name: 'Walhain-Saint-Paul',
  },
  {
    code: '1460',
    name: 'Ittre',
    nameNL: 'Itter',
    nameFR: 'Ittre',
  },
  {
    code: '1460',
    name: 'Virginal-Samme',
  },
  {
    code: '1461',
    name: 'Haut-Ittre',
  },
  {
    code: '1470',
    name: 'Baisy-Thy',
  },
  {
    code: '1470',
    name: 'Bousval',
  },
  {
    code: '1470',
    name: 'Genappe',
    nameNL: 'Genepiën',
    nameFR: 'Genappe',
  },
  {
    code: '1471',
    name: 'Loupoigne',
  },
  {
    code: '1472',
    name: 'Vieux-Genappe',
    nameNL: 'Oud-Genepiën',
    nameFR: 'Vieux-Genappe',
  },
  {
    code: '1473',
    name: 'Glabais',
  },
  {
    code: '1474',
    name: 'Ways',
  },
  {
    code: '1476',
    name: 'Houtain-Le-Val',
  },
  {
    code: '1480',
    name: 'Clabecq',
    nameNL: 'Klabbeek',
    nameFR: 'Clabecq',
  },
  {
    code: '1480',
    name: 'Oisquercq',
    nameNL: 'Oostkerk',
    nameFR: 'Oisquercq',
  },
  {
    code: '1480',
    name: 'Saintes',
    nameNL: 'Sint-Renelde',
    nameFR: 'Saintes',
  },
  {
    code: '1480',
    name: 'Tubize',
    nameNL: 'Tubeke',
    nameFR: 'Tubize',
  },
  {
    code: '1490',
    name: 'Court-Saint-Étienne',
    nameNL: 'Court-Saint-Etienne',
  },
  {
    code: '1495',
    name: 'Marbais',
  },
  {
    code: '1495',
    name: 'Mellery',
  },
  {
    code: '1495',
    name: 'Sart-Dames-Avelines',
  },
  {
    code: '1495',
    name: 'Tilly',
  },
  {
    code: '1495',
    name: 'Villers-La-Ville',
    nameNL: 'Villers-de-Stad',
    nameFR: 'Villers-la-Ville',
  },
  {
    code: '1500',
    name: 'Halle',
    nameNL: 'Halle',
    nameFR: 'Hal',
  },
  {
    code: '1501',
    name: 'Buizingen',
  },
  {
    code: '1502',
    name: 'Lembeek',
    nameNL: 'Lembeek',
    nameFR: 'Lembecq',
  },
  {
    code: '1540',
    name: 'Herfelingen',
  },
  {
    code: '1540',
    name: 'Pajottegem',
    nameNL: 'Pajottegem',
    nameFR: 'Pajottegem',
  },
  {
    code: '1541',
    name: 'Sint-Pieters-Kapelle',
    nameNL: 'Sint-Pieters-Kapelle',
    nameFR: 'Saint-Pierre-Capelle',
  },
  {
    code: '1547',
    name: 'Bever',
    nameNL: 'Bever',
    nameFR: 'Biévène',
  },
  {
    code: '1560',
    name: 'Hoeilaart',
  },
  {
    code: '1570',
    name: 'Pajottegem',
    nameNL: 'Pajottegem',
    nameFR: 'Pajottegem',
  },
  {
    code: '1570',
    name: 'Tollembeek',
  },
  {
    code: '1570',
    name: 'Vollezele',
  },
  {
    code: '1600',
    name: 'Oudenaken',
  },
  {
    code: '1600',
    name: 'Sint-Laureins-Berchem',
  },
  {
    code: '1600',
    name: 'Sint-Pieters-Leeuw',
    nameNL: 'Sint-Pieters-Leeuw',
    nameFR: 'Leeuw-Saint-Pierre',
  },
  {
    code: '1601',
    name: 'Ruisbroek',
  },
  {
    code: '1602',
    name: 'Vlezenbeek',
  },
  {
    code: '1620',
    name: 'Drogenbos',
  },
  {
    code: '1630',
    name: 'Linkebeek',
  },
  {
    code: '1640',
    name: 'Sint-Genesius-Rode',
    nameNL: 'Sint-Genesius-Rode',
    nameFR: 'Rhode-Saint-Genèse',
  },
  {
    code: '1650',
    name: 'Beersel',
  },
  {
    code: '1651',
    name: 'Lot',
    nameNL: 'Lot',
    nameFR: 'Loth',
  },
  {
    code: '1652',
    name: 'Alsemberg',
  },
  {
    code: '1653',
    name: 'Dworp',
    nameNL: 'Dworp',
    nameFR: 'Tourneppe',
  },
  {
    code: '1654',
    name: 'Huizingen',
    nameNL: 'Huizingen',
    nameFR: 'Huyssinghen',
  },
  {
    code: '1670',
    name: 'Bogaarden',
  },
  {
    code: '1670',
    name: 'Heikruis',
    nameNL: 'Heikruis',
    nameFR: 'Hautecroix',
  },
  {
    code: '1670',
    name: 'Pepingen',
  },
  {
    code: '1671',
    name: 'Elingen',
  },
  {
    code: '1673',
    name: 'Beert',
    nameNL: 'Beert',
    nameFR: 'Brages',
  },
  {
    code: '1674',
    name: 'Bellingen',
  },
  {
    code: '1700',
    name: 'Dilbeek',
  },
  {
    code: '1700',
    name: 'Sint-Martens-Bodegem',

    nameFR: 'Bodeghem-Saint-Martin',
  },
  {
    code: '1700',
    name: 'Sint-Ulriks-Kapelle',
    nameNL: 'Sint-Ulriks-Kapelle',
    nameFR: 'Chapelle-Saint-Ulric',
  },
  {
    code: '1701',
    name: 'Itterbeek',
  },
  {
    code: '1702',
    name: 'Groot-Bijgaarden',
    nameNL: 'Groot-Bijgaarden',
    nameFR: 'Grand-Bigard',
  },
  {
    code: '1703',
    name: 'Schepdaal',
  },
  {
    code: '1730',
    name: 'Asse',
  },
  {
    code: '1730',
    name: 'Bekkerzeel',
  },
  {
    code: '1730',
    name: 'Kobbegem',
  },
  {
    code: '1730',
    name: 'Mollem',
  },
  {
    code: '1731',
    name: 'Relegem',
  },
  {
    code: '1731',
    name: 'Zellik',
  },
  {
    code: '1733',
    name: 'HighCo DATA',
  },
  {
    code: '1740',
    name: 'Ternat',
  },
  {
    code: '1741',
    name: 'Wambeek',
  },
  {
    code: '1742',
    name: 'Sint-Katherina-Lombeek',
  },
  {
    code: '1745',
    name: 'Mazenzele',
    nameNL: 'Mazenzele',
    nameFR: 'Maxenzele',
  },
  {
    code: '1745',
    name: 'Opwijk',
  },
  {
    code: '1750',
    name: 'Gaasbeek',
  },
  {
    code: '1750',
    name: 'Lennik',
  },
  {
    code: '1750',
    name: 'Sint-Kwintens-Lennik',
    nameNL: 'Sint-Kwintens-Lennik',
    nameFR: 'Lennick-Saint-Quentin',
  },
  {
    code: '1750',
    name: 'Sint-Martens-Lennik',
    nameNL: 'Sint-Martens-Lennik',
    nameFR: 'Lennick-Saint-Martin',
  },
  {
    code: '1755',
    name: 'Pajottegem',
  },
  {
    code: '1755',
    name: 'Kester',
  },
  {
    code: '1755',
    name: 'Leerbeek',
  },
  {
    code: '1755',
    name: 'Oetingen',
  },
  {
    code: '1760',
    name: 'Onze-Lieve-Vrouw-Lombeek',

    nameFR: 'Lombeek-Notre-Dame',
  },
  {
    code: '1760',
    name: 'Pamel',
  },
  {
    code: '1760',
    name: 'Roosdaal',
  },
  {
    code: '1760',
    name: 'Strijtem',
  },
  {
    code: '1761',
    name: 'Borchtlombeek',
  },
  {
    code: '1770',
    name: 'Liedekerke',
  },
  {
    code: '1780',
    name: 'Wemmel',
  },
  {
    code: '1785',
    name: 'Brussegem',
  },
  {
    code: '1785',
    name: 'Hamme',
  },
  {
    code: '1785',
    name: 'Merchtem',
  },
  {
    code: '1790',
    name: 'Affligem',
  },
  {
    code: '1790',
    name: 'Essene',
  },
  {
    code: '1790',
    name: 'Hekelgem',
  },
  {
    code: '1790',
    name: 'Teralfene',
  },
  {
    code: '1800',
    name: 'Peutie',
  },
  {
    code: '1800',
    name: 'Vilvoorde',
    nameNL: 'Vilvoorde',
    nameFR: 'Volvorde',
  },
  {
    code: '1804',
    name: 'Cargovil',
  },
  {
    code: '1818',
    name: 'Vtm',
  },
  {
    code: '1820',
    name: 'Melsbroek',
  },
  {
    code: '1820',
    name: 'Perk',
  },
  {
    code: '1820',
    name: 'Steenokkerzeel',
  },
  {
    code: '1830',
    name: 'Machelen',
  },
  {
    code: '1831',
    name: 'Diegem',
  },
  {
    code: '1840',
    name: 'Londerzeel',
  },
  {
    code: '1840',
    name: 'Malderen',
  },
  {
    code: '1840',
    name: 'Steenhuffel',
  },
  {
    code: '1850',
    name: 'Grimbergen',
  },
  {
    code: '1851',
    name: 'Humbeek',
  },
  {
    code: '1852',
    name: 'Beigem',
    nameNL: 'Beigem',
    nameFR: 'Beyghem',
  },
  {
    code: '1853',
    name: 'Strombeek-Bever',
  },
  {
    code: '1860',
    name: 'Meise',
  },
  {
    code: '1861',
    name: 'Wolvertem',
  },
  {
    code: '1880',
    name: 'Kapelle-Op-Den-Bos',
    nameNL: 'Kapelle-op-den-Bos',
    nameFR: 'Cap(p)elle-au-Bois',
  },
  {
    code: '1880',
    name: 'Nieuwenrode',
  },
  {
    code: '1880',
    name: 'Ramsdonk',
  },
  {
    code: '1910',
    name: 'Berg',
  },
  {
    code: '1910',
    name: 'Buken',
  },
  {
    code: '1910',
    name: 'Kampenhout',
  },
  {
    code: '1910',
    name: 'Nederokkerzeel',
  },
  {
    code: '1930',
    name: 'Nossegem',
  },
  {
    code: '1930',
    name: 'Zaventem',
  },
  {
    code: '1931',
    name: 'Brucargo',
  },
  {
    code: '1932',
    name: 'Sint-Stevens-Woluwe',
    nameNL: 'Sint-Stevens-Woluwe',
    nameFR: 'Woluwe-Saint-Étienne',
  },
  {
    code: '1933',
    name: 'Sterrebeek',
  },
  {
    code: '1934',
    name: 'Office Exchange Brussels Airpor Remailing',
  },
  {
    code: '1935',
    name: 'Corporate Village',
  },
  {
    code: '1950',
    name: 'Kraainem',

    nameFR: 'Crainhem',
  },
  {
    code: '1970',
    name: 'Wezembeek-Oppem',
  },
  {
    code: '1980',
    name: 'Eppegem',
  },
  {
    code: '1980',
    name: 'Zemst',
  },
  {
    code: '1981',
    name: 'Hofstade',
  },
  {
    code: '1982',
    name: 'Elewijt',
  },
  {
    code: '1982',
    name: 'Weerde',
  },
  {
    code: '2000',
    name: 'Antwerpen',
    nameNL: 'Antwerpen',
    nameFR: 'Anvers',
  },
  {
    code: '2018',
    name: 'Antwerpen',

    nameFR: 'Anvers',
  },
  {
    code: '2020',
    name: 'Antwerpen',

    nameFR: 'Anvers',
  },
  {
    code: '2030',
    name: 'Antwerpen',

    nameFR: 'Anvers',
  },
  {
    code: '2040',
    name: 'Antwerpen',

    nameFR: 'Anvers',
  },
  {
    code: '2040',
    name: 'Berendrecht',
  },
  {
    code: '2040',
    name: 'Lillo',
  },
  {
    code: '2040',
    name: 'Zandvliet',
  },
  {
    code: '2050',
    name: 'Antwerpen',

    nameFR: 'Anvers',
  },
  {
    code: '2060',
    name: 'Antwerpen',

    nameFR: 'Anvers',
  },
  {
    code: '2070',
    name: 'Burcht',
  },
  {
    code: '2070',
    name: 'Beveren-Kruibeke-Zwijndrecht',
  },
  {
    code: '2075',
    name: 'CSM Antwerpen X',
  },
  {
    code: '2099',
    name: 'Antwerpen X',
  },
  {
    code: '2100',
    name: 'Deurne',
  },
  {
    code: '2110',
    name: 'Wijnegem',
  },
  {
    code: '2140',
    name: 'Borgerhout',
  },
  {
    code: '2150',
    name: 'Antwerpen',
  },
  {
    code: '2160',
    name: 'Wommelgem',
  },
  {
    code: '2170',
    name: 'Merksem',
  },
  {
    code: '2180',
    name: 'Ekeren',
  },
  {
    code: '2200',
    name: 'Herentals',
  },
  {
    code: '2200',
    name: 'Morkhoven',
  },
  {
    code: '2200',
    name: 'Noorderwijk',
  },
  {
    code: '2220',
    name: 'Hallaar',
  },
  {
    code: '2220',
    name: 'Heist-Op-Den-Berg',
  },
  {
    code: '2221',
    name: 'Booischot',
  },
  {
    code: '2222',
    name: 'Itegem',
  },
  {
    code: '2222',
    name: 'Wiekevorst',
  },
  {
    code: '2223',
    name: 'Schriek',
  },
  {
    code: '2230',
    name: 'Herselt',
  },
  {
    code: '2230',
    name: 'Ramsel',
  },
  {
    code: '2235',
    name: 'Houtvenne',
  },
  {
    code: '2235',
    name: 'Hulshout',
  },
  {
    code: '2235',
    name: 'Westmeerbeek',
  },
  {
    code: '2240',
    name: 'Massenhoven',
  },
  {
    code: '2240',
    name: 'Viersel',
  },
  {
    code: '2240',
    name: 'Zandhoven',
  },
  {
    code: '2242',
    name: 'Pulderbos',
  },
  {
    code: '2243',
    name: 'Pulle',
  },
  {
    code: '2250',
    name: 'Olen',
  },
  {
    code: '2260',
    name: 'Oevel',
  },
  {
    code: '2260',
    name: 'Tongerlo',
  },
  {
    code: '2260',
    name: 'Westerlo',
  },
  {
    code: '2260',
    name: 'Zoerle-Parwijs',
  },
  {
    code: '2270',
    name: 'Herenthout',
  },
  {
    code: '2275',
    name: 'Gierle',
  },
  {
    code: '2275',
    name: 'Lille',
  },
  {
    code: '2275',
    name: 'Poederlee',
  },
  {
    code: '2275',
    name: 'Wechelderzande',
  },
  {
    code: '2280',
    name: 'Grobbendonk',
  },
  {
    code: '2288',
    name: 'Bouwel',
  },
  {
    code: '2290',
    name: 'Vorselaar',
  },
  {
    code: '2300',
    name: 'Turnhout',
  },
  {
    code: '2310',
    name: 'Rijkevorsel',
  },
  {
    code: '2320',
    name: 'Hoogstraten',
  },
  {
    code: '2321',
    name: 'Meer',
  },
  {
    code: '2322',
    name: 'Minderhout',
  },
  {
    code: '2323',
    name: 'Wortel',
  },
  {
    code: '2328',
    name: 'Meerle',
  },
  {
    code: '2330',
    name: 'Merksplas',
  },
  {
    code: '2340',
    name: 'Beerse',
  },
  {
    code: '2340',
    name: 'Vlimmeren',
  },
  {
    code: '2350',
    name: 'Vosselaar',
  },
  {
    code: '2360',
    name: 'Oud-Turnhout',

    nameFR: 'Vieux-Turnhout',
  },
  {
    code: '2370',
    name: 'Arendonk',
  },
  {
    code: '2380',
    name: 'Ravels',
  },
  {
    code: '2381',
    name: 'Weelde',
  },
  {
    code: '2382',
    name: 'Poppel',
  },
  {
    code: '2387',
    name: 'Baarle-Hertog',
    nameNL: 'Baarle-Hertog',
    nameFR: 'Baerle-Duc',
  },
  {
    code: '2390',
    name: 'Malle',
  },
  {
    code: '2390',
    name: 'Oostmalle',
  },
  {
    code: '2390',
    name: 'Westmalle',
  },
  {
    code: '2400',
    name: 'Mol',
  },
  {
    code: '2430',
    name: 'Eindhout',
  },
  {
    code: '2430',
    name: 'Laakdal',
  },
  {
    code: '2430',
    name: 'Vorst',
  },
  {
    code: '2431',
    name: 'Varendonk',
  },
  {
    code: '2431',
    name: 'Veerle',
  },
  {
    code: '2440',
    name: 'Geel',
  },
  {
    code: '2450',
    name: 'Meerhout',
  },
  {
    code: '2460',
    name: 'Kasterlee',
  },
  {
    code: '2460',
    name: 'Lichtaart',
  },
  {
    code: '2460',
    name: 'Tielen',
  },
  {
    code: '2470',
    name: 'Retie',
    nameNL: 'Retie',
    nameFR: 'Rethy',
  },
  {
    code: '2480',
    name: 'Dessel',
  },
  {
    code: '2490',
    name: 'Balen',
  },
  {
    code: '2491',
    name: 'Olmen',
  },
  {
    code: '2500',
    name: 'Koningshooikt',
  },
  {
    code: '2500',
    name: 'Lier',
    nameNL: 'Lier',
    nameFR: 'Lierre',
  },
  {
    code: '2520',
    name: 'Broechem',
  },
  {
    code: '2520',
    name: 'Emblem',
    nameNL: 'Emblem',
    nameFR: 'Emblehem',
  },
  {
    code: '2520',
    name: 'Oelegem',
  },
  {
    code: '2520',
    name: 'Ranst',
  },
  {
    code: '2530',
    name: 'Boechout',
  },
  {
    code: '2531',
    name: 'Vremde',
  },
  {
    code: '2540',
    name: 'Hove',
  },
  {
    code: '2547',
    name: 'Lint',
  },
  {
    code: '2550',
    name: 'Kontich',
  },
  {
    code: '2550',
    name: 'Waarloos',
  },
  {
    code: '2560',
    name: 'Bevel',
  },
  {
    code: '2560',
    name: 'Kessel',
  },
  {
    code: '2560',
    name: 'Nijlen',
  },
  {
    code: '2570',
    name: 'Duffel',
  },
  {
    code: '2580',
    name: 'Beerzel',
  },
  {
    code: '2580',
    name: 'Putte',
  },
  {
    code: '2590',
    name: 'Berlaar',
  },
  {
    code: '2590',
    name: 'Gestel',
  },
  {
    code: '2600',
    name: 'Berchem',
  },
  {
    code: '2610',
    name: 'Wilrijk',
  },
  {
    code: '2620',
    name: 'Hemiksem',
  },
  {
    code: '2627',
    name: 'Schelle',
  },
  {
    code: '2630',
    name: 'Aartselaar',
  },
  {
    code: '2640',
    name: 'Mortsel',
  },
  {
    code: '2650',
    name: 'Edegem',
  },
  {
    code: '2660',
    name: 'Hoboken',
  },
  {
    code: '2800',
    name: 'Mechelen',
    nameNL: 'Mechelen',
    nameFR: 'Malines',
  },
  {
    code: '2800',
    name: 'Walem',
  },
  {
    code: '2801',
    name: 'Heffen',
  },
  {
    code: '2811',
    name: 'Hombeek',
  },
  {
    code: '2811',
    name: 'Leest',
  },
  {
    code: '2812',
    name: 'Muizen',
  },
  {
    code: '2820',
    name: 'Bonheiden',
  },
  {
    code: '2820',
    name: 'Rijmenam',
  },
  {
    code: '2830',
    name: 'Blaasveld',
  },
  {
    code: '2830',
    name: 'Heindonk',
  },
  {
    code: '2830',
    name: 'Tisselt',
  },
  {
    code: '2830',
    name: 'Willebroek',
  },
  {
    code: '2840',
    name: 'Reet',
  },
  {
    code: '2840',
    name: 'Rumst',
  },
  {
    code: '2840',
    name: 'Terhagen',
  },
  {
    code: '2845',
    name: 'Niel',
  },
  {
    code: '2850',
    name: 'Boom',
  },
  {
    code: '2860',
    name: 'Sint-Katelijne-Waver',
    nameFR: 'Wavre-Sainte-Catherine',
  },
  {
    code: '2861',
    name: 'Onze-Lieve-Vrouw-Waver',

    nameFR: 'Wavre-Notre-Dame',
  },
  {
    code: '2870',
    name: 'Breendonk',
  },
  {
    code: '2870',
    name: 'Liezele',
  },
  {
    code: '2870',
    name: 'Puurs-Sint-Amands',
  },
  {
    code: '2870',
    name: 'Ruisbroek',
  },
  {
    code: '2880',
    name: 'Bornem',
  },
  {
    code: '2880',
    name: 'Hingene',
  },
  {
    code: '2880',
    name: 'Mariekerke',
  },
  {
    code: '2880',
    name: 'Weert',
  },
  {
    code: '2890',
    name: 'Lippelo',
  },
  {
    code: '2890',
    name: 'Oppuurs',
  },
  {
    code: '2890',
    name: 'Sint-Amands',
    nameNL: 'Puurs-Sint-Amands',
    nameFR: 'Puurs-Saint-Amand',
  },
  {
    code: '2900',
    name: 'Schoten',
  },
  {
    code: '2910',
    name: 'Essen',
  },
  {
    code: '2920',
    name: 'Kalmthout',
  },
  {
    code: '2930',
    name: 'Brasschaat',
  },
  {
    code: '2940',
    name: 'Hoevenen',
  },
  {
    code: '2940',
    name: 'Stabroek',
  },
  {
    code: '2950',
    name: 'Kapellen',
  },
  {
    code: '2960',
    name: 'Brecht',
  },
  {
    code: '2960',
    name: "Sint-Job-In-'T-Goor",
  },
  {
    code: '2960',
    name: 'Sint-Lenaarts',
    nameNL: 'Sint-Lenaarts',
    nameFR: 'Saint-Léonard',
  },
  {
    code: '2970',
    name: "'s-Gravenwezel",
  },
  {
    code: '2970',
    name: 'Schilde',
  },
  {
    code: '2980',
    name: 'Halle',
  },
  {
    code: '2980',
    name: 'Zoersel',
  },
  {
    code: '2990',
    name: 'Loenhout',
  },
  {
    code: '2990',
    name: 'Wuustwezel',
  },
  {
    code: '3000',
    name: 'Leuven',
    nameNL: 'Leuven',
    nameFR: 'Louvain',
  },
  {
    code: '3001',
    name: 'Heverlee',
  },
  {
    code: '3010',
    name: 'Kessel-Lo',
  },
  {
    code: '3012',
    name: 'Wilsele',
  },
  {
    code: '3018',
    name: 'Wijgmaal',
  },
  {
    code: '3020',
    name: 'Herent',
  },
  {
    code: '3020',
    name: 'Veltem-Beisem',
  },
  {
    code: '3020',
    name: 'Winksele',
  },
  {
    code: '3040',
    name: 'Huldenberg',
  },
  {
    code: '3040',
    name: 'Loonbeek',
  },
  {
    code: '3040',
    name: 'Neerijse',
  },
  {
    code: '3040',
    name: 'Ottenburg',
    nameNL: 'Ottenburg',
    nameFR: 'Ottenbourg',
  },
  {
    code: '3040',
    name: 'Sint-Agatha-Rode',
    nameNL: 'Sint-Agatha-Rode',
    nameFR: 'Rhode-Sainte-Agathe',
  },
  {
    code: '3050',
    name: 'Oud-Heverlee',
  },
  {
    code: '3051',
    name: 'Sint-Joris-Weert',
    nameNL: 'Sint-Joris-Weert',
    nameFR: 'Weert-Saint-Georges',
  },
  {
    code: '3052',
    name: 'Blanden',
  },
  {
    code: '3053',
    name: 'Haasrode',
  },
  {
    code: '3054',
    name: 'Vaalbeek',
  },
  {
    code: '3060',
    name: 'Bertem',
  },
  {
    code: '3060',
    name: 'Korbeek-Dijle',
  },
  {
    code: '3061',
    name: 'Leefdaal',
  },
  {
    code: '3070',
    name: 'Kortenberg',
  },
  {
    code: '3071',
    name: 'Erps-Kwerps',
  },
  {
    code: '3078',
    name: 'Everberg',
  },
  {
    code: '3078',
    name: 'Meerbeek',
  },
  {
    code: '3080',
    name: 'Duisburg',
  },
  {
    code: '3080',
    name: 'Tervuren',
  },
  {
    code: '3080',
    name: 'Vossem',
  },
  {
    code: '3090',
    name: 'Overijse',
  },
  {
    code: '3110',
    name: 'Rotselaar',
  },
  {
    code: '3111',
    name: 'Wezemaal',
  },
  {
    code: '3118',
    name: 'Werchter',
  },
  {
    code: '3120',
    name: 'Tremelo',
  },
  {
    code: '3128',
    name: 'Baal',
  },
  {
    code: '3130',
    name: 'Begijnendijk',
  },
  {
    code: '3130',
    name: 'Betekom',
  },
  {
    code: '3140',
    name: 'Keerbergen',
  },
  {
    code: '3150',
    name: 'Haacht',
  },
  {
    code: '3150',
    name: 'Tildonk',
  },
  {
    code: '3150',
    name: 'Wespelaar',
  },
  {
    code: '3190',
    name: 'Boortmeerbeek',
  },
  {
    code: '3191',
    name: 'Hever',
  },
  {
    code: '3200',
    name: 'Aarschot',
  },
  {
    code: '3200',
    name: 'Gelrode',
    nameNL: 'Gelrode',
    nameFR: 'Gelderode',
  },
  {
    code: '3201',
    name: 'Langdorp',
  },
  {
    code: '3202',
    name: 'Rillaar',
  },
  {
    code: '3210',
    name: 'Linden',
  },
  {
    code: '3210',
    name: 'Lubbeek',
  },
  {
    code: '3211',
    name: 'Binkom',
  },
  {
    code: '3212',
    name: 'Pellenberg',
  },
  {
    code: '3220',
    name: 'Holsbeek',
  },
  {
    code: '3220',
    name: 'Kortrijk-Dutsel',
    nameNL: 'Kortrijk-Dutsel',
    nameFR: 'Courtrai-Dutsel',
  },
  {
    code: '3220',
    name: 'Sint-Pieters-Rode',
    nameNL: 'Sint-Pieters-Rode',
    nameFR: 'Rhode-Saint-Pierre',
  },
  {
    code: '3221',
    name: 'Nieuwrode',
  },
  {
    code: '3270',
    name: 'Scherpenheuvel',
    nameNL: 'Scherpenheuvel',
    nameFR: 'Montaigu',
  },
  {
    code: '3270',
    name: 'Scherpenheuvel-Zichem',
  },
  {
    code: '3271',
    name: 'Averbode',
  },
  {
    code: '3271',
    name: 'Zichem',
  },
  {
    code: '3272',
    name: 'Messelbroek',
  },
  {
    code: '3272',
    name: 'Testelt',
  },
  {
    code: '3290',
    name: 'Deurne',
  },
  {
    code: '3290',
    name: 'Diest',
  },
  {
    code: '3290',
    name: 'Schaffen',
  },
  {
    code: '3290',
    name: 'Webbekom',
  },
  {
    code: '3293',
    name: 'Kaggevinne',
  },
  {
    code: '3294',
    name: 'Molenstede',
  },
  {
    code: '3300',
    name: 'Bost',
  },
  {
    code: '3300',
    name: 'Goetsenhoven',
    nameNL: 'Goetsenhoven',
    nameFR: 'Gossoncourt',
  },
  {
    code: '3300',
    name: 'Hakendover',
  },
  {
    code: '3300',
    name: 'Kumtich',
  },
  {
    code: '3300',
    name: 'Oorbeek',
    nameNL: 'Oorbeek',
    nameFR: 'Oirbeek',
  },
  {
    code: '3300',
    name: 'Oplinter',
  },
  {
    code: '3300',
    name: 'Sint-Margriete-Houtem',
    nameNL: 'Sint-Margriete-Houtem',
    nameFR: 'Hautem-Sainte-Marguerite',
  },
  {
    code: '3300',
    name: 'Tienen',
    nameNL: 'Tienen',
    nameFR: 'Tirlemont',
  },
  {
    code: '3300',
    name: 'Vissenaken',
  },
  {
    code: '3320',
    name: 'Hoegaarden',
  },
  {
    code: '3320',
    name: 'Meldert',
  },
  {
    code: '3321',
    name: 'Outgaarden',
    nameNL: 'Outgaarden',
    nameFR: 'Autgaerden',
  },
  {
    code: '3350',
    name: 'Drieslinter',
  },
  {
    code: '3350',
    name: 'Linter',
  },
  {
    code: '3350',
    name: 'Melkwezer',
  },
  {
    code: '3350',
    name: 'Neerhespen',
  },
  {
    code: '3350',
    name: 'Neerlinter',
  },
  {
    code: '3350',
    name: 'Orsmaal-Gussenhoven',
  },
  {
    code: '3350',
    name: 'Overhespen',
  },
  {
    code: '3350',
    name: 'Wommersom',
  },
  {
    code: '3360',
    name: 'Bierbeek',
  },
  {
    code: '3360',
    name: 'Korbeek-Lo',
  },
  {
    code: '3360',
    name: 'Lovenjoel',
  },
  {
    code: '3360',
    name: 'Opvelp',
  },
  {
    code: '3370',
    name: 'Boutersem',
  },
  {
    code: '3370',
    name: 'Kerkom',
  },
  {
    code: '3370',
    name: 'Neervelp',
  },
  {
    code: '3370',
    name: 'Roosbeek',
  },
  {
    code: '3370',
    name: 'Vertrijk',
  },
  {
    code: '3370',
    name: 'Willebringen',
  },
  {
    code: '3380',
    name: 'Bunsbeek',
  },
  {
    code: '3380',
    name: 'Glabbeek',
  },
  {
    code: '3381',
    name: 'Kapellen',
  },
  {
    code: '3384',
    name: 'Attenrode',
  },
  {
    code: '3390',
    name: 'Houwaart',
  },
  {
    code: '3390',
    name: 'Sint-Joris-Winge',
    nameNL: 'Sint-Joris-Winge',
    nameFR: 'Winghe-Saint-Georges',
  },
  {
    code: '3390',
    name: 'Tielt',
  },
  {
    code: '3390',
    name: 'Tielt-Winge',
  },
  {
    code: '3391',
    name: 'Meensel-Kiezegem',
  },
  {
    code: '3400',
    name: 'Eliksem',
  },
  {
    code: '3400',
    name: 'Ezemaal',
  },
  {
    code: '3400',
    name: 'Laar',
  },
  {
    code: '3400',
    name: 'Landen',
  },
  {
    code: '3400',
    name: 'Neerwinden',
  },
  {
    code: '3400',
    name: 'Overwinden',
  },
  {
    code: '3400',
    name: 'Rumsdorp',
  },
  {
    code: '3400',
    name: 'Wange',
  },
  {
    code: '3401',
    name: 'Waasmont',
    nameNL: 'Waasmont',
    nameFR: 'Wamont',
  },
  {
    code: '3401',
    name: 'Walsbets',
  },
  {
    code: '3401',
    name: 'Walshoutem',
    nameNL: 'Walshoutem',
    nameFR: "Hautain-l'Evêque",
  },
  {
    code: '3401',
    name: 'Wezeren',
  },
  {
    code: '3404',
    name: 'Attenhoven',
  },
  {
    code: '3404',
    name: 'Neerlanden',
  },
  {
    code: '3440',
    name: 'Budingen',
  },
  {
    code: '3440',
    name: 'Dormaal',
  },
  {
    code: '3440',
    name: 'Halle-Booienhoven',
  },
  {
    code: '3440',
    name: 'Helen-Bos',
  },
  {
    code: '3440',
    name: 'Zoutleeuw',
    nameNL: 'Zoutleeuw',
    nameFR: 'Léau',
  },
  {
    code: '3450',
    name: 'Geetbets',
  },
  {
    code: '3450',
    name: 'Grazen',
    nameNL: 'Grazen',
    nameFR: 'Graesen',
  },
  {
    code: '3454',
    name: 'Rummen',
  },
  {
    code: '3460',
    name: 'Assent',
  },
  {
    code: '3460',
    name: 'Bekkevoort',
  },
  {
    code: '3461',
    name: 'Molenbeek-Wersbeek',
  },
  {
    code: '3470',
    name: 'Kortenaken',
  },
  {
    code: '3470',
    name: 'Ransberg',
  },
  {
    code: '3470',
    name: 'Sint-Margriete-Houtem',
    nameNL: 'Sint-Margriete-Houtem',
    nameFR: 'Hautem-Sainte-Marguerite',
  },
  {
    code: '3471',
    name: 'Hoeleden',
  },
  {
    code: '3472',
    name: 'Kersbeek-Miskom',
  },
  {
    code: '3473',
    name: 'Waanrode',
  },
  {
    code: '3500',
    name: 'Hasselt',
  },
  {
    code: '3500',
    name: 'Sint-Lambrechts-Herk',
    nameNL: 'Sint-Lambrechts-Herk',
    nameFR: 'Herck-Saint-Lambert',
  },
  {
    code: '3501',
    name: 'Wimmertingen',
  },
  {
    code: '3510',
    name: 'Kermt',
  },
  {
    code: '3510',
    name: 'Spalbeek',
  },
  {
    code: '3511',
    name: 'Kuringen',
    nameNL: 'Kuringen',
    nameFR: 'Curange',
  },
  {
    code: '3511',
    name: 'Stokrooie',
  },
  {
    code: '3512',
    name: 'Stevoort',
  },
  {
    code: '3520',
    name: 'Zonhoven',
  },
  {
    code: '3530',
    name: 'Helchteren',
  },
  {
    code: '3530',
    name: 'Houthalen',
  },
  {
    code: '3530',
    name: 'Houthalen-Helchteren',
  },
  {
    code: '3540',
    name: 'Berbroek',
  },
  {
    code: '3540',
    name: 'Donk',
  },
  {
    code: '3540',
    name: 'Herk-de-Stad',
    nameNL: 'Herk-de-Stad',
    nameFR: 'Herck-la-Ville',
  },
  {
    code: '3540',
    name: 'Schulen',
  },
  {
    code: '3545',
    name: 'Halen',
  },
  {
    code: '3545',
    name: 'Loksbergen',
  },
  {
    code: '3545',
    name: 'Zelem',
    nameNL: 'Zelem',
    nameFR: 'Zeelhem',
  },
  {
    code: '3550',
    name: 'Heusden',
  },
  {
    code: '3550',
    name: 'Heusden-Zolder',
  },
  {
    code: '3550',
    name: 'Zolder',
  },
  {
    code: '3560',
    name: 'Linkhout',
  },
  {
    code: '3560',
    name: 'Lummen',
  },
  {
    code: '3560',
    name: 'Meldert',
  },
  {
    code: '3570',
    name: 'Alken',
  },
  {
    code: '3580',
    name: 'Beringen',
  },
  {
    code: '3581',
    name: 'Beverlo',
  },
  {
    code: '3582',
    name: 'Koersel',
    nameNL: 'Koersel',
    nameFR: 'Coursel',
  },
  {
    code: '3583',
    name: 'Paal',
  },
  {
    code: '3590',
    name: 'Diepenbeek',
  },
  {
    code: '3600',
    name: 'Genk',
  },
  {
    code: '3620',
    name: 'Gellik',
  },
  {
    code: '3620',
    name: 'Lanaken',
  },
  {
    code: '3620',
    name: 'Neerharen',
  },
  {
    code: '3620',
    name: 'Veldwezelt',
  },
  {
    code: '3621',
    name: 'Rekem',
    nameNL: 'Rekem',
    nameFR: 'Reckheim',
  },
  {
    code: '3630',
    name: 'Eisden',
  },
  {
    code: '3630',
    name: 'Leut',
    nameNL: 'Leut',
    nameFR: 'Leuth',
  },
  {
    code: '3630',
    name: 'Maasmechelen',
  },
  {
    code: '3630',
    name: 'Mechelen-Aan-De-Maas',
    nameNL: 'Mechelen-aan-de-Maas',
    nameFR: 'Malines-sur-Meuse',
  },
  {
    code: '3630',
    name: 'Meeswijk',
  },
  {
    code: '3630',
    name: 'Opgrimbie',
  },
  {
    code: '3630',
    name: 'Vucht',
  },
  {
    code: '3631',
    name: 'Boorsem',
    nameNL: 'Boorsem',
    nameFR: 'Boorsheim',
  },
  {
    code: '3631',
    name: 'Uikhoven',
  },
  {
    code: '3640',
    name: 'Kessenich',
  },
  {
    code: '3640',
    name: 'Kinrooi',
  },
  {
    code: '3640',
    name: 'Molenbeersel',
  },
  {
    code: '3640',
    name: 'Ophoven',
  },
  {
    code: '3650',
    name: 'Dilsen',
  },
  {
    code: '3650',
    name: 'Dilsen-Stokkem',
  },
  {
    code: '3650',
    name: 'Elen',
  },
  {
    code: '3650',
    name: 'Lanklaar',
  },
  {
    code: '3650',
    name: 'Rotem',
  },
  {
    code: '3650',
    name: 'Stokkem',
  },
  {
    code: '3660',
    name: 'Oudsbergen',
  },
  {
    code: '3665',
    name: 'As',
  },
  {
    code: '3668',
    name: 'Niel-Bij-As',
  },
  {
    code: '3670',
    name: 'Ellikom',
  },
  {
    code: '3670',
    name: 'Gruitrode',
  },
  {
    code: '3670',
    name: 'Meeuwen',
  },
  {
    code: '3670',
    name: 'Oudsbergen',
  },
  {
    code: '3670',
    name: 'Neerglabbeek',
  },
  {
    code: '3670',
    name: 'Wijshagen',
  },
  {
    code: '3680',
    name: 'Maaseik',
  },
  {
    code: '3680',
    name: 'Neeroeteren',
  },
  {
    code: '3680',
    name: 'Opoeteren',
  },
  {
    code: '3690',
    name: 'Zutendaal',
  },
  {
    code: '3700',
    name: "'S Herenelderen",
  },
  {
    code: '3700',
    name: 'Berg',
  },
  {
    code: '3700',
    name: 'Diets-Heur',
    nameNL: 'Diets-Heur',
    nameFR: 'Heur-le-Tiexhe',
  },
  {
    code: '3700',
    name: 'Haren',
  },
  {
    code: '3700',
    name: 'Henis',
  },
  {
    code: '3700',
    name: 'Kolmont',
  },
  {
    code: '3700',
    name: 'Koninksem',
    nameNL: 'Koninksem',
    nameFR: 'Conincxheim',
  },
  {
    code: '3700',
    name: 'Lauw',
    nameNL: 'Lauw',
    nameFR: 'Lowaige',
  },
  {
    code: '3700',
    name: 'Mal',
  },
  {
    code: '3700',
    name: 'Neerrepen',
  },
  {
    code: '3700',
    name: 'Nerem',
    nameNL: 'Nerem',
    nameFR: 'Nederheim',
  },
  {
    code: '3700',
    name: 'Overrepen',
  },
  {
    code: '3700',
    name: 'Piringen',
    nameNL: 'Piringen',
    nameFR: 'Pirange',
  },
  {
    code: '3700',
    name: 'Riksingen',
  },
  {
    code: '3700',
    name: 'Rutten',
    nameNL: 'Rutten',
    nameFR: 'Russon',
  },
  {
    code: '3700',
    name: 'Sluizen',
    nameNL: 'Sluizen',
    nameFR: 'Sluse',
  },
  {
    code: '3700',
    name: 'Tongeren-Borgloon',
    nameNL: 'Tongeren-Borgloon',
    nameFR: 'Tongres-Looz',
  },
  {
    code: '3700',
    name: 'Vreren',
    nameNL: 'Vreren',
    nameFR: 'Freeren',
  },
  {
    code: '3700',
    name: 'Widooie',
    nameNL: 'Widooie',
    nameFR: 'Widoye',
  },
  {
    code: '3717',
    name: 'Herstappe',
  },
  {
    code: '3720',
    name: 'Hasselt',
  },
  {
    code: '3721',
    name: 'Vliermaalroot',
  },
  {
    code: '3722',
    name: 'Wintershoven',
  },
  {
    code: '3723',
    name: 'Guigoven',
  },
  {
    code: '3724',
    name: 'Vliermaal',
  },
  {
    code: '3730',
    name: 'Bilzen-Hoeselt',
  },
  {
    code: '3730',
    name: 'Romershoven',
  },
  {
    code: '3730',
    name: 'Sint-Huibrechts-Hern',
  },
  {
    code: '3730',
    name: 'Werm',
  },
  {
    code: '3732',
    name: 'Schalkhoven',
  },
  {
    code: '3740',
    name: 'Beverst',
  },
  {
    code: '3740',
    name: 'Bilzen-Hoeselt',
  },
  {
    code: '3740',
    name: 'Eigenbilzen',
  },
  {
    code: '3740',
    name: 'Grote-Spouwen',
    nameNL: 'Grote-Spouwen',
    nameFR: 'Grand-Spauwen',
  },
  {
    code: '3740',
    name: 'Hees',
  },
  {
    code: '3740',
    name: 'Kleine-Spouwen',
    nameNL: 'Kleine-Spouwen',
    nameFR: 'Petit-Spauwen',
  },
  {
    code: '3740',
    name: 'Mopertingen',
  },
  {
    code: '3740',
    name: 'Munsterbilzen',
  },
  {
    code: '3740',
    name: 'Rijkhoven',
  },
  {
    code: '3740',
    name: 'Rosmeer',
  },
  {
    code: '3740',
    name: 'Waltwilder',
  },
  {
    code: '3742',
    name: 'Martenslinde',
  },
  {
    code: '3746',
    name: 'Hoelbeek',
  },
  {
    code: '3770',
    name: 'Genoelselderen',
  },
  {
    code: '3770',
    name: 'Herderen',
  },
  {
    code: '3770',
    name: 'Kanne',
  },
  {
    code: '3770',
    name: 'Membruggen',
  },
  {
    code: '3770',
    name: 'Millen',
  },
  {
    code: '3770',
    name: 'Riemst',
  },
  {
    code: '3770',
    name: 'Val-Meer',
    nameNL: 'Val-Meer',
    nameFR: 'Falle-et-Mheer',
  },
  {
    code: '3770',
    name: 'Vlijtingen',
  },
  {
    code: '3770',
    name: 'Vroenhoven',
  },
  {
    code: '3770',
    name: 'Zichen-Zussen-Bolder',
  },
  {
    code: '3790',
    name: 'Moelingen',
    nameNL: 'Moelingen',
    nameFR: 'Mouland',
  },
  {
    code: '3790',
    name: 'Sint-Martens-Voeren',
    nameNL: 'Sint-Martens-Voeren',
    nameFR: 'Fouron-Saint-Martin',
  },
  {
    code: '3790',
    name: 'Voeren',
    nameNL: 'Voeren',
    nameFR: 'Fourons',
  },
  {
    code: '3791',
    name: 'Remersdaal',
  },
  {
    code: '3792',
    name: 'Sint-Pieters-Voeren',
    nameNL: 'Sint-Pieters-Voeren',
    nameFR: 'Fouron-Saint-Pierre',
  },
  {
    code: '3793',
    name: 'Teuven',
  },
  {
    code: '3798',
    name: 'S Gravenvoeren',
  },
  {
    code: '3800',
    name: 'Aalst',

    nameFR: 'Alost',
  },
  {
    code: '3800',
    name: 'Brustem',
  },
  {
    code: '3800',
    name: 'Engelmanshoven',
  },
  {
    code: '3800',
    name: 'Gelinden',
  },
  {
    code: '3800',
    name: 'Groot-Gelmen',
    nameNL: 'Groot-Gelmen',
    nameFR: 'Grand-Jamine',
  },
  {
    code: '3800',
    name: 'Halmaal',
  },
  {
    code: '3800',
    name: 'Kerkom-Bij-Sint-Truiden',
  },
  {
    code: '3800',
    name: 'Ordingen',
    nameNL: 'Ordingen',
    nameFR: 'Ordange',
  },
  {
    code: '3800',
    name: 'Sint-Truiden',
    nameNL: 'Sint-Truiden',
    nameFR: 'Sint-Trond',
  },
  {
    code: '3800',
    name: 'Zepperen',
  },
  {
    code: '3803',
    name: 'Duras',
  },
  {
    code: '3803',
    name: 'Gorsem',
    nameNL: 'Gorsem',
    nameFR: 'Gorssum',
  },
  {
    code: '3803',
    name: 'Runkelen',
  },
  {
    code: '3803',
    name: 'Wilderen',
  },
  {
    code: '3806',
    name: 'Velm',
  },
  {
    code: '3830',
    name: 'Berlingen',
  },
  {
    code: '3830',
    name: 'Wellen',
  },
  {
    code: '3831',
    name: 'Herten',
  },
  {
    code: '3832',
    name: 'Ulbeek',
  },
  {
    code: '3840',
    name: 'Bommershoven',
  },
  {
    code: '3840',
    name: 'Tongeren-Borgloon',
    nameNL: 'Tongeren-Borgloon',
    nameFR: 'Tongres-Looz',
  },
  {
    code: '3840',
    name: 'Broekom',
  },
  {
    code: '3840',
    name: 'Gors-Opleeuw',
  },
  {
    code: '3840',
    name: 'Gotem',
  },
  {
    code: '3840',
    name: 'Groot-Loon',
    nameNL: 'Groot-Loon',
    nameFR: 'Grand-Looz',
  },
  {
    code: '3840',
    name: 'Haren',
  },
  {
    code: '3840',
    name: 'Hendrieken',
  },
  {
    code: '3840',
    name: 'Hoepertingen',
  },
  {
    code: '3840',
    name: 'Jesseren',
  },
  {
    code: '3840',
    name: 'Kerniel',
  },
  {
    code: '3840',
    name: 'Kolmont',
  },
  {
    code: '3840',
    name: 'Kuttekoven',
  },
  {
    code: '3840',
    name: 'Rijkel',
  },
  {
    code: '3840',
    name: 'Voort',
  },
  {
    code: '3850',
    name: 'Binderveld',
  },
  {
    code: '3850',
    name: 'Kozen',
    nameNL: 'Kozen',
    nameFR: 'Cosen',
  },
  {
    code: '3850',
    name: 'Nieuwerkerken',
  },
  {
    code: '3850',
    name: 'Wijer',
    nameNL: 'Wijer',
    nameFR: 'Weyer',
  },
  {
    code: '3870',
    name: 'Batsheers',
    nameNL: 'Batsheers',
    nameFR: 'Bas-Heers',
  },
  {
    code: '3870',
    name: 'Bovelingen',
  },
  {
    code: '3870',
    name: 'Gutshoven',
  },
  {
    code: '3870',
    name: 'Heers',
  },
  {
    code: '3870',
    name: 'Heks',
    nameNL: 'Heks',
    nameFR: 'Hex',
  },
  {
    code: '3870',
    name: 'Horpmaal',
  },
  {
    code: '3870',
    name: 'Klein-Gelmen',
    nameNL: 'Klein-Gelmen',
    nameFR: 'Petit(e)-Jamine',
  },
  {
    code: '3870',
    name: 'Mechelen-Bovelingen',
    nameNL: 'Mechelen-Bovelingen',
    nameFR: 'Marlinne',
  },
  {
    code: '3870',
    name: 'Mettekoven',
  },
  {
    code: '3870',
    name: 'Opheers',
  },
  {
    code: '3870',
    name: 'Rukkelingen-Loon',
    nameNL: 'Rukkelingen-Loon',
    nameFR: 'Roclenge-Looz',
  },
  {
    code: '3870',
    name: 'Vechmaal',
  },
  {
    code: '3870',
    name: 'Veulen',
    nameNL: 'Veulen',
    nameFR: 'Fologne',
  },
  {
    code: '3890',
    name: 'Boekhout',
  },
  {
    code: '3890',
    name: 'Gingelom',
  },
  {
    code: '3890',
    name: 'Jeuk',
    nameNL: 'Jeuk',
    nameFR: 'Goyer',
  },
  {
    code: '3890',
    name: 'Kortijs',
  },
  {
    code: '3890',
    name: 'Montenaken',
  },
  {
    code: '3890',
    name: 'Niel-Bij-Sint-Truiden',
  },
  {
    code: '3890',
    name: 'Vorsen',
    nameNL: 'Vorsen',
    nameFR: 'Frésin',
  },
  {
    code: '3891',
    name: 'Borlo',
  },
  {
    code: '3891',
    name: 'Buvingen',
  },
  {
    code: '3891',
    name: 'Mielen-Boven-Aalst',
  },
  {
    code: '3891',
    name: 'Muizen',
  },
  {
    code: '3900',
    name: 'Pelt',
  },
  {
    code: '3910',
    name: 'Pelt',
  },
  {
    code: '3910',
    name: 'Sint-Huibrechts-Lille',
  },
  {
    code: '3920',
    name: 'Lommel',
  },
  {
    code: '3930',
    name: 'Achel',
  },
  {
    code: '3930',
    name: 'Hamont',
  },
  {
    code: '3930',
    name: 'Hamont-Achel',
  },
  {
    code: '3940',
    name: 'Hechtel',
  },
  {
    code: '3940',
    name: 'Hechtel-Eksel',
  },
  {
    code: '3941',
    name: 'Eksel',
  },
  {
    code: '3945',
    name: 'Tessenderlo-Ham',
  },
  {
    code: '3945',
    name: 'Kwaadmechelen',
    nameNL: 'Kwaadmechelen',
    nameFR: 'Quaedmechelen',
  },
  {
    code: '3945',
    name: 'Oostham',
  },
  {
    code: '3950',
    name: 'Bocholt',
  },
  {
    code: '3950',
    name: 'Kaulille',
    nameNL: 'Kaulille',
    nameFR: 'Caulille',
  },
  {
    code: '3950',
    name: 'Reppel',
  },
  {
    code: '3960',
    name: 'Beek',
  },
  {
    code: '3960',
    name: 'Bree',
  },
  {
    code: '3960',
    name: 'Gerdingen',
  },
  {
    code: '3960',
    name: 'Opitter',
  },
  {
    code: '3960',
    name: 'Tongerlo',
  },
  {
    code: '3970',
    name: 'Leopoldsburg',
    nameNL: 'Leopoldsburg',
    nameFR: 'Bourg-Léopold',
  },
  {
    code: '3971',
    name: 'Heppen',
  },
  {
    code: '3980',
    name: 'Tessenderlo-Ham',
  },
  {
    code: '3990',
    name: 'Grote-Brogel',
  },
  {
    code: '3990',
    name: 'Kleine-Brogel',
    nameNL: 'Kleine-Brogel',
    nameFR: 'Petit-Brogel',
  },
  {
    code: '3990',
    name: 'Peer',
  },
  {
    code: '3990',
    name: 'Wijchmaal',
  },
  {
    code: '4000',
    name: 'Glain',
  },
  {
    code: '4000',
    name: 'Liège',
    nameNL: 'Luik',
    nameFR: 'Liège',
  },
  {
    code: '4000',
    name: 'Rocourt',
  },
  {
    code: '4020',
    name: 'Bressoux',
  },
  {
    code: '4020',
    name: 'Jupille-Sur-Meuse',
  },
  {
    code: '4020',
    name: 'Liège',
  },
  {
    code: '4020',
    name: 'Wandre',
  },
  {
    code: '4030',
    name: 'Grivegnee',
  },
  {
    code: '4031',
    name: 'Angleur',
  },
  {
    code: '4032',
    name: 'Chênee',
  },
  {
    code: '4040',
    name: 'Herstal',
  },
  {
    code: '4041',
    name: 'Milmort',
  },
  {
    code: '4041',
    name: 'Vottem',
  },
  {
    code: '4042',
    name: 'Liers',
  },
  {
    code: '4050',
    name: 'Chaudfontaine',
  },
  {
    code: '4051',
    name: 'Vaux-Sous-Chèvremont',
  },
  {
    code: '4052',
    name: 'Beaufays',
  },
  {
    code: '4053',
    name: 'Embourg',
  },
  {
    code: '4075',
    name: 'CSM Liege X',
  },
  {
    code: '4099',
    name: 'Liège X',
  },
  {
    code: '4100',
    name: 'Boncelles',
  },
  {
    code: '4100',
    name: 'Seraing',
  },
  {
    code: '4101',
    name: 'Jemeppe-Sur-Meuse',
  },
  {
    code: '4102',
    name: 'Ougrée',
  },
  {
    code: '4120',
    name: 'Ehein',
  },
  {
    code: '4120',
    name: 'Neupré',
  },
  {
    code: '4120',
    name: 'Rotheux-Rimière',
  },
  {
    code: '4121',
    name: 'Neuville-En-Condroz',
  },
  {
    code: '4122',
    name: 'Plainevaux',
  },
  {
    code: '4130',
    name: 'Esneux',
  },
  {
    code: '4130',
    name: 'Tilff',
  },
  {
    code: '4140',
    name: 'Dolembreux',
  },
  {
    code: '4140',
    name: 'Gomzé-Andoumont',
  },
  {
    code: '4140',
    name: 'Rouvreux',
  },
  {
    code: '4140',
    name: 'Sprimont',
  },
  {
    code: '4141',
    name: 'Louveigné',
  },
  {
    code: '4160',
    name: 'Anthisnes',
  },
  {
    code: '4161',
    name: 'Villers-Aux-Tours',
  },
  {
    code: '4162',
    name: 'Hody',
  },
  {
    code: '4163',
    name: 'Tavier',
  },
  {
    code: '4170',
    name: 'Comblain-Au-Pont',
  },
  {
    code: '4171',
    name: 'Poulseur',
  },
  {
    code: '4180',
    name: 'Comblain-Fairon',
  },
  {
    code: '4180',
    name: 'Comblain-La-Tour',
  },
  {
    code: '4180',
    name: 'Hamoir',
  },
  {
    code: '4181',
    name: 'Filot',
  },
  {
    code: '4190',
    name: 'Ferrières',
  },
  {
    code: '4190',
    name: 'My',
  },
  {
    code: '4190',
    name: 'Vieuxville',
  },
  {
    code: '4190',
    name: 'Werbomont',
  },
  {
    code: '4190',
    name: 'Xhoris',
  },
  {
    code: '4210',
    name: 'Burdinne',
  },
  {
    code: '4210',
    name: 'Hannêche',
  },
  {
    code: '4210',
    name: 'Lamontzée',
  },
  {
    code: '4210',
    name: 'Marneffe',
  },
  {
    code: '4210',
    name: 'Oteppe',
  },
  {
    code: '4217',
    name: 'Héron',
  },
  {
    code: '4217',
    name: 'Lavoir',
  },
  {
    code: '4217',
    name: "Waret-L'Evêque",
  },
  {
    code: '4218',
    name: 'Couthuin',
  },
  {
    code: '4219',
    name: 'Acosse',
  },
  {
    code: '4219',
    name: 'Ambresin',
    nameNL: 'Embresin',
    nameFR: 'Ambresin',
  },
  {
    code: '4219',
    name: 'Meeffe',
  },
  {
    code: '4219',
    name: 'Wasseiges',
  },
  {
    code: '4250',
    name: 'Boëlhe',
  },
  {
    code: '4250',
    name: 'Geer',
  },
  {
    code: '4250',
    name: 'Hollogne-Sur-Geer',
  },
  {
    code: '4250',
    name: 'Lens-Saint-Servais',
  },
  {
    code: '4252',
    name: 'Omal',
  },
  {
    code: '4253',
    name: 'Darion',
  },
  {
    code: '4254',
    name: 'Ligney',
  },
  {
    code: '4257',
    name: 'Berloz',
  },
  {
    code: '4257',
    name: 'Corswarem',
    nameNL: 'Korsworm',
    nameFR: 'Corswarem',
  },
  {
    code: '4257',
    name: 'Rosoux-Crenwick',
    nameNL: 'Roost-Krenwick',
    nameFR: 'Rosoux-Crenwick',
  },
  {
    code: '4260',
    name: 'Avennes',
  },
  {
    code: '4260',
    name: 'Braives',
  },
  {
    code: '4260',
    name: 'Ciplet',
  },
  {
    code: '4260',
    name: 'Fallais',
  },
  {
    code: '4260',
    name: 'Fumal',
  },
  {
    code: '4260',
    name: 'Ville-En-Hesbaye',
  },
  {
    code: '4261',
    name: 'Latinne',
  },
  {
    code: '4263',
    name: 'Tourinne',
  },
  {
    code: '4280',
    name: 'Abolens',
  },
  {
    code: '4280',
    name: 'Avernas-Le-Bauduin',
  },
  {
    code: '4280',
    name: 'Avin',
  },
  {
    code: '4280',
    name: 'Bertrée',
  },
  {
    code: '4280',
    name: 'Blehen',
  },
  {
    code: '4280',
    name: 'Cras-Avernas',
  },
  {
    code: '4280',
    name: 'Crehen',
  },
  {
    code: '4280',
    name: 'Grand-Hallet',
  },
  {
    code: '4280',
    name: 'Hannut',
    nameNL: 'Hannuit',
    nameFR: 'Hannut',
  },
  {
    code: '4280',
    name: 'Lens-Saint-Remy',
  },
  {
    code: '4280',
    name: 'Merdorp',
  },
  {
    code: '4280',
    name: 'Moxhe',
  },
  {
    code: '4280',
    name: 'Petit-Hallet',
  },
  {
    code: '4280',
    name: 'Poucet',
  },
  {
    code: '4280',
    name: 'Thisnes',
  },
  {
    code: '4280',
    name: 'Trognée',
    nameNL: 'Truielingen',
    nameFR: 'Trognée',
  },
  {
    code: '4280',
    name: 'Villers-Le-Peuplier',
  },
  {
    code: '4280',
    name: 'Wansin',
  },
  {
    code: '4287',
    name: 'Lincent',
    nameNL: 'Lijsem',
    nameFR: 'Lincent',
  },
  {
    code: '4287',
    name: 'Pellaines',
    nameNL: 'Pellen',
    nameFR: 'Pellaines',
  },
  {
    code: '4287',
    name: 'Racour',
    nameNL: 'Raatshoven',
    nameFR: 'Racour',
  },
  {
    code: '4300',
    name: 'Bettincourt',
    nameNL: 'Bettenhoven',
    nameFR: 'Bettincourt',
  },
  {
    code: '4300',
    name: 'Bleret',
  },
  {
    code: '4300',
    name: 'Bovenistier',
  },
  {
    code: '4300',
    name: 'Grand-Axhe',
  },
  {
    code: '4300',
    name: 'Lantremange',
  },
  {
    code: '4300',
    name: 'Oleye',
    nameNL: 'Liek',
    nameFR: 'Oleye',
  },
  {
    code: '4300',
    name: 'Waremme',
    nameNL: 'Borgworm',
    nameFR: 'Waremme',
  },
  {
    code: '4317',
    name: 'Aineffe',
  },
  {
    code: '4317',
    name: 'Borlez',
  },
  {
    code: '4317',
    name: 'Celles',
  },
  {
    code: '4317',
    name: 'Faimes',
  },
  {
    code: '4317',
    name: 'Les Waleffes',
  },
  {
    code: '4317',
    name: 'Viemme',
  },
  {
    code: '4340',
    name: 'Awans',
  },
  {
    code: '4340',
    name: 'Fooz',
  },
  {
    code: '4340',
    name: 'Othée',
    nameNL: 'Elch',
    nameFR: 'Othée',
  },
  {
    code: '4340',
    name: "Villers-L'Evêque",
  },
  {
    code: '4342',
    name: 'Hognoul',
  },
  {
    code: '4347',
    name: 'Fexhe-Le-Haut-Clocher',
  },
  {
    code: '4347',
    name: 'Freloux',
  },
  {
    code: '4347',
    name: 'Noville',
  },
  {
    code: '4347',
    name: 'Roloux',
  },
  {
    code: '4347',
    name: 'Voroux-Goreux',
  },
  {
    code: '4350',
    name: 'Lamine',
  },
  {
    code: '4350',
    name: 'Momalle',
  },
  {
    code: '4350',
    name: 'Pousset',
  },
  {
    code: '4350',
    name: 'Remicourt',
  },
  {
    code: '4351',
    name: 'Hodeige',
  },
  {
    code: '4357',
    name: 'Donceel',
  },
  {
    code: '4357',
    name: 'Haneffe',
  },
  {
    code: '4357',
    name: 'Jeneffe',
  },
  {
    code: '4357',
    name: 'Limont',
  },
  {
    code: '4360',
    name: 'Bergilers',
    nameNL: 'Belliek',
    nameFR: 'Bergilers',
  },
  {
    code: '4360',
    name: 'Grandville',
  },
  {
    code: '4360',
    name: 'Lens-Sur-Geer',
  },
  {
    code: '4360',
    name: 'Oreye',
    nameNL: 'Oerle',
    nameFR: 'Oreye',
  },
  {
    code: '4360',
    name: 'Otrange',
    nameNL: 'Wouteringen',
    nameFR: 'Otrange',
  },
  {
    code: '4367',
    name: 'Crisnée',
  },
  {
    code: '4367',
    name: 'Fize-Le-Marsal',
  },
  {
    code: '4367',
    name: 'Kemexhe',
  },
  {
    code: '4367',
    name: 'Odeur',
  },
  {
    code: '4367',
    name: 'Thys',
  },
  {
    code: '4400',
    name: 'Awirs',
  },
  {
    code: '4400',
    name: 'Chokier',
  },
  {
    code: '4400',
    name: 'Flémalle',
  },
  {
    code: '4400',
    name: 'Flémalle-Grande',
  },
  {
    code: '4400',
    name: 'Flémalle-Haute',
  },
  {
    code: '4400',
    name: 'Gleixhe',
  },
  {
    code: '4400',
    name: 'Ivoz-Ramet',
  },
  {
    code: '4400',
    name: 'Mons-Lez-Liège',
  },
  {
    code: '4420',
    name: 'Montegnée',
  },
  {
    code: '4420',
    name: 'Saint-Nicolas',
  },
  {
    code: '4420',
    name: 'Tilleur',
  },
  {
    code: '4430',
    name: 'Ans',
  },
  {
    code: '4431',
    name: 'Loncin',
  },
  {
    code: '4432',
    name: 'Alleur',
  },
  {
    code: '4432',
    name: 'Xhendremael',
  },
  {
    code: '4450',
    name: 'Juprelle',
  },
  {
    code: '4450',
    name: 'Lantin',
  },
  {
    code: '4450',
    name: 'Slins',
  },
  {
    code: '4451',
    name: 'Voroux-Lez-Liers',
  },
  {
    code: '4452',
    name: 'Paifve',
  },
  {
    code: '4452',
    name: 'Wihogne',
    nameNL: 'Nudorp',
    nameFR: 'Wihogne',
  },
  {
    code: '4453',
    name: 'Villers-Saint-Siméon',
  },
  {
    code: '4458',
    name: 'Fexhe-Slins',
  },
  {
    code: '4460',
    name: 'Bierset',
  },
  {
    code: '4460',
    name: 'Grâce-Berleur',
  },
  {
    code: '4460',
    name: 'Grâce-Hollogne',
  },
  {
    code: '4460',
    name: 'Hollogne-Aux-Pierres',
  },
  {
    code: '4460',
    name: 'Horion-Hozémont',
  },
  {
    code: '4460',
    name: 'Velroux',
  },
  {
    code: '4470',
    name: 'Saint-Georges-Sur-Meuse',
  },
  {
    code: '4480',
    name: 'Clermont-Sous-Huy',
  },
  {
    code: '4480',
    name: 'Ehein',
  },
  {
    code: '4480',
    name: 'Engis',
  },
  {
    code: '4480',
    name: 'Hermalle-Sous-Huy',
  },
  {
    code: '4500',
    name: 'Ben-Ahin',
  },
  {
    code: '4500',
    name: 'Huy',
    nameNL: 'Hoei',
    nameFR: 'Huy',
  },
  {
    code: '4500',
    name: 'Tihange',
  },
  {
    code: '4520',
    name: 'Antheit',
  },
  {
    code: '4520',
    name: 'Bas-Oha',
  },
  {
    code: '4520',
    name: 'Huccorgne',
  },
  {
    code: '4520',
    name: 'Moha',
  },
  {
    code: '4520',
    name: 'Vinalmont',
  },
  {
    code: '4520',
    name: 'Wanze',
  },
  {
    code: '4530',
    name: 'Fize-Fontaine',
  },
  {
    code: '4530',
    name: 'Vaux-Et-Borset',
  },
  {
    code: '4530',
    name: 'Vieux-Waleffe',
  },
  {
    code: '4530',
    name: 'Villers-Le-Bouillet',
  },
  {
    code: '4530',
    name: 'Warnant-Dreye',
  },
  {
    code: '4537',
    name: 'Bodegnée',
  },
  {
    code: '4537',
    name: 'Chapon-Seraing',
  },
  {
    code: '4537',
    name: 'Seraing-Le-Château',
  },
  {
    code: '4537',
    name: 'Verlaine',
  },
  {
    code: '4540',
    name: 'Amay',
  },
  {
    code: '4540',
    name: 'Ampsin',
  },
  {
    code: '4540',
    name: 'Flône',
  },
  {
    code: '4540',
    name: 'Jehay',
  },
  {
    code: '4540',
    name: 'Ombret',
  },
  {
    code: '4550',
    name: 'Nandrin',
  },
  {
    code: '4550',
    name: 'Saint-Séverin',
  },
  {
    code: '4550',
    name: 'Villers-Le-Temple',
  },
  {
    code: '4550',
    name: 'Yernée-Fraineux',
  },
  {
    code: '4557',
    name: 'Abée',
  },
  {
    code: '4557',
    name: 'Fraiture',
  },
  {
    code: '4557',
    name: 'Ramelot',
  },
  {
    code: '4557',
    name: 'Seny',
  },
  {
    code: '4557',
    name: 'Soheit-Tinlot',
  },
  {
    code: '4557',
    name: 'Tinlot',
  },
  {
    code: '4560',
    name: 'Bois-Et-Borsu',
  },
  {
    code: '4560',
    name: 'Clavier',
  },
  {
    code: '4560',
    name: 'Les Avins',
  },
  {
    code: '4560',
    name: 'Ocquier',
  },
  {
    code: '4560',
    name: 'Pailhe',
  },
  {
    code: '4560',
    name: 'Terwagne',
  },
  {
    code: '4570',
    name: 'Marchin',
  },
  {
    code: '4570',
    name: 'Vyle-Et-Tharoul',
  },
  {
    code: '4577',
    name: 'Modave',
  },
  {
    code: '4577',
    name: 'Outrelouxhe',
  },
  {
    code: '4577',
    name: 'Strée-Lez-Huy',
  },
  {
    code: '4577',
    name: 'Vierset-Barse',
  },
  {
    code: '4590',
    name: 'Ellemelle',
  },
  {
    code: '4590',
    name: 'Ouffet',
  },
  {
    code: '4590',
    name: 'Warzée',
  },
  {
    code: '4600',
    name: 'Lanaye',
    nameNL: 'Ternaaien',
    nameFR: 'Lanaye',
  },
  {
    code: '4600',
    name: 'Lixhe',
    nameNL: 'Lieze',
    nameFR: 'Lixhe',
  },
  {
    code: '4600',
    name: 'Richelle',
  },
  {
    code: '4600',
    name: 'Visé',
    nameNL: 'Wezet',
    nameFR: 'Visé',
  },
  {
    code: '4601',
    name: 'Argenteau',
  },
  {
    code: '4602',
    name: 'Cheratte',
  },
  {
    code: '4606',
    name: 'Saint-André',
  },
  {
    code: '4607',
    name: 'Berneau',
  },
  {
    code: '4607',
    name: 'Bombaye',
    nameNL: 'Bolbeek',
    nameFR: 'Bombaye',
  },
  {
    code: '4607',
    name: 'Dalhem',
  },
  {
    code: '4607',
    name: 'Feneur',
  },
  {
    code: '4607',
    name: 'Mortroux',
  },
  {
    code: '4608',
    name: 'Neufchâteau',
  },
  {
    code: '4608',
    name: 'Warsage',
    nameNL: 'Weerst',
    nameFR: 'Warsage',
  },
  {
    code: '4610',
    name: 'Bellaire',
  },
  {
    code: '4610',
    name: 'Beyne-Heusay',
  },
  {
    code: '4610',
    name: 'Queue-Du-Bois',
  },
  {
    code: '4620',
    name: 'Fléron',
  },
  {
    code: '4621',
    name: 'Retinne',
  },
  {
    code: '4623',
    name: 'Magnée',
  },
  {
    code: '4624',
    name: 'Romsée',
  },
  {
    code: '4630',
    name: 'Ayeneux',
  },
  {
    code: '4630',
    name: 'Micheroux',
  },
  {
    code: '4630',
    name: 'Soumagne',
  },
  {
    code: '4630',
    name: 'Tignée',
  },
  {
    code: '4631',
    name: 'Evegnée',
  },
  {
    code: '4632',
    name: 'Cérexhe-Heuseux',
  },
  {
    code: '4633',
    name: 'Melen',
  },
  {
    code: '4650',
    name: 'Chaineux',
  },
  {
    code: '4650',
    name: 'Grand-Rechain',
  },
  {
    code: '4650',
    name: 'Herve',
  },
  {
    code: '4650',
    name: 'Julémont',
  },
  {
    code: '4651',
    name: 'Battice',
  },
  {
    code: '4652',
    name: 'Xhendelesse',
  },
  {
    code: '4653',
    name: 'Bolland',
  },
  {
    code: '4654',
    name: 'Charneux',
  },
  {
    code: '4670',
    name: 'Blégny',
  },
  {
    code: '4670',
    name: 'Mortier',
  },
  {
    code: '4670',
    name: 'Trembleur',
  },
  {
    code: '4671',
    name: 'Barchon',
  },
  {
    code: '4671',
    name: 'Housse',
  },
  {
    code: '4671',
    name: 'Saive',
  },
  {
    code: '4672',
    name: 'Saint-Remy',
  },
  {
    code: '4680',
    name: 'Hermée',
  },
  {
    code: '4680',
    name: 'Oupeye',
  },
  {
    code: '4681',
    name: 'Hermalle-Sous-Argenteau',
  },
  {
    code: '4682',
    name: 'Heure-Le-Romain',
  },
  {
    code: '4682',
    name: 'Houtain-Saint-Siméon',
  },
  {
    code: '4683',
    name: 'Vivegnis',
  },
  {
    code: '4684',
    name: 'Haccourt',
  },
  {
    code: '4690',
    name: 'Bassenge',
    nameNL: 'Bitsingen',
    nameFR: 'Bassenge',
  },
  {
    code: '4690',
    name: 'Boirs',
  },
  {
    code: '4690',
    name: 'Eben-Emael',
  },
  {
    code: '4690',
    name: 'Glons',
    nameNL: 'Glaaien',
    nameFR: 'Glons',
  },
  {
    code: '4690',
    name: 'Roclenge-Sur-Geer',
    nameNL: 'Rukkelingen-aan-de-Jeker',
    nameFR: 'Roclenge-sur-Geer',
  },
  {
    code: '4690',
    name: 'Wonck',
  },
  {
    code: '4700',
    name: 'Eupen',
  },
  {
    code: '4701',
    name: 'Kettenis',
  },
  {
    code: '4710',
    name: 'Lontzen',
  },
  {
    code: '4711',
    name: 'Walhorn',
  },
  {
    code: '4720',
    name: 'Kelmis',
  },
  {
    code: '4721',
    name: 'Neu-Moresnet',
  },
  {
    code: '4728',
    name: 'Hergenrath',
  },
  {
    code: '4730',
    name: 'Hauset',
  },
  {
    code: '4730',
    name: 'Raeren',
  },
  {
    code: '4731',
    name: 'Eynatten',
  },
  {
    code: '4750',
    name: 'Butgenbach',
  },
  {
    code: '4750',
    name: 'Elsenborn',
  },
  {
    code: '4760',
    name: 'Büllingen',
    nameNL: 'Bullange',
    nameFR: 'Büllingen',
  },
  {
    code: '4760',
    name: 'Manderfeld',
  },
  {
    code: '4761',
    name: 'Rocherath',
  },
  {
    code: '4770',
    name: 'Amel',
    nameNL: 'Amblève',
    nameFR: 'Amel',
  },
  {
    code: '4770',
    name: 'Meyerode',
  },
  {
    code: '4771',
    name: 'Heppenbach',
  },
  {
    code: '4780',
    name: 'Recht',
  },
  {
    code: '4780',
    name: 'Sankt-Vith',
  },
  {
    code: '4782',
    name: 'Schönberg',
  },
  {
    code: '4783',
    name: 'Lommersweiler',
  },
  {
    code: '4784',
    name: 'Crombach',
  },
  {
    code: '4790',
    name: 'Burg-Reuland',
  },
  {
    code: '4790',
    name: 'Reuland',
  },
  {
    code: '4791',
    name: 'Thommen',
  },
  {
    code: '4800',
    name: 'Ensival',
  },
  {
    code: '4800',
    name: 'Lambermont',
  },
  {
    code: '4800',
    name: 'Petit-Rechain',
  },
  {
    code: '4800',
    name: 'Polleur',
  },
  {
    code: '4800',
    name: 'Verviers',
  },
  {
    code: '4801',
    name: 'Stembert',
  },
  {
    code: '4802',
    name: 'Heusy',
  },
  {
    code: '4820',
    name: 'Dison',
  },
  {
    code: '4821',
    name: 'Andrimont',
  },
  {
    code: '4830',
    name: 'Limbourg',
    nameNL: 'Limburg',
    nameFR: 'Limbourg',
  },
  {
    code: '4831',
    name: 'Bilstain',
  },
  {
    code: '4834',
    name: 'Goé',
    nameNL: 'Gulke',
    nameFR: 'Goé',
  },
  {
    code: '4837',
    name: 'Baelen',
  },
  {
    code: '4837',
    name: 'Membach',
  },
  {
    code: '4840',
    name: 'Welkenraedt',
  },
  {
    code: '4841',
    name: 'Henri-Chapelle',
    nameNL: 'Hendrik-Kapelle',
    nameFR: 'Henri-Chapelle',
  },
  {
    code: '4845',
    name: 'Jalhay',
  },
  {
    code: '4845',
    name: 'Sart-Lez-Spa',
  },
  {
    code: '4850',
    name: 'Montzen',
  },
  {
    code: '4850',
    name: 'Moresnet',
  },
  {
    code: '4850',
    name: 'Plombières',
  },
  {
    code: '4851',
    name: 'Gemmenich',
  },
  {
    code: '4851',
    name: 'Sippenaeken',
  },
  {
    code: '4852',
    name: 'Hombourg',
    nameNL: 'Homburg',
    nameFR: 'Hombourg',
  },
  {
    code: '4860',
    name: 'Cornesse',
  },
  {
    code: '4860',
    name: 'Pepinster',
  },
  {
    code: '4860',
    name: 'Wegnez',
  },
  {
    code: '4861',
    name: 'Soiron',
  },
  {
    code: '4870',
    name: 'Forêt',
  },
  {
    code: '4870',
    name: 'Fraipont',
  },
  {
    code: '4870',
    name: 'Nessonvaux',
  },
  {
    code: '4870',
    name: 'Trooz',
  },
  {
    code: '4877',
    name: 'Olne',
  },
  {
    code: '4880',
    name: 'Aubel',
  },
  {
    code: '4890',
    name: 'Clermont',
  },
  {
    code: '4890',
    name: 'Thimister',
  },
  {
    code: '4890',
    name: 'Thimister-Clermont',
  },
  {
    code: '4900',
    name: 'Spa',
  },
  {
    code: '4910',
    name: 'La Reid',
  },
  {
    code: '4910',
    name: 'Polleur',
  },
  {
    code: '4910',
    name: 'Theux',
  },
  {
    code: '4920',
    name: 'Aywaille',
  },
  {
    code: '4920',
    name: 'Ernonheid',
  },
  {
    code: '4920',
    name: 'Harzé',
  },
  {
    code: '4920',
    name: 'Louveigné',
  },
  {
    code: '4920',
    name: 'Sougné-Remouchamps',
  },
  {
    code: '4950',
    name: 'Faymonville',
  },
  {
    code: '4950',
    name: 'Robertville',
  },
  {
    code: '4950',
    name: 'Sourbrodt',
  },
  {
    code: '4950',
    name: 'Weismes',
  },
  {
    code: '4960',
    name: 'Bellevaux-Ligneuville',
  },
  {
    code: '4960',
    name: 'Bevercé',
  },
  {
    code: '4960',
    name: 'Malmedy',
  },
  {
    code: '4970',
    name: 'Francorchamps',
  },
  {
    code: '4970',
    name: 'Stavelot',
  },
  {
    code: '4980',
    name: 'Fosse',
  },
  {
    code: '4980',
    name: 'Trois-Ponts',
  },
  {
    code: '4980',
    name: 'Wanne',
  },
  {
    code: '4983',
    name: 'Basse-Bodeux',
  },
  {
    code: '4987',
    name: 'Chevron',
  },
  {
    code: '4987',
    name: 'La Gleize',
  },
  {
    code: '4987',
    name: 'Lorcé',
  },
  {
    code: '4987',
    name: 'Rahier',
  },
  {
    code: '4987',
    name: 'Stoumont',
  },
  {
    code: '4990',
    name: 'Arbrefontaine',
  },
  {
    code: '4990',
    name: 'Bra',
  },
  {
    code: '4990',
    name: 'Lierneux',
  },
  {
    code: '5000',
    name: 'Beez',
  },
  {
    code: '5000',
    name: 'Namur',
    nameNL: 'Namen',
    nameFR: 'Namur',
  },
  {
    code: '5001',
    name: 'Belgrade',
  },
  {
    code: '5002',
    name: 'Saint-Servais',
  },
  {
    code: '5003',
    name: 'Saint-Marc',
  },
  {
    code: '5004',
    name: 'Bouge',
  },
  {
    code: '5010',
    name: 'SA SudPresse',
  },
  {
    code: '5012',
    name: 'Parlement Wallon',
  },
  {
    code: '5020',
    name: 'Champion',
  },
  {
    code: '5020',
    name: 'Daussoulx',
  },
  {
    code: '5020',
    name: 'Flawinne',
  },
  {
    code: '5020',
    name: 'Malonne',
  },
  {
    code: '5020',
    name: 'Suarlée',
  },
  {
    code: '5020',
    name: 'Temploux',
  },
  {
    code: '5020',
    name: 'Vedrin',
  },
  {
    code: '5021',
    name: 'Boninne',
  },
  {
    code: '5022',
    name: 'Cognelée',
  },
  {
    code: '5024',
    name: 'Gelbressée',
  },
  {
    code: '5024',
    name: 'Marche-Les-Dames',
  },
  {
    code: '5030',
    name: 'Beuzet',
  },
  {
    code: '5030',
    name: 'Ernage',
  },
  {
    code: '5030',
    name: 'Gembloux',
  },
  {
    code: '5030',
    name: 'Grand-Manil',
  },
  {
    code: '5030',
    name: 'Lonzée',
  },
  {
    code: '5030',
    name: 'Sauvenière',
  },
  {
    code: '5031',
    name: 'Grand-Leez',
    nameNL: 'Groot-Leez',
    nameFR: 'Grand-Leez',
  },
  {
    code: '5032',
    name: 'Bossière',
  },
  {
    code: '5032',
    name: 'Bothey',
  },
  {
    code: '5032',
    name: 'Corroy-Le-Château',
  },
  {
    code: '5032',
    name: 'Isnes',
  },
  {
    code: '5032',
    name: 'Mazy',
  },
  {
    code: '5060',
    name: 'Arsimont',
  },
  {
    code: '5060',
    name: 'Auvelais',
  },
  {
    code: '5060',
    name: 'Falisolle',
  },
  {
    code: '5060',
    name: 'Keumiée',
  },
  {
    code: '5060',
    name: 'Moignelée',
  },
  {
    code: '5060',
    name: 'Sambreville',
  },
  {
    code: '5060',
    name: 'Tamines',
  },
  {
    code: '5060',
    name: 'Velaine-Sur-Sambre',
  },
  {
    code: '5070',
    name: 'Aisemont',
  },
  {
    code: '5070',
    name: 'Fosses-La-Ville',
  },
  {
    code: '5070',
    name: 'Le Roux',
  },
  {
    code: '5070',
    name: 'Sart-Eustache',
  },
  {
    code: '5070',
    name: 'Sart-Saint-Laurent',
  },
  {
    code: '5070',
    name: 'Vitrival',
  },
  {
    code: '5080',
    name: 'Emines',
  },
  {
    code: '5080',
    name: 'La Bruyère',
  },
  {
    code: '5080',
    name: 'Rhisnes',
  },
  {
    code: '5080',
    name: 'Villers-Lez-Heest',
  },
  {
    code: '5080',
    name: 'Warisoulx',
  },
  {
    code: '5081',
    name: 'Bovesse',
  },
  {
    code: '5081',
    name: 'Meux',
  },
  {
    code: '5081',
    name: 'Saint-Denis-Bovesse',
  },
  {
    code: '5100',
    name: 'Dave',
  },
  {
    code: '5100',
    name: 'Jambes',
  },
  {
    code: '5100',
    name: 'Naninne',
  },
  {
    code: '5100',
    name: 'Wépion',
  },
  {
    code: '5100',
    name: 'Wierde',
  },
  {
    code: '5101',
    name: 'Erpent',
  },
  {
    code: '5101',
    name: 'Lives-Sur-Meuse',
  },
  {
    code: '5101',
    name: 'Loyers',
  },
  {
    code: '5140',
    name: 'Boignée',
  },
  {
    code: '5140',
    name: 'Ligny',
  },
  {
    code: '5140',
    name: 'Sombreffe',
  },
  {
    code: '5140',
    name: 'Tongrinne',
  },
  {
    code: '5150',
    name: 'Floreffe',
  },
  {
    code: '5150',
    name: 'Floriffoux',
  },
  {
    code: '5150',
    name: 'Franière',
  },
  {
    code: '5150',
    name: 'Soye',
  },
  {
    code: '5170',
    name: 'Arbre',
  },
  {
    code: '5170',
    name: 'Bois-De-Villers',
  },
  {
    code: '5170',
    name: 'Lesve',
  },
  {
    code: '5170',
    name: 'Lustin',
  },
  {
    code: '5170',
    name: 'Profondeville',
  },
  {
    code: '5170',
    name: 'Rivière',
  },
  {
    code: '5190',
    name: 'Balâtre',
  },
  {
    code: '5190',
    name: 'Ham-Sur-Sambre',
  },
  {
    code: '5190',
    name: 'Jemeppe-Sur-Sambre',
  },
  {
    code: '5190',
    name: 'Mornimont',
  },
  {
    code: '5190',
    name: 'Moustier-Sur-Sambre',
  },
  {
    code: '5190',
    name: 'Onoz',
  },
  {
    code: '5190',
    name: 'Saint-Martin',
  },
  {
    code: '5190',
    name: 'Spy',
  },
  {
    code: '5300',
    name: 'Andenne',
  },
  {
    code: '5300',
    name: 'Bonneville',
  },
  {
    code: '5300',
    name: 'Coutisse',
  },
  {
    code: '5300',
    name: 'Landenne',
  },
  {
    code: '5300',
    name: 'Maizeret',
  },
  {
    code: '5300',
    name: 'Namêche',
  },
  {
    code: '5300',
    name: 'Sclayn',
  },
  {
    code: '5300',
    name: 'Seilles',
  },
  {
    code: '5300',
    name: 'Thon',
  },
  {
    code: '5300',
    name: 'Vezin',
  },
  {
    code: '5310',
    name: 'Aische-En-Refail',
  },
  {
    code: '5310',
    name: 'Bolinne',
  },
  {
    code: '5310',
    name: 'Boneffe',
  },
  {
    code: '5310',
    name: 'Branchon',
  },
  {
    code: '5310',
    name: 'Dhuy',
  },
  {
    code: '5310',
    name: 'Eghezée',
  },
  {
    code: '5310',
    name: 'Hanret',
  },
  {
    code: '5310',
    name: 'Leuze',
  },
  {
    code: '5310',
    name: 'Liernu',
  },
  {
    code: '5310',
    name: 'Longchamps',
  },
  {
    code: '5310',
    name: 'Mehaigne',
  },
  {
    code: '5310',
    name: 'Noville-Sur-Méhaigne',
  },
  {
    code: '5310',
    name: 'Saint-Germain',
  },
  {
    code: '5310',
    name: 'Taviers',
  },
  {
    code: '5310',
    name: 'Upigny',
  },
  {
    code: '5310',
    name: 'Waret-La-Chaussée',
  },
  {
    code: '5330',
    name: 'Assesse',
  },
  {
    code: '5330',
    name: 'Maillen',
  },
  {
    code: '5330',
    name: 'Sart-Bernard',
  },
  {
    code: '5332',
    name: 'Crupet',
  },
  {
    code: '5333',
    name: 'Sorinne-La-Longue',
  },
  {
    code: '5334',
    name: 'Florée',
  },
  {
    code: '5336',
    name: 'Courrière',
  },
  {
    code: '5340',
    name: 'Faulx-Les-Tombes',
  },
  {
    code: '5340',
    name: 'Gesves',
  },
  {
    code: '5340',
    name: 'Haltinne',
  },
  {
    code: '5340',
    name: 'Mozet',
  },
  {
    code: '5340',
    name: 'Sorée',
  },
  {
    code: '5350',
    name: 'Evelette',
  },
  {
    code: '5350',
    name: 'Ohey',
  },
  {
    code: '5351',
    name: 'Haillot',
  },
  {
    code: '5352',
    name: 'Perwez-Haillot',
  },
  {
    code: '5353',
    name: 'Goesnes',
  },
  {
    code: '5354',
    name: 'Jallet',
  },
  {
    code: '5360',
    name: 'Hamois',
  },
  {
    code: '5360',
    name: 'Natoye',
  },
  {
    code: '5361',
    name: 'Mohiville',
  },
  {
    code: '5361',
    name: 'Scy',
  },
  {
    code: '5362',
    name: 'Achet',
  },
  {
    code: '5363',
    name: 'Emptinne',
  },
  {
    code: '5364',
    name: 'Schaltin',
  },
  {
    code: '5370',
    name: 'Barvaux-Condroz',
  },
  {
    code: '5370',
    name: 'Flostoy',
  },
  {
    code: '5370',
    name: 'Havelange',
  },
  {
    code: '5370',
    name: 'Jeneffe',
  },
  {
    code: '5370',
    name: 'Porcheresse',
  },
  {
    code: '5370',
    name: 'Verlée',
  },
  {
    code: '5372',
    name: 'Méan',
  },
  {
    code: '5374',
    name: 'Maffe',
  },
  {
    code: '5376',
    name: 'Miécret',
  },
  {
    code: '5377',
    name: 'Baillonville',
  },
  {
    code: '5377',
    name: 'Bonsin',
  },
  {
    code: '5377',
    name: 'Heure',
  },
  {
    code: '5377',
    name: 'Hogne',
  },
  {
    code: '5377',
    name: 'Nettinne',
  },
  {
    code: '5377',
    name: 'Noiseux',
  },
  {
    code: '5377',
    name: 'Sinsin',
  },
  {
    code: '5377',
    name: 'Somme-Leuze',
  },
  {
    code: '5377',
    name: 'Waillet',
  },
  {
    code: '5380',
    name: 'Bierwart',
  },
  {
    code: '5380',
    name: 'Cortil-Wodon',
  },
  {
    code: '5380',
    name: 'Fernelmont',
  },
  {
    code: '5380',
    name: 'Forville',
  },
  {
    code: '5380',
    name: 'Franc-Waret',
  },
  {
    code: '5380',
    name: 'Hemptinne',
  },
  {
    code: '5380',
    name: 'Hingeon',
  },
  {
    code: '5380',
    name: 'Marchovelette',
  },
  {
    code: '5380',
    name: 'Noville-Les-Bois',
  },
  {
    code: '5380',
    name: 'Pontillas',
  },
  {
    code: '5380',
    name: 'Tillier',
  },
  {
    code: '5500',
    name: 'Anseremme',
  },
  {
    code: '5500',
    name: 'Bouvignes-Sur-Meuse',
  },
  {
    code: '5500',
    name: 'Dinant',
  },
  {
    code: '5500',
    name: 'Dréhance',
  },
  {
    code: '5500',
    name: 'Falmagne',
  },
  {
    code: '5500',
    name: 'Falmignoul',
  },
  {
    code: '5500',
    name: 'Furfooz',
  },
  {
    code: '5501',
    name: 'Lisogne',
  },
  {
    code: '5502',
    name: 'Thynes',
  },
  {
    code: '5503',
    name: 'Sorinnes',
  },
  {
    code: '5504',
    name: 'Foy-Notre-Dame',
  },
  {
    code: '5520',
    name: 'Anthée',
  },
  {
    code: '5520',
    name: 'Onhaye',
  },
  {
    code: '5521',
    name: 'Serville',
  },
  {
    code: '5522',
    name: 'Falaen',
  },
  {
    code: '5523',
    name: 'Sommière',
  },
  {
    code: '5523',
    name: 'Weillen',
  },
  {
    code: '5524',
    name: 'Gerin',
  },
  {
    code: '5530',
    name: 'Dorinne',
  },
  {
    code: '5530',
    name: 'Durnal',
  },
  {
    code: '5530',
    name: 'Evrehailles',
  },
  {
    code: '5530',
    name: 'Godinne',
  },
  {
    code: '5530',
    name: 'Houx',
  },
  {
    code: '5530',
    name: 'Mont',
  },
  {
    code: '5530',
    name: 'Purnode',
  },
  {
    code: '5530',
    name: 'Spontin',
  },
  {
    code: '5530',
    name: 'Yvoir',
  },
  {
    code: '5537',
    name: 'Anhée',
  },
  {
    code: '5537',
    name: 'Annevoie-Rouillon',
  },
  {
    code: '5537',
    name: 'Bioul',
  },
  {
    code: '5537',
    name: 'Denée',
  },
  {
    code: '5537',
    name: 'Haut-Le-Wastia',
  },
  {
    code: '5537',
    name: 'Sosoye',
  },
  {
    code: '5537',
    name: 'Warnant',
  },
  {
    code: '5540',
    name: 'Hastière',
  },
  {
    code: '5540',
    name: 'Hastière-Lavaux',
  },
  {
    code: '5540',
    name: 'Hermeton-Sur-Meuse',
  },
  {
    code: '5540',
    name: 'Waulsort',
  },
  {
    code: '5541',
    name: 'Hastière-Par-Delà',
  },
  {
    code: '5542',
    name: 'Blaimont',
  },
  {
    code: '5543',
    name: 'Heer',
  },
  {
    code: '5544',
    name: 'Agimont',
  },
  {
    code: '5550',
    name: 'Alle',
  },
  {
    code: '5550',
    name: 'Bagimont',
  },
  {
    code: '5550',
    name: 'Bohan',
  },
  {
    code: '5550',
    name: 'Chairière',
  },
  {
    code: '5550',
    name: 'Laforet',
  },
  {
    code: '5550',
    name: 'Membre',
  },
  {
    code: '5550',
    name: 'Mouzaive',
  },
  {
    code: '5550',
    name: 'Nafraiture',
  },
  {
    code: '5550',
    name: 'Orchimont',
  },
  {
    code: '5550',
    name: 'Pussemange',
  },
  {
    code: '5550',
    name: 'Sugny',
  },
  {
    code: '5550',
    name: 'Vresse-Sur-Semois',
  },
  {
    code: '5555',
    name: 'Baillamont',
  },
  {
    code: '5555',
    name: 'Bellefontaine',
  },
  {
    code: '5555',
    name: 'Bièvre',
  },
  {
    code: '5555',
    name: 'Cornimont',
  },
  {
    code: '5555',
    name: 'Graide',
  },
  {
    code: '5555',
    name: 'Gros-Fays',
  },
  {
    code: '5555',
    name: 'Monceau-En-Ardenne',
  },
  {
    code: '5555',
    name: 'Naomé',
  },
  {
    code: '5555',
    name: 'Oizy',
  },
  {
    code: '5555',
    name: 'Petit-Fays',
  },
  {
    code: '5560',
    name: 'Ciergnon',
  },
  {
    code: '5560',
    name: 'Finnevaux',
  },
  {
    code: '5560',
    name: 'Houyet',
  },
  {
    code: '5560',
    name: 'Hulsonniaux',
  },
  {
    code: '5560',
    name: 'Mesnil-Eglise',
  },
  {
    code: '5560',
    name: 'Mesnil-Saint-Blaise',
  },
  {
    code: '5561',
    name: 'Celles',
  },
  {
    code: '5562',
    name: 'Custinne',
  },
  {
    code: '5563',
    name: 'Hour',
  },
  {
    code: '5564',
    name: 'Wanlin',
  },
  {
    code: '5570',
    name: 'Baronville',
  },
  {
    code: '5570',
    name: 'Beauraing',
  },
  {
    code: '5570',
    name: 'Dion',
  },
  {
    code: '5570',
    name: 'Felenne',
  },
  {
    code: '5570',
    name: 'Feschaux',
  },
  {
    code: '5570',
    name: 'Honnay',
  },
  {
    code: '5570',
    name: 'Javingue',
  },
  {
    code: '5570',
    name: 'Vonêche',
  },
  {
    code: '5570',
    name: 'Wancennes',
  },
  {
    code: '5570',
    name: 'Winenne',
  },
  {
    code: '5571',
    name: 'Wiesme',
  },
  {
    code: '5572',
    name: 'Focant',
  },
  {
    code: '5573',
    name: 'Martouzin-Neuville',
  },
  {
    code: '5574',
    name: 'Pondrôme',
  },
  {
    code: '5575',
    name: 'Bourseigne-Neuve',
  },
  {
    code: '5575',
    name: 'Bourseigne-Vieille',
  },
  {
    code: '5575',
    name: 'Gedinne',
  },
  {
    code: '5575',
    name: 'Houdremont',
  },
  {
    code: '5575',
    name: 'Louette-Saint-Denis',
  },
  {
    code: '5575',
    name: 'Louette-Saint-Pierre',
  },
  {
    code: '5575',
    name: 'Malvoisin',
  },
  {
    code: '5575',
    name: 'Patignies',
  },
  {
    code: '5575',
    name: 'Rienne',
  },
  {
    code: '5575',
    name: 'Sart-Custinne',
  },
  {
    code: '5575',
    name: 'Vencimont',
  },
  {
    code: '5575',
    name: 'Willerzie',
  },
  {
    code: '5576',
    name: 'Froidfontaine',
  },
  {
    code: '5580',
    name: 'Ave-Et-Auffe',
  },
  {
    code: '5580',
    name: 'Buissonville',
  },
  {
    code: '5580',
    name: 'Eprave',
  },
  {
    code: '5580',
    name: 'Han-Sur-Lesse',
  },
  {
    code: '5580',
    name: 'Jemelle',
  },
  {
    code: '5580',
    name: 'Lavaux-Saint-Anne',
  },
  {
    code: '5580',
    name: 'Lessive',
  },
  {
    code: '5580',
    name: 'Mont-Gauthier',
  },
  {
    code: '5580',
    name: 'Rochefort',
  },
  {
    code: '5580',
    name: 'Villers-Sur-Lesse',
  },
  {
    code: '5580',
    name: 'Wavreille',
  },
  {
    code: '5589',
    name: 'Jemelle',
  },
  {
    code: '5590',
    name: 'Achêne',
  },
  {
    code: '5590',
    name: 'Braibant',
  },
  {
    code: '5590',
    name: 'Chevetogne',
  },
  {
    code: '5590',
    name: 'Ciney',
  },
  {
    code: '5590',
    name: 'Conneux',
  },
  {
    code: '5590',
    name: 'Haversin',
  },
  {
    code: '5590',
    name: 'Leignon',
  },
  {
    code: '5590',
    name: 'Pessoux',
  },
  {
    code: '5590',
    name: 'Serinchamps',
  },
  {
    code: '5590',
    name: 'Sovet',
  },
  {
    code: '5600',
    name: 'Fagnolle',
  },
  {
    code: '5600',
    name: 'Franchimont',
  },
  {
    code: '5600',
    name: 'Jamagne',
  },
  {
    code: '5600',
    name: 'Jamiolle',
  },
  {
    code: '5600',
    name: 'Merlemont',
  },
  {
    code: '5600',
    name: 'Neuville',
  },
  {
    code: '5600',
    name: 'Omezée',
  },
  {
    code: '5600',
    name: 'Philippeville',
  },
  {
    code: '5600',
    name: 'Roly',
  },
  {
    code: '5600',
    name: 'Romedenne',
  },
  {
    code: '5600',
    name: 'Samart',
  },
  {
    code: '5600',
    name: 'Sart-En-Fagne',
  },
  {
    code: '5600',
    name: 'Sautour',
  },
  {
    code: '5600',
    name: 'Surice',
  },
  {
    code: '5600',
    name: 'Villers-En-Fagne',
  },
  {
    code: '5600',
    name: 'Villers-Le-Gambon',
  },
  {
    code: '5600',
    name: 'Vodecée',
  },
  {
    code: '5620',
    name: 'Corenne',
  },
  {
    code: '5620',
    name: 'Flavion',
  },
  {
    code: '5620',
    name: 'Florennes',
  },
  {
    code: '5620',
    name: 'Hemptinne-Lez-Florennes',
  },
  {
    code: '5620',
    name: 'Morville',
  },
  {
    code: '5620',
    name: 'Rosée',
  },
  {
    code: '5620',
    name: 'Saint-Aubin',
  },
  {
    code: '5621',
    name: 'Hanzinelle',
  },
  {
    code: '5621',
    name: 'Hanzinne',
  },
  {
    code: '5621',
    name: 'Morialmé',
  },
  {
    code: '5621',
    name: 'Thy-Le-Baudouin',
  },
  {
    code: '5630',
    name: 'Cerfontaine',
  },
  {
    code: '5630',
    name: 'Daussois',
  },
  {
    code: '5630',
    name: 'Senzeille',
  },
  {
    code: '5630',
    name: 'Silenrieux',
  },
  {
    code: '5630',
    name: 'Soumoy',
  },
  {
    code: '5630',
    name: 'Villers-Deux-Eglises',
  },
  {
    code: '5640',
    name: 'Biesme',
  },
  {
    code: '5640',
    name: 'Biesmerée',
  },
  {
    code: '5640',
    name: 'Graux',
  },
  {
    code: '5640',
    name: 'Mettet',
  },
  {
    code: '5640',
    name: 'Oret',
  },
  {
    code: '5640',
    name: 'Saint-Gérard',
  },
  {
    code: '5641',
    name: 'Furnaux',
  },
  {
    code: '5644',
    name: 'Ermeton-Sur-Biert',
  },
  {
    code: '5646',
    name: 'Stave',
  },
  {
    code: '5650',
    name: 'Castillon',
  },
  {
    code: '5650',
    name: 'Chastrès',
  },
  {
    code: '5650',
    name: 'Clermont',
  },
  {
    code: '5650',
    name: 'Fontenelle',
  },
  {
    code: '5650',
    name: 'Fraire',
  },
  {
    code: '5650',
    name: 'Pry',
  },
  {
    code: '5650',
    name: 'Vogenée',
  },
  {
    code: '5650',
    name: 'Walcourt',
  },
  {
    code: '5650',
    name: 'Yves-Gomezée',
  },
  {
    code: '5651',
    name: 'Berzée',
  },
  {
    code: '5651',
    name: 'Gourdinne',
  },
  {
    code: '5651',
    name: 'Laneffe',
  },
  {
    code: '5651',
    name: 'Rognée',
  },
  {
    code: '5651',
    name: 'Somzée',
  },
  {
    code: '5651',
    name: 'Tarcienne',
  },
  {
    code: '5651',
    name: 'Thy-Le-Château',
  },
  {
    code: '5660',
    name: 'Aublain',
  },
  {
    code: '5660',
    name: 'Boussu-En-Fagne',
  },
  {
    code: '5660',
    name: 'Brûly',
  },
  {
    code: '5660',
    name: 'Brûly-De-Pesche',
  },
  {
    code: '5660',
    name: 'Couvin',
  },
  {
    code: '5660',
    name: 'Cul-Des-Sarts',
  },
  {
    code: '5660',
    name: 'Dailly',
  },
  {
    code: '5660',
    name: 'Frasnes',
  },
  {
    code: '5660',
    name: 'Gonrieux',
  },
  {
    code: '5660',
    name: 'Mariembourg',
  },
  {
    code: '5660',
    name: 'Pesche',
  },
  {
    code: '5660',
    name: 'Petigny',
  },
  {
    code: '5660',
    name: 'Petite-Chapelle',
  },
  {
    code: '5660',
    name: 'Presgaux',
  },
  {
    code: '5670',
    name: 'Dourbes',
  },
  {
    code: '5670',
    name: 'Le Mesnil',
  },
  {
    code: '5670',
    name: 'Mazée',
  },
  {
    code: '5670',
    name: 'Nismes',
  },
  {
    code: '5670',
    name: 'Oignies-En-Thiérache',
  },
  {
    code: '5670',
    name: 'Olloy-Sur-Viroin',
  },
  {
    code: '5670',
    name: 'Treignes',
  },
  {
    code: '5670',
    name: 'Vierves-Sur-Viroin',
  },
  {
    code: '5670',
    name: 'Viroinval',
  },
  {
    code: '5680',
    name: 'Doische',
  },
  {
    code: '5680',
    name: 'Gimnée',
  },
  {
    code: '5680',
    name: 'Gochenée',
  },
  {
    code: '5680',
    name: 'Matagne-La-Grande',
  },
  {
    code: '5680',
    name: 'Matagne-La-Petite',
  },
  {
    code: '5680',
    name: 'Niverlée',
  },
  {
    code: '5680',
    name: 'Romerée',
  },
  {
    code: '5680',
    name: 'Soulme',
  },
  {
    code: '5680',
    name: 'Vaucelles',
  },
  {
    code: '5680',
    name: 'Vodelée',
  },
  {
    code: '6000',
    name: 'Charleroi',
  },
  {
    code: '6001',
    name: 'Marcinelle',
  },
  {
    code: '6010',
    name: 'Couillet',
  },
  {
    code: '6020',
    name: 'Dampremy',
  },
  {
    code: '6030',
    name: 'Goutroux',
  },
  {
    code: '6030',
    name: 'Marchienne-Au-Pont',
  },
  {
    code: '6031',
    name: 'Monceau-Sur-Sambre',
  },
  {
    code: '6032',
    name: 'Mont-Sur-Marchienne',
  },
  {
    code: '6040',
    name: 'Jumet',
  },
  {
    code: '6041',
    name: 'Gosselies',
  },
  {
    code: '6042',
    name: 'Lodelinsart',
  },
  {
    code: '6043',
    name: 'Ransart',
  },
  {
    code: '6044',
    name: 'Roux',
  },
  {
    code: '6060',
    name: 'Gilly',
  },
  {
    code: '6061',
    name: 'Montignies-Sur-Sambre',
  },
  {
    code: '6075',
    name: 'CSM Charleroi X',
  },
  {
    code: '6099',
    name: 'Charleroi X',
  },
  {
    code: '6110',
    name: 'Montigny-Le-Tilleul',
  },
  {
    code: '6111',
    name: 'Landelies',
  },
  {
    code: '6120',
    name: 'Cour-Sur-Heure',
  },
  {
    code: '6120',
    name: 'Ham-Sur-Heure',
  },
  {
    code: '6120',
    name: 'Jamioulx',
  },
  {
    code: '6120',
    name: 'Marbaix',
  },
  {
    code: '6120',
    name: 'Nalinnes',
  },
  {
    code: '6140',
    name: "Fontaine-L'Evêque",
  },
  {
    code: '6141',
    name: 'Forchies-La-Marche',
  },
  {
    code: '6142',
    name: 'Leernes',
  },
  {
    code: '6150',
    name: 'Anderlues',
  },
  {
    code: '6180',
    name: 'Courcelles',
  },
  {
    code: '6181',
    name: 'Gouy-Lez-Piéton',
  },
  {
    code: '6182',
    name: 'Souvret',
  },
  {
    code: '6183',
    name: 'Trazegnies',
  },
  {
    code: '6200',
    name: 'Bouffioulx',
  },
  {
    code: '6200',
    name: 'Châtelet',
  },
  {
    code: '6200',
    name: 'Châtelineau',
  },
  {
    code: '6210',
    name: 'Frasnes-Lez-Gosselies',
  },
  {
    code: '6210',
    name: 'Les Bons Villers',
  },
  {
    code: '6210',
    name: 'Rèves',
  },
  {
    code: '6210',
    name: 'Villers-Perwin',
  },
  {
    code: '6210',
    name: 'Wayaux',
  },
  {
    code: '6211',
    name: 'Mellet',
  },
  {
    code: '6220',
    name: 'Fleurus',
  },
  {
    code: '6220',
    name: 'Heppignies',
  },
  {
    code: '6220',
    name: 'Lambusart',
  },
  {
    code: '6220',
    name: 'Wangenies',
  },
  {
    code: '6221',
    name: 'Saint-Amand',
  },
  {
    code: '6222',
    name: 'Brye',
  },
  {
    code: '6223',
    name: 'Wagnelée',
  },
  {
    code: '6224',
    name: 'Wanfercée-Baulet',
  },
  {
    code: '6230',
    name: 'Buzet',
  },
  {
    code: '6230',
    name: 'Obaix',
  },
  {
    code: '6230',
    name: 'Pont-À-Celles',
  },
  {
    code: '6230',
    name: 'Thiméon',
  },
  {
    code: '6230',
    name: 'Viesville',
  },
  {
    code: '6238',
    name: 'Liberchies',
  },
  {
    code: '6238',
    name: 'Luttre',
  },
  {
    code: '6240',
    name: 'Farciennes',
  },
  {
    code: '6240',
    name: 'Pironchamps',
  },
  {
    code: '6250',
    name: 'Aiseau',
  },
  {
    code: '6250',
    name: 'Aiseau-Presles',
  },
  {
    code: '6250',
    name: 'Pont-De-Loup',
  },
  {
    code: '6250',
    name: 'Presles',
  },
  {
    code: '6250',
    name: 'Roselies',
  },
  {
    code: '6280',
    name: 'Acoz',
  },
  {
    code: '6280',
    name: 'Gerpinnes',
  },
  {
    code: '6280',
    name: 'Gougnies',
  },
  {
    code: '6280',
    name: 'Joncret',
  },
  {
    code: '6280',
    name: 'Loverval',
  },
  {
    code: '6280',
    name: 'Villers-Poterie',
  },
  {
    code: '6440',
    name: 'Boussu-Lez-Walcourt',
  },
  {
    code: '6440',
    name: 'Fourbechies',
  },
  {
    code: '6440',
    name: 'Froidchapelle',
  },
  {
    code: '6440',
    name: 'Vergnies',
  },
  {
    code: '6441',
    name: 'Erpion',
  },
  {
    code: '6460',
    name: 'Bailièvre',
  },
  {
    code: '6460',
    name: 'Chimay',
  },
  {
    code: '6460',
    name: 'Robechies',
  },
  {
    code: '6460',
    name: 'Saint-Remy',
  },
  {
    code: '6460',
    name: 'Salles',
  },
  {
    code: '6460',
    name: 'Villers-La-Tour',
  },
  {
    code: '6461',
    name: 'Virelles',
  },
  {
    code: '6462',
    name: 'Vaulx-Lez-Chimay',
  },
  {
    code: '6463',
    name: 'Lompret',
  },
  {
    code: '6464',
    name: 'Baileux',
  },
  {
    code: '6464',
    name: 'Bourlers',
  },
  {
    code: '6464',
    name: 'Forges',
  },
  {
    code: '6464',
    name: "L'Escaillère",
  },
  {
    code: '6464',
    name: 'Rièzes',
  },
  {
    code: '6470',
    name: 'Grandrieu',
  },
  {
    code: '6470',
    name: 'Montbliart',
  },
  {
    code: '6470',
    name: 'Rance',
  },
  {
    code: '6470',
    name: 'Sautin',
  },
  {
    code: '6470',
    name: 'Sivry',
  },
  {
    code: '6470',
    name: 'Sivry-Rance',
  },
  {
    code: '6500',
    name: 'Barbençon',
  },
  {
    code: '6500',
    name: 'Beaumont',
  },
  {
    code: '6500',
    name: 'Leugnies',
  },
  {
    code: '6500',
    name: 'Leval-Chaudeville',
  },
  {
    code: '6500',
    name: 'Renlies',
  },
  {
    code: '6500',
    name: 'Solre-Saint-Géry',
  },
  {
    code: '6500',
    name: 'Thirimont',
  },
  {
    code: '6511',
    name: 'Strée',
  },
  {
    code: '6530',
    name: 'Leers-Et-Fosteau',
  },
  {
    code: '6530',
    name: 'Thuin',
  },
  {
    code: '6531',
    name: 'Biesme-Sous-Thuin',
  },
  {
    code: '6532',
    name: 'Ragnies',
  },
  {
    code: '6533',
    name: 'Biercée',
  },
  {
    code: '6534',
    name: 'Gozée',
  },
  {
    code: '6536',
    name: 'Donstiennes',
  },
  {
    code: '6536',
    name: 'Thuillies',
  },
  {
    code: '6540',
    name: 'Lobbes',
  },
  {
    code: '6540',
    name: 'Mont-Sainte-Geneviève',
  },
  {
    code: '6542',
    name: 'Sars-La-Buissière',
  },
  {
    code: '6543',
    name: 'Bienne-Lez-Happart',
  },
  {
    code: '6560',
    name: "Bersillies-L'Abbaye",
  },
  {
    code: '6560',
    name: 'Erquelinnes',
  },
  {
    code: '6560',
    name: 'Grand-Reng',
  },
  {
    code: '6560',
    name: 'Hantes-Wihéries',
  },
  {
    code: '6560',
    name: 'Montignies-Saint-Christophe',
  },
  {
    code: '6560',
    name: 'Solre-Sur-Sambre',
  },
  {
    code: '6567',
    name: 'Fontaine-Valmont',
  },
  {
    code: '6567',
    name: 'Labuissière',
  },
  {
    code: '6567',
    name: 'Merbes-Le-Château',
  },
  {
    code: '6567',
    name: 'Merbes-Sainte-Marie',
  },
  {
    code: '6590',
    name: 'Momignies',
  },
  {
    code: '6591',
    name: 'Macon',
  },
  {
    code: '6592',
    name: 'Monceau-Imbrechies',
  },
  {
    code: '6593',
    name: 'Macquenoise',
  },
  {
    code: '6594',
    name: 'Beauwelz',
  },
  {
    code: '6596',
    name: 'Forge-Philippe',
  },
  {
    code: '6596',
    name: 'Seloignes',
  },
  {
    code: '6600',
    name: 'Bastogne',
    nameNL: 'Bastenaken',
    nameFR: 'Bastogne',
  },
  {
    code: '6600',
    name: 'Longvilly',
  },
  {
    code: '6600',
    name: 'Noville',
  },
  {
    code: '6600',
    name: 'Villers-La-Bonne-Eau',
  },
  {
    code: '6600',
    name: 'Wardin',
  },
  {
    code: '6630',
    name: 'Martelange',
    nameNL: 'Martelingen',
    nameFR: 'Martelange',
  },
  {
    code: '6637',
    name: 'Fauvillers',
  },
  {
    code: '6637',
    name: 'Hollange',
  },
  {
    code: '6637',
    name: 'Tintange',
  },
  {
    code: '6640',
    name: 'Hompré',
  },
  {
    code: '6640',
    name: 'Morhet',
  },
  {
    code: '6640',
    name: 'Nives',
  },
  {
    code: '6640',
    name: 'Sibret',
  },
  {
    code: '6640',
    name: 'Vaux-Lez-Rosières',
  },
  {
    code: '6640',
    name: 'Vaux-Sur-Sûre',
  },
  {
    code: '6642',
    name: 'Juseret',
  },
  {
    code: '6660',
    name: 'Houffalize',
  },
  {
    code: '6660',
    name: 'Nadrin',
  },
  {
    code: '6661',
    name: 'Mont',
  },
  {
    code: '6661',
    name: 'Tailles',
  },
  {
    code: '6662',
    name: 'Tavigny',
  },
  {
    code: '6663',
    name: 'Mabompré',
  },
  {
    code: '6666',
    name: 'Wibrin',
  },
  {
    code: '6670',
    name: 'Gouvy',
  },
  {
    code: '6670',
    name: 'Limerlé',
    nameNL: 'Lomerslaer',
    nameFR: 'Limerlé',
  },
  {
    code: '6671',
    name: 'Bovigny',
  },
  {
    code: '6672',
    name: 'Beho',
  },
  {
    code: '6673',
    name: 'Cherain',
  },
  {
    code: '6674',
    name: 'Montleban',
  },
  {
    code: '6680',
    name: 'Amberloup',
  },
  {
    code: '6680',
    name: 'Sainte-Ode',
  },
  {
    code: '6680',
    name: 'Tillet',
  },
  {
    code: '6681',
    name: 'Lavacherie',
  },
  {
    code: '6686',
    name: 'Flamierge',
  },
  {
    code: '6687',
    name: 'Bastenaken',
    nameNL: 'Bastenaken',
    nameFR: 'Bastogne',
  },
  {
    code: '6688',
    name: 'Longchamps',
  },
  {
    code: '6690',
    name: 'Bihain',
  },
  {
    code: '6690',
    name: 'Vielsalm',
  },
  {
    code: '6692',
    name: 'Petit-Thier',
  },
  {
    code: '6698',
    name: 'Grand-Halleux',
  },
  {
    code: '6700',
    name: 'Arlon',
    nameNL: 'Aarlen',
    nameFR: 'Arlon',
  },
  {
    code: '6700',
    name: 'Bonnert',
  },
  {
    code: '6700',
    name: 'Heinsch',
  },
  {
    code: '6700',
    name: 'Toernich',
  },
  {
    code: '6704',
    name: 'Guirsch',
  },
  {
    code: '6706',
    name: 'Autelbas',
  },
  {
    code: '6717',
    name: 'Attert',
  },
  {
    code: '6717',
    name: 'Nobressart',
  },
  {
    code: '6717',
    name: 'Nothomb',
  },
  {
    code: '6717',
    name: 'Thiaumont',
    nameNL: 'Diedenberg',
    nameFR: 'Thiaumont',
  },
  {
    code: '6717',
    name: 'Tontelange',
  },
  {
    code: '6720',
    name: 'Habay',
  },
  {
    code: '6720',
    name: 'Habay-La-Neuve',
  },
  {
    code: '6720',
    name: 'Hachy',
  },
  {
    code: '6721',
    name: 'Anlier',
  },
  {
    code: '6723',
    name: 'Habay-La-Vieille',
  },
  {
    code: '6724',
    name: 'Houdemont',
  },
  {
    code: '6724',
    name: 'Rulles',
  },
  {
    code: '6730',
    name: 'Bellefontaine',
  },
  {
    code: '6730',
    name: 'Rossignol',
  },
  {
    code: '6730',
    name: 'Saint-Vincent',
  },
  {
    code: '6730',
    name: 'Tintigny',
  },
  {
    code: '6740',
    name: 'Etalle',
  },
  {
    code: '6740',
    name: 'Sainte-Marie-Sur-Semois',
  },
  {
    code: '6740',
    name: 'Villers-Sur-Semois',
  },
  {
    code: '6741',
    name: 'Vance',
  },
  {
    code: '6742',
    name: 'Chantemelle',
  },
  {
    code: '6743',
    name: 'Buzenol',
  },
  {
    code: '6747',
    name: 'Châtillon',
  },
  {
    code: '6747',
    name: 'Meix-Le-Tige',
  },
  {
    code: '6747',
    name: 'Saint-Léger',
  },
  {
    code: '6750',
    name: 'Musson',
  },
  {
    code: '6750',
    name: 'Mussy-La-Ville',
  },
  {
    code: '6750',
    name: 'Signeulx',
  },
  {
    code: '6760',
    name: 'Bleid',
  },
  {
    code: '6760',
    name: 'Ethe',
  },
  {
    code: '6760',
    name: 'Ruette',
  },
  {
    code: '6760',
    name: 'Virton',
  },
  {
    code: '6761',
    name: 'Latour',
  },
  {
    code: '6762',
    name: 'Saint-Mard',
  },
  {
    code: '6767',
    name: 'Dampicourt',
  },
  {
    code: '6767',
    name: 'Harnoncourt',
  },
  {
    code: '6767',
    name: 'Lamorteau',
  },
  {
    code: '6767',
    name: 'Rouvroy',
  },
  {
    code: '6767',
    name: 'Torgny',
  },
  {
    code: '6769',
    name: 'Gérouville',
  },
  {
    code: '6769',
    name: 'Meix-Devant-Virton',
  },
  {
    code: '6769',
    name: 'Robelmont',
  },
  {
    code: '6769',
    name: 'Sommethonne',
  },
  {
    code: '6769',
    name: 'Villers-La-Loue',
  },
  {
    code: '6780',
    name: 'Hondelange',
    nameNL: 'Hondelingen',
    nameFR: 'Hondelange',
  },
  {
    code: '6780',
    name: 'Messancy',
  },
  {
    code: '6780',
    name: 'Wolkrange',
  },
  {
    code: '6781',
    name: 'Sélange',
  },
  {
    code: '6782',
    name: 'Habergy',
  },
  {
    code: '6790',
    name: 'Aubange',
  },
  {
    code: '6791',
    name: 'Athus',
  },
  {
    code: '6792',
    name: 'Halanzy',
    nameNL: 'Helsingen',
    nameFR: 'Halanzy',
  },
  {
    code: '6792',
    name: 'Rachecourt',
    nameNL: 'Roesig',
    nameFR: 'Rachecourt',
  },
  {
    code: '6800',
    name: 'Bras',
  },
  {
    code: '6800',
    name: 'Freux',
  },
  {
    code: '6800',
    name: 'Libramont-Chevigny',
  },
  {
    code: '6800',
    name: 'Moircy',
  },
  {
    code: '6800',
    name: 'Recogne',
  },
  {
    code: '6800',
    name: 'Remagne',
  },
  {
    code: '6800',
    name: 'Saint-Pierre',
  },
  {
    code: '6800',
    name: 'Sainte-Marie-Chevigny',
  },
  {
    code: '6810',
    name: 'Chiny',
  },
  {
    code: '6810',
    name: 'Izel',
  },
  {
    code: '6810',
    name: 'Jamoigne',
  },
  {
    code: '6811',
    name: 'Les Bulles',
  },
  {
    code: '6812',
    name: 'Suxy',
  },
  {
    code: '6813',
    name: 'Termes',
  },
  {
    code: '6820',
    name: 'Florenville',
  },
  {
    code: '6820',
    name: 'Fontenoille',
  },
  {
    code: '6820',
    name: 'Muno',
  },
  {
    code: '6820',
    name: 'Sainte-Cécile',
  },
  {
    code: '6821',
    name: 'Lacuisine',
  },
  {
    code: '6823',
    name: 'Villers-Devant-Orval',
  },
  {
    code: '6824',
    name: 'Chassepierre',
  },
  {
    code: '6830',
    name: 'Bouillon',
  },
  {
    code: '6830',
    name: 'Les Hayons',
  },
  {
    code: '6830',
    name: 'Poupehan',
  },
  {
    code: '6830',
    name: 'Rochehaut',
  },
  {
    code: '6831',
    name: 'Noirfontaine',
  },
  {
    code: '6832',
    name: 'Sensenruth',
  },
  {
    code: '6833',
    name: 'Ucimont',
  },
  {
    code: '6833',
    name: 'Vivy',
  },
  {
    code: '6834',
    name: 'Bellevaux',
  },
  {
    code: '6836',
    name: 'Dohan',
  },
  {
    code: '6838',
    name: 'Corbion',
  },
  {
    code: '6840',
    name: 'Grandvoir',
  },
  {
    code: '6840',
    name: 'Grapfontaine',
  },
  {
    code: '6840',
    name: 'Hamipré',
  },
  {
    code: '6840',
    name: 'Longlier',
  },
  {
    code: '6840',
    name: 'Neufchâteau',
  },
  {
    code: '6840',
    name: 'Tournay',
  },
  {
    code: '6850',
    name: 'Carlsbourg',
  },
  {
    code: '6850',
    name: 'Offagne',
  },
  {
    code: '6850',
    name: 'Paliseul',
  },
  {
    code: '6851',
    name: 'Nollevaux',
  },
  {
    code: '6852',
    name: 'Maissin',
  },
  {
    code: '6852',
    name: 'Opont',
  },
  {
    code: '6853',
    name: 'Framont',
  },
  {
    code: '6856',
    name: 'Fays-Les-Veneurs',
  },
  {
    code: '6860',
    name: 'Assenois',
  },
  {
    code: '6860',
    name: 'Ebly',
  },
  {
    code: '6860',
    name: 'Léglise',
  },
  {
    code: '6860',
    name: 'Mellier',
  },
  {
    code: '6860',
    name: 'Witry',
  },
  {
    code: '6870',
    name: 'Arville',
  },
  {
    code: '6870',
    name: 'Awenne',
  },
  {
    code: '6870',
    name: 'Hatrival',
  },
  {
    code: '6870',
    name: 'Mirwart',
  },
  {
    code: '6870',
    name: 'Saint-Hubert',
    nameNL: 'Sint-Hubertus',
    nameFR: 'Saint-Hubert',
  },
  {
    code: '6870',
    name: 'Vesqueville',
  },
  {
    code: '6880',
    name: 'Auby-Sur-Semois',
  },
  {
    code: '6880',
    name: 'Bertrix',
  },
  {
    code: '6880',
    name: 'Cugnon',
  },
  {
    code: '6880',
    name: 'Jehonville',
  },
  {
    code: '6880',
    name: 'Orgeo',
  },
  {
    code: '6887',
    name: 'Herbeumont',
  },
  {
    code: '6887',
    name: 'Saint-Médard',
  },
  {
    code: '6887',
    name: 'Straimont',
  },
  {
    code: '6890',
    name: 'Anloy',
  },
  {
    code: '6890',
    name: 'Libin',
  },
  {
    code: '6890',
    name: 'Ochamps',
  },
  {
    code: '6890',
    name: 'Redu',
  },
  {
    code: '6890',
    name: 'Smuid',
  },
  {
    code: '6890',
    name: 'Transinne',
  },
  {
    code: '6890',
    name: 'Villance',
  },
  {
    code: '6900',
    name: 'Aye',
  },
  {
    code: '6900',
    name: 'Hargimont',
  },
  {
    code: '6900',
    name: 'Humain',
  },
  {
    code: '6900',
    name: 'Marche-En-Famenne',
  },
  {
    code: '6900',
    name: 'On',
  },
  {
    code: '6900',
    name: 'Roy',
  },
  {
    code: '6900',
    name: 'Waha',
  },
  {
    code: '6920',
    name: 'Sohier',
  },
  {
    code: '6920',
    name: 'Wellin',
  },
  {
    code: '6921',
    name: 'Chanly',
  },
  {
    code: '6922',
    name: 'Halma',
  },
  {
    code: '6924',
    name: 'Lomprez',
  },
  {
    code: '6927',
    name: 'Bure',
  },
  {
    code: '6927',
    name: 'Grupont',
  },
  {
    code: '6927',
    name: 'Resteigne',
  },
  {
    code: '6927',
    name: 'Tellin',
  },
  {
    code: '6929',
    name: 'Daverdisse',
  },
  {
    code: '6929',
    name: 'Gembes',
  },
  {
    code: '6929',
    name: 'Haut-Fays',
  },
  {
    code: '6929',
    name: 'Porcheresse',
  },
  {
    code: '6940',
    name: 'Barvaux-Sur-Ourthe',
  },
  {
    code: '6940',
    name: 'Durbuy',
  },
  {
    code: '6940',
    name: 'Grandhan',
    nameNL: 'Groothan',
    nameFR: 'Grandhan',
  },
  {
    code: '6940',
    name: 'Septon',
  },
  {
    code: '6940',
    name: 'Wéris',
  },
  {
    code: '6941',
    name: 'Bende',
  },
  {
    code: '6941',
    name: 'Bomal-Sur-Ourthe',
  },
  {
    code: '6941',
    name: 'Borlon',
  },
  {
    code: '6941',
    name: 'Heyd',
  },
  {
    code: '6941',
    name: 'Izier',
  },
  {
    code: '6941',
    name: 'Tohogne',
  },
  {
    code: '6941',
    name: 'Villers-Sainte-Gertrude',
  },
  {
    code: '6950',
    name: 'Harsin',
  },
  {
    code: '6950',
    name: 'Nassogne',
  },
  {
    code: '6951',
    name: 'Bande',
  },
  {
    code: '6952',
    name: 'Grune',
  },
  {
    code: '6953',
    name: 'Ambly',
  },
  {
    code: '6953',
    name: 'Forrières',
  },
  {
    code: '6953',
    name: 'Lesterny',
  },
  {
    code: '6953',
    name: 'Masbourg',
  },
  {
    code: '6960',
    name: 'Dochamps',
  },
  {
    code: '6960',
    name: 'Grandmenil',
    nameNL: 'Grootmenil',
    nameFR: 'Grandmenil',
  },
  {
    code: '6960',
    name: 'Harre',
  },
  {
    code: '6960',
    name: 'Malempré',
  },
  {
    code: '6960',
    name: 'Manhay',
  },
  {
    code: '6960',
    name: 'Odeigne',
  },
  {
    code: '6960',
    name: 'Vaux-Chavanne',
  },
  {
    code: '6970',
    name: 'Tenneville',
  },
  {
    code: '6971',
    name: 'Champlon',
  },
  {
    code: '6972',
    name: 'Erneuville',
  },
  {
    code: '6980',
    name: 'Beausaint',
  },
  {
    code: '6980',
    name: 'La Roche-En-Ardenne',
  },
  {
    code: '6982',
    name: 'Samrée',
  },
  {
    code: '6983',
    name: 'Ortho',
  },
  {
    code: '6984',
    name: 'Hives',
  },
  {
    code: '6986',
    name: 'Halleux',
  },
  {
    code: '6987',
    name: 'Beffe',
  },
  {
    code: '6987',
    name: 'Hodister',
  },
  {
    code: '6987',
    name: 'Marcourt',
  },
  {
    code: '6987',
    name: 'Rendeux',
  },
  {
    code: '6990',
    name: 'Fronville',
  },
  {
    code: '6990',
    name: 'Hampteau',
  },
  {
    code: '6990',
    name: 'Hotton',
  },
  {
    code: '6990',
    name: 'Marenne',
  },
  {
    code: '6997',
    name: 'Amonines',
  },
  {
    code: '6997',
    name: 'Erezée',
  },
  {
    code: '6997',
    name: 'Mormont',
  },
  {
    code: '6997',
    name: 'Soy',
  },
  {
    code: '7000',
    name: 'Mons',
    nameNL: 'Mons',
    nameFR: 'Bergen',
  },
  {
    code: '7010',
    name: 'Shape',
  },
  {
    code: '7011',
    name: 'Ghlin',
  },
  {
    code: '7012',
    name: 'Flénu',
  },
  {
    code: '7012',
    name: 'Jemappes',
  },
  {
    code: '7020',
    name: 'Maisières',
  },
  {
    code: '7020',
    name: 'Nimy',
  },
  {
    code: '7021',
    name: 'Havre',
  },
  {
    code: '7022',
    name: 'Harmignies',
  },
  {
    code: '7022',
    name: 'Harveng',
  },
  {
    code: '7022',
    name: 'Hyon',
  },
  {
    code: '7022',
    name: 'Mesvin',
  },
  {
    code: '7022',
    name: 'Nouvelles',
  },
  {
    code: '7024',
    name: 'Ciply',
  },
  {
    code: '7030',
    name: 'Saint-Symphorien',
  },
  {
    code: '7031',
    name: 'Villers-Saint-Ghislain',
  },
  {
    code: '7032',
    name: 'Spiennes',
  },
  {
    code: '7033',
    name: 'Cuesmes',
  },
  {
    code: '7034',
    name: 'Obourg',
  },
  {
    code: '7034',
    name: 'Saint-Denis',
  },
  {
    code: '7040',
    name: 'Asquillies',
  },
  {
    code: '7040',
    name: 'Aulnois',
  },
  {
    code: '7040',
    name: 'Blaregnies',
  },
  {
    code: '7040',
    name: 'Bougnies',
  },
  {
    code: '7040',
    name: 'Genly',
  },
  {
    code: '7040',
    name: 'Goegnies-Chaussée',
  },
  {
    code: '7040',
    name: 'Quévy',
  },
  {
    code: '7040',
    name: 'Quévy-Le-Grand',
    nameNL: 'Quévy-le-Grand',
    nameFR: 'Groot-Quevy',
  },
  {
    code: '7040',
    name: 'Quévy-Le-Petit',
  },
  {
    code: '7041',
    name: 'Givry',
  },
  {
    code: '7041',
    name: 'Havay',
  },
  {
    code: '7050',
    name: 'Erbaut',
  },
  {
    code: '7050',
    name: 'Erbisoeul',
  },
  {
    code: '7050',
    name: 'Herchies',
  },
  {
    code: '7050',
    name: 'Jurbise',
    nameNL: 'Jurbise',
    nameFR: 'Jurbeke',
  },
  {
    code: '7050',
    name: 'Masnuy-Saint-Jean',
  },
  {
    code: '7050',
    name: 'Masnuy-Saint-Pierre',
  },
  {
    code: '7060',
    name: 'Horrues',
  },
  {
    code: '7060',
    name: 'Soignies',
    nameNL: 'Soignies',
    nameFR: 'Zinnik',
  },
  {
    code: '7061',
    name: 'Casteau',
  },
  {
    code: '7061',
    name: 'Thieusies',
  },
  {
    code: '7062',
    name: 'Naast',
  },
  {
    code: '7063',
    name: 'Chaussée-Notre-Dame-Louvignies',
  },
  {
    code: '7063',
    name: 'Neufvilles',
  },
  {
    code: '7070',
    name: 'Gottignies',
  },
  {
    code: '7070',
    name: 'Le Roeulx',
  },
  {
    code: '7070',
    name: 'Mignault',
  },
  {
    code: '7070',
    name: 'Thieu',
  },
  {
    code: '7070',
    name: 'Ville-Sur-Haine',
  },
  {
    code: '7080',
    name: 'Eugies',
  },
  {
    code: '7080',
    name: 'Frameries',
  },
  {
    code: '7080',
    name: 'La Bouverie',
  },
  {
    code: '7080',
    name: 'Noirchain',
  },
  {
    code: '7080',
    name: 'Sars-La-Bruyère',
  },
  {
    code: '7090',
    name: 'Braine-Le-Comte',
    nameNL: 'Braine-le-Comte',
    nameFR: "Gravenbrakel ('s--)",
  },
  {
    code: '7090',
    name: 'Hennuyères',
  },
  {
    code: '7090',
    name: 'Henripont',
  },
  {
    code: '7090',
    name: 'Petit-Roeulx-Lez-Braine',
  },
  {
    code: '7090',
    name: 'Ronquières',
  },
  {
    code: '7090',
    name: 'Steenkerque',
    nameNL: 'Steenkerque',
    nameFR: 'Steenkerke',
  },
  {
    code: '7100',
    name: 'Haine-Saint-Paul',
  },
  {
    code: '7100',
    name: 'Haine-Saint-Pierre',
  },
  {
    code: '7100',
    name: 'La Louvière',
  },
  {
    code: '7100',
    name: 'Saint-Vaast',
  },
  {
    code: '7100',
    name: 'Trivières',
  },
  {
    code: '7110',
    name: 'Boussoit',
  },
  {
    code: '7110',
    name: 'Houdeng-Aimeries',
  },
  {
    code: '7110',
    name: 'Houdeng-Goegnies',
  },
  {
    code: '7110',
    name: 'Maurage',
  },
  {
    code: '7110',
    name: 'Strépy-Bracquegnies',
  },
  {
    code: '7120',
    name: 'Croix-Lez-Rouveroy',
  },
  {
    code: '7120',
    name: 'Estinnes',
  },
  {
    code: '7120',
    name: 'Estinnes-Au-Mont',
  },
  {
    code: '7120',
    name: 'Estinnes-Au-Val',
  },
  {
    code: '7120',
    name: 'Fauroeulx',
  },
  {
    code: '7120',
    name: 'Haulchin',
  },
  {
    code: '7120',
    name: 'Peissant',
  },
  {
    code: '7120',
    name: 'Rouveroy',
  },
  {
    code: '7120',
    name: 'Vellereille-Le-Sec',
  },
  {
    code: '7120',
    name: 'Vellereille-Les-Brayeux',
  },
  {
    code: '7130',
    name: 'Battignies',
  },
  {
    code: '7130',
    name: 'Binche',
    nameNL: 'Binche',
    nameFR: 'Bing',
  },
  {
    code: '7130',
    name: 'Bray',
  },
  {
    code: '7131',
    name: 'Waudrez',
  },
  {
    code: '7133',
    name: 'Buvrinnes',
  },
  {
    code: '7134',
    name: 'Epinois',
  },
  {
    code: '7134',
    name: 'Leval-Trahegnies',
  },
  {
    code: '7134',
    name: 'Péronnes-Lez-Binche',
  },
  {
    code: '7134',
    name: 'Ressaix',
  },
  {
    code: '7140',
    name: 'Morlanwelz',
  },
  {
    code: '7140',
    name: 'Morlanwelz-Mariemont',
  },
  {
    code: '7141',
    name: 'Carnières',
  },
  {
    code: '7141',
    name: 'Mont-Sainte-Aldegonde',
  },
  {
    code: '7160',
    name: 'Chapelle-Lez-Herlaimont',
  },
  {
    code: '7160',
    name: 'Godarville',
  },
  {
    code: '7160',
    name: 'Piéton',
  },
  {
    code: '7170',
    name: 'Bellecourt',
  },
  {
    code: '7170',
    name: "Bois-D'Haine",
  },
  {
    code: '7170',
    name: 'Fayt-Lez-Manage',
  },
  {
    code: '7170',
    name: 'La Hestre',
  },
  {
    code: '7170',
    name: 'Manage',
  },
  {
    code: '7180',
    name: 'Seneffe',
  },
  {
    code: '7181',
    name: 'Arquennes',
  },
  {
    code: '7181',
    name: 'Familleureux',
  },
  {
    code: '7181',
    name: 'Feluy',
  },
  {
    code: '7181',
    name: 'Petit-Roeulx-Lez-Nivelles',
  },
  {
    code: '7190',
    name: 'Ecaussinnes',
  },
  {
    code: '7190',
    name: "Ecaussinnes-D'Enghien",
  },
  {
    code: '7190',
    name: 'Marche-Lez-Ecaussinnes',
  },
  {
    code: '7191',
    name: 'Ecaussinnes-Lalaing',
  },
  {
    code: '7300',
    name: 'Boussu',
  },
  {
    code: '7301',
    name: 'Hornu',
  },
  {
    code: '7320',
    name: 'Bernissart',
  },
  {
    code: '7321',
    name: 'Blaton',
  },
  {
    code: '7321',
    name: 'Harchies',
  },
  {
    code: '7322',
    name: 'Pommeroeul',
  },
  {
    code: '7322',
    name: 'Ville-Pommeroeul',
  },
  {
    code: '7330',
    name: 'Saint-Ghislain',
  },
  {
    code: '7331',
    name: 'Baudour',
  },
  {
    code: '7332',
    name: 'Neufmaison',
  },
  {
    code: '7332',
    name: 'Sirault',
  },
  {
    code: '7333',
    name: 'Tertre',
  },
  {
    code: '7334',
    name: 'Hautrage',
  },
  {
    code: '7334',
    name: 'Villerot',
  },
  {
    code: '7340',
    name: 'Colfontaine',
  },
  {
    code: '7340',
    name: 'Paturages',
  },
  {
    code: '7340',
    name: 'Warquignies',
  },
  {
    code: '7340',
    name: 'Wasmes',
  },
  {
    code: '7350',
    name: 'Hainin',
  },
  {
    code: '7350',
    name: 'Hensies',
  },
  {
    code: '7350',
    name: 'Montroeul-Sur-Haine',
  },
  {
    code: '7350',
    name: 'Thulin',
  },
  {
    code: '7370',
    name: 'Blaugies',
  },
  {
    code: '7370',
    name: 'Dour',
  },
  {
    code: '7370',
    name: 'Elouges',
  },
  {
    code: '7370',
    name: 'Wihéries',
  },
  {
    code: '7380',
    name: 'Baisieux',
  },
  {
    code: '7380',
    name: 'Quiévrain',
  },
  {
    code: '7382',
    name: 'Audregnies',
  },
  {
    code: '7387',
    name: 'Angre',
  },
  {
    code: '7387',
    name: 'Angreau',
  },
  {
    code: '7387',
    name: 'Athis',
  },
  {
    code: '7387',
    name: 'Autreppe',
  },
  {
    code: '7387',
    name: 'Erquennes',
  },
  {
    code: '7387',
    name: 'Fayt-Le-Franc',
  },
  {
    code: '7387',
    name: 'Honnelles',
  },
  {
    code: '7387',
    name: 'Marchipont',
  },
  {
    code: '7387',
    name: 'Montignies-Sur-Roc',
  },
  {
    code: '7387',
    name: 'Onnezies',
  },
  {
    code: '7387',
    name: 'Roisin',
  },
  {
    code: '7390',
    name: 'Quaregnon',
  },
  {
    code: '7390',
    name: 'Wasmuel',
  },
  {
    code: '7500',
    name: 'Ere',
  },
  {
    code: '7500',
    name: 'Saint-Maur',
  },
  {
    code: '7500',
    name: 'Tournai',
    nameNL: 'Tournai',
    nameFR: 'Doornik',
  },
  {
    code: '7501',
    name: 'Orcq',
  },
  {
    code: '7502',
    name: 'Esplechin',
  },
  {
    code: '7503',
    name: 'Froyennes',
  },
  {
    code: '7504',
    name: 'Froidmont',
  },
  {
    code: '7506',
    name: 'Willemeau',
  },
  {
    code: '7510',
    name: '3 Suisses',
  },
  {
    code: '7511',
    name: 'Vitrine Magique',
  },
  {
    code: '7512',
    name: 'Yves Rocher',
  },
  {
    code: '7513',
    name: 'Yves Rocher',
  },
  {
    code: '7520',
    name: 'Ramegnies-Chin',
  },
  {
    code: '7520',
    name: 'Templeuve',
  },
  {
    code: '7521',
    name: 'Chercq',
  },
  {
    code: '7522',
    name: 'Blandain',
  },
  {
    code: '7522',
    name: 'Hertain',
  },
  {
    code: '7522',
    name: 'Lamain',
  },
  {
    code: '7522',
    name: 'Marquain',
  },
  {
    code: '7530',
    name: 'Gaurain-Ramecroix',
  },
  {
    code: '7531',
    name: 'Havinnes',
  },
  {
    code: '7532',
    name: 'Beclers',
  },
  {
    code: '7533',
    name: 'Thimougies',
  },
  {
    code: '7534',
    name: 'Barry',
  },
  {
    code: '7534',
    name: 'Maulde',
  },
  {
    code: '7536',
    name: 'Vaulx',
  },
  {
    code: '7538',
    name: 'Vezon',
  },
  {
    code: '7540',
    name: 'Kain',
  },
  {
    code: '7540',
    name: 'Melles',
  },
  {
    code: '7540',
    name: 'Quartes',
  },
  {
    code: '7540',
    name: 'Rumillies',
  },
  {
    code: '7542',
    name: 'Mont-Saint-Aubert',
  },
  {
    code: '7543',
    name: 'Mourcourt',
  },
  {
    code: '7548',
    name: 'Warchin',
  },
  {
    code: '7600',
    name: 'Péruwelz',
  },
  {
    code: '7601',
    name: 'Roucourt',
  },
  {
    code: '7602',
    name: 'Bury',
  },
  {
    code: '7603',
    name: 'Bon-Secours',
  },
  {
    code: '7604',
    name: 'Baugnies',
  },
  {
    code: '7604',
    name: 'Braffe',
  },
  {
    code: '7604',
    name: 'Brasmenil',
  },
  {
    code: '7604',
    name: 'Callenelle',
  },
  {
    code: '7604',
    name: 'Wasmes-Audemez-Briffoeil',
  },
  {
    code: '7608',
    name: 'Wiers',
  },
  {
    code: '7610',
    name: 'Rumes',
  },
  {
    code: '7611',
    name: 'La Glanerie',
  },
  {
    code: '7618',
    name: 'Taintignies',
  },
  {
    code: '7620',
    name: 'Bléharies',
  },
  {
    code: '7620',
    name: 'Brunehaut',
  },
  {
    code: '7620',
    name: 'Guignies',
  },
  {
    code: '7620',
    name: 'Hollain',
  },
  {
    code: '7620',
    name: 'Jollain-Merlin',
  },
  {
    code: '7620',
    name: 'Wez-Velvain',
  },
  {
    code: '7621',
    name: 'Lesdain',
  },
  {
    code: '7622',
    name: 'Laplaigne',
  },
  {
    code: '7623',
    name: 'Rongy',
  },
  {
    code: '7624',
    name: 'Howardries',
  },
  {
    code: '7640',
    name: 'Antoing',
  },
  {
    code: '7640',
    name: 'Maubray',
  },
  {
    code: '7640',
    name: 'Péronnes-Lez-Antoing',
  },
  {
    code: '7641',
    name: 'Bruyelle',
    nameNL: 'Bruyelle',
    nameFR: 'Briel',
  },
  {
    code: '7642',
    name: 'Calonne',
  },
  {
    code: '7643',
    name: 'Fontenoy',
  },
  {
    code: '7700',
    name: 'Luingne',
  },
  {
    code: '7700',
    name: 'Moeskroen',
  },
  {
    code: '7711',
    name: 'Dottenijs',
  },
  {
    code: '7712',
    name: 'Herseaux',
    nameNL: 'Herseaux',
    nameFR: 'Herseeuw',
  },
  {
    code: '7730',
    name: 'Bailleul',
  },
  {
    code: '7730',
    name: 'Estaimbourg',
  },
  {
    code: '7730',
    name: 'Estaimpuis',
    nameNL: 'Estaimpuis',
    nameFR: 'Steenput',
  },
  {
    code: '7730',
    name: 'Evregnies',
  },
  {
    code: '7730',
    name: 'Leers-Nord',
  },
  {
    code: '7730',
    name: 'Néchin',
  },
  {
    code: '7730',
    name: 'Saint-Léger',
  },
  {
    code: '7740',
    name: 'Pecq',
  },
  {
    code: '7740',
    name: 'Warcoing',
  },
  {
    code: '7742',
    name: 'Hérinnes-Lez-Pecq',
  },
  {
    code: '7743',
    name: 'Esquelmes',
  },
  {
    code: '7743',
    name: 'Obigies',
  },
  {
    code: '7750',
    name: 'Amougies',
    nameNL: 'Amougies',
    nameFR: 'Amengijs',
  },
  {
    code: '7750',
    name: 'Anseroeul',
  },
  {
    code: '7750',
    name: "Mont-De-L'Enclus",
    nameNL: "Mont-de-l'Enclus",
    nameFR: "Mont-de-l'Enclus",
  },
  {
    code: '7750',
    name: 'Orroir',
  },
  {
    code: '7750',
    name: 'Russeignies',
    nameNL: 'Russeignies',
    nameFR: 'Rozenaken',
  },
  {
    code: '7760',
    name: 'Celles',
  },
  {
    code: '7760',
    name: 'Escanaffles',
    nameNL: 'Escanaffles',
    nameFR: 'Schalafie',
  },
  {
    code: '7760',
    name: 'Molenbaix',
  },
  {
    code: '7760',
    name: 'Popuelles',
  },
  {
    code: '7760',
    name: 'Pottes',
  },
  {
    code: '7760',
    name: 'Velaines',
  },
  {
    code: '7780',
    name: 'Komen',
  },
  {
    code: '7780',
    name: 'Komen-Waasten',
  },
  {
    code: '7781',
    name: 'Houthem',
  },
  {
    code: '7782',
    name: 'Ploegsteert',
  },
  {
    code: '7783',
    name: 'Bizet',
  },
  {
    code: '7784',
    name: 'Neerwaasten',
  },
  {
    code: '7784',
    name: 'Waasten',
  },
  {
    code: '7800',
    name: 'Ath',
    nameNL: 'Ath',
    nameFR: 'Aat',
  },
  {
    code: '7800',
    name: 'Lanquesaint',
  },
  {
    code: '7801',
    name: 'Irchonwelz',
  },
  {
    code: '7802',
    name: 'Ormeignies',
  },
  {
    code: '7803',
    name: 'Bouvignies',
  },
  {
    code: '7804',
    name: 'Ostiches',
  },
  {
    code: '7804',
    name: 'Rebaix',
  },
  {
    code: '7810',
    name: 'Maffle',
  },
  {
    code: '7811',
    name: 'Arbre',
  },
  {
    code: '7812',
    name: 'Houtaing',
  },
  {
    code: '7812',
    name: 'Ligne',
  },
  {
    code: '7812',
    name: 'Mainvault',
  },
  {
    code: '7812',
    name: 'Moulbaix',
  },
  {
    code: '7812',
    name: 'Villers-Notre-Dame',
  },
  {
    code: '7812',
    name: 'Villers-Saint-Amand',
  },
  {
    code: '7822',
    name: 'Ghislenghien',
    nameNL: 'Ghislenghien',
    nameFR: 'Gellingen',
  },
  {
    code: '7822',
    name: 'Isières',
  },
  {
    code: '7822',
    name: "Meslin-L'Evêque",
  },
  {
    code: '7823',
    name: 'Gibecq',
  },
  {
    code: '7830',
    name: 'Bassilly',
    nameNL: 'Bassilly',
    nameFR: 'Zullik',
  },
  {
    code: '7830',
    name: 'Fouleng',
  },
  {
    code: '7830',
    name: 'Gondregnies',
  },
  {
    code: '7830',
    name: 'Graty',
  },
  {
    code: '7830',
    name: 'Hellebecq',
  },
  {
    code: '7830',
    name: 'Hoves',
    nameNL: 'Hoves',
    nameFR: 'Hove',
  },
  {
    code: '7830',
    name: 'Silly',
    nameNL: 'Silly',
    nameFR: 'Opzullik',
  },
  {
    code: '7830',
    name: 'Thoricourt',
  },
  {
    code: '7850',
    name: 'Edingen',
  },
  {
    code: '7850',
    name: 'Lettelingen',
  },
  {
    code: '7850',
    name: 'Mark',
  },
  {
    code: '7860',
    name: 'Lessines',
  },
  {
    code: '7861',
    name: 'Papignies',
    nameNL: 'Papignies',
    nameFR: 'Papegem',
  },
  {
    code: '7861',
    name: 'Wannebecq',
  },
  {
    code: '7862',
    name: 'Ogy',
  },
  {
    code: '7863',
    name: 'Ghoy',
  },
  {
    code: '7864',
    name: 'Deux-Acren',
  },
  {
    code: '7866',
    name: 'Bois-De-Lessines',
    nameNL: 'Bois-de-Lessines',
    nameFR: 'Lessenbos',
  },
  {
    code: '7866',
    name: 'Ollignies',
    nameNL: 'Ollignies',
    nameFR: 'Woelingen',
  },
  {
    code: '7870',
    name: 'Bauffe',
  },
  {
    code: '7870',
    name: 'Cambron-Saint-Vincent',
  },
  {
    code: '7870',
    name: 'Lens',
  },
  {
    code: '7870',
    name: 'Lombise',
  },
  {
    code: '7870',
    name: 'Montignies-Lez-Lens',
  },
  {
    code: '7880',
    name: 'Vloesberg',
  },
  {
    code: '7890',
    name: 'Ellezelles',
    nameNL: 'Ellezelles',
    nameFR: 'Elzele',
  },
  {
    code: '7890',
    name: 'Lahamaide',
  },
  {
    code: '7890',
    name: 'Wodecq',
  },
  {
    code: '7900',
    name: 'Grandmetz',
  },
  {
    code: '7900',
    name: 'Leuze-En-Hainaut',
  },
  {
    code: '7901',
    name: 'Thieulain',
  },
  {
    code: '7903',
    name: 'Blicquy',
  },
  {
    code: '7903',
    name: 'Chapelle-À-Oie',
  },
  {
    code: '7903',
    name: 'Chapelle-À-Wattines',
  },
  {
    code: '7904',
    name: 'Pipaix',
  },
  {
    code: '7904',
    name: 'Tourpes',
  },
  {
    code: '7904',
    name: 'Willaupuis',
  },
  {
    code: '7906',
    name: 'Gallaix',
  },
  {
    code: '7910',
    name: 'Anvaing',
  },
  {
    code: '7910',
    name: 'Arc-Ainières',
  },
  {
    code: '7910',
    name: 'Arc-Wattripont',
  },
  {
    code: '7910',
    name: 'Cordes',
  },
  {
    code: '7910',
    name: 'Ellignies-Lez-Frasnes',
  },
  {
    code: '7910',
    name: 'Forest',
  },
  {
    code: '7910',
    name: 'Frasnes-Lez-Anvaing',
  },
  {
    code: '7910',
    name: 'Wattripont',
  },
  {
    code: '7911',
    name: 'Buissenal',
  },
  {
    code: '7911',
    name: 'Frasnes-Lez-Buissenal',
  },
  {
    code: '7911',
    name: 'Hacquegnies',
  },
  {
    code: '7911',
    name: 'Herquegies',
  },
  {
    code: '7911',
    name: 'Montroeul-Au-Bois',
  },
  {
    code: '7911',
    name: 'Moustier',
  },
  {
    code: '7911',
    name: 'Oeudeghien',
  },
  {
    code: '7912',
    name: 'Dergneau',
  },
  {
    code: '7912',
    name: 'Saint-Sauveur',
  },
  {
    code: '7940',
    name: 'Brugelette',
  },
  {
    code: '7940',
    name: 'Cambron-Casteau',
  },
  {
    code: '7941',
    name: 'Attre',
  },
  {
    code: '7942',
    name: 'Mévergnies-Lez-Lens',
  },
  {
    code: '7943',
    name: 'Gages',
  },
  {
    code: '7950',
    name: 'Chièvres',
  },
  {
    code: '7950',
    name: 'Grosage',
  },
  {
    code: '7950',
    name: 'Huissignies',
  },
  {
    code: '7950',
    name: 'Ladeuze',
  },
  {
    code: '7950',
    name: 'Tongre-Saint-Martin',
  },
  {
    code: '7951',
    name: 'Tongre-Notre-Dame',
    nameNL: 'Tongre-Notre-Dame',
    nameFR: 'Onze Lieve Vrouw-Tongeren',
  },
  {
    code: '7970',
    name: 'Beloeil',
  },
  {
    code: '7971',
    name: 'Basècles',
  },
  {
    code: '7971',
    name: 'Ramegnies',
  },
  {
    code: '7971',
    name: 'Thumaide',
  },
  {
    code: '7971',
    name: 'Wadelincourt',
  },
  {
    code: '7972',
    name: 'Aubechies',
  },
  {
    code: '7972',
    name: 'Ellignies-Saint-Anne',
  },
  {
    code: '7972',
    name: 'Quevaucamps',
  },
  {
    code: '7973',
    name: 'Grandglise',
  },
  {
    code: '7973',
    name: 'Stambruges',
  },
  {
    code: '8000',
    name: 'Brugge',
    nameNL: 'Brugge',
    nameFR: 'Bruges',
  },
  {
    code: '8000',
    name: 'Koolkerke',
  },
  {
    code: '8020',
    name: 'Hertsberge',
  },
  {
    code: '8020',
    name: 'Oostkamp',
  },
  {
    code: '8020',
    name: 'Ruddervoorde',
  },
  {
    code: '8020',
    name: 'Waardamme',
  },
  {
    code: '8200',
    name: 'Sint-Andries',
    nameNL: 'Sint-Andries',
    nameFR: 'Saint-André',
  },
  {
    code: '8200',
    name: 'Sint-Michiels',
    nameNL: 'Sint-Michiels',
    nameFR: 'Saint-Michel',
  },
  {
    code: '8210',
    name: 'Loppem',
  },
  {
    code: '8210',
    name: 'Veldegem',
  },
  {
    code: '8210',
    name: 'Zedelgem',
  },
  {
    code: '8211',
    name: 'Aartrijke',
  },
  {
    code: '8300',
    name: 'Knokke',
  },
  {
    code: '8300',
    name: 'Knokke-Heist',
  },
  {
    code: '8300',
    name: 'Westkapelle',
  },
  {
    code: '8301',
    name: 'Heist-Aan-Zee',
  },
  {
    code: '8301',
    name: 'Ramskapelle',
  },
  {
    code: '8310',
    name: 'Assebroek',
  },
  {
    code: '8310',
    name: 'Sint-Kruis',
    nameNL: 'Sint-Kruis',
    nameFR: 'Sainte-Croix',
  },
  {
    code: '8340',
    name: 'Damme',
  },
  {
    code: '8340',
    name: 'Hoeke',
    nameNL: 'Hoeke',
    nameFR: 'Houcke',
  },
  {
    code: '8340',
    name: 'Lapscheure',
  },
  {
    code: '8340',
    name: 'Moerkerke',
  },
  {
    code: '8340',
    name: 'Oostkerke',
  },
  {
    code: '8340',
    name: 'Sijsele',
  },
  {
    code: '8370',
    name: 'Blankenberge',
  },
  {
    code: '8370',
    name: 'Uitkerke',
  },
  {
    code: '8377',
    name: 'Houtave',
  },
  {
    code: '8377',
    name: 'Meetkerke',
  },
  {
    code: '8377',
    name: 'Nieuwmunster',
  },
  {
    code: '8377',
    name: 'Zuienkerke',
  },
  {
    code: '8380',
    name: 'Dudzele',
  },
  {
    code: '8380',
    name: 'Lissewege',
  },
  {
    code: '8380',
    name: 'Zeebrugge',
  },
  {
    code: '8400',
    name: 'Oostende',
    nameNL: 'Oostende',
    nameFR: 'Ostende',
  },
  {
    code: '8400',
    name: 'Stene',
  },
  {
    code: '8400',
    name: 'Zandvoorde',
  },
  {
    code: '8420',
    name: 'De Haan',
    nameNL: 'De Haan',
    nameFR: 'Le Coq',
  },
  {
    code: '8420',
    name: 'Klemskerke',
  },
  {
    code: '8420',
    name: 'Wenduine',
  },
  {
    code: '8421',
    name: 'Vlissegem',
  },
  {
    code: '8430',
    name: 'Middelkerke',
  },
  {
    code: '8431',
    name: 'Wilskerke',
  },
  {
    code: '8432',
    name: 'Leffinge',
  },
  {
    code: '8433',
    name: 'Mannekensvere',
  },
  {
    code: '8433',
    name: 'Schore',
  },
  {
    code: '8433',
    name: 'Sint-Pieters-Kapelle',
  },
  {
    code: '8433',
    name: 'Slijpe',
  },
  {
    code: '8434',
    name: 'Lombardsijde',
  },
  {
    code: '8434',
    name: 'Westende',
  },
  {
    code: '8450',
    name: 'Bredene',
  },
  {
    code: '8460',
    name: 'Ettelgem',
  },
  {
    code: '8460',
    name: 'Oudenburg',
  },
  {
    code: '8460',
    name: 'Roksem',
  },
  {
    code: '8460',
    name: 'Westkerke',
  },
  {
    code: '8470',
    name: 'Gistel',
    nameNL: 'Gistel',
    nameFR: 'Ghistelles',
  },
  {
    code: '8470',
    name: 'Moere',
  },
  {
    code: '8470',
    name: 'Snaaskerke',
  },
  {
    code: '8470',
    name: 'Zevekote',
  },
  {
    code: '8480',
    name: 'Bekegem',
  },
  {
    code: '8480',
    name: 'Eernegem',
  },
  {
    code: '8480',
    name: 'Ichtegem',
  },
  {
    code: '8490',
    name: 'Jabbeke',
  },
  {
    code: '8490',
    name: 'Snellegem',
  },
  {
    code: '8490',
    name: 'Stalhille',
  },
  {
    code: '8490',
    name: 'Varsenare',
  },
  {
    code: '8490',
    name: 'Zerkegem',
  },
  {
    code: '8500',
    name: 'Kortrijk',
    nameNL: 'Kortrijk',
    nameFR: 'Courtrai',
  },
  {
    code: '8501',
    name: 'Bissegem',
  },
  {
    code: '8501',
    name: 'Heule',
  },
  {
    code: '8510',
    name: 'Bellegem',
  },
  {
    code: '8510',
    name: 'Kooigem',
  },
  {
    code: '8510',
    name: 'Marke',
  },
  {
    code: '8510',
    name: 'Rollegem',
  },
  {
    code: '8511',
    name: 'Aalbeke',
  },
  {
    code: '8520',
    name: 'Kuurne',
  },
  {
    code: '8530',
    name: 'Harelbeke',
    nameNL: 'Harelbeke',
    nameFR: 'Harlebeke',
  },
  {
    code: '8531',
    name: 'Bavikhove',
  },
  {
    code: '8531',
    name: 'Hulste',
  },
  {
    code: '8540',
    name: 'Deerlijk',
  },
  {
    code: '8550',
    name: 'Zwevegem',
  },
  {
    code: '8551',
    name: 'Heestert',
  },
  {
    code: '8552',
    name: 'Moen',
  },
  {
    code: '8553',
    name: 'Otegem',
  },
  {
    code: '8554',
    name: 'Sint-Denijs',
  },
  {
    code: '8560',
    name: 'Gullegem',
  },
  {
    code: '8560',
    name: 'Moorsele',
  },
  {
    code: '8560',
    name: 'Wevelgem',
  },
  {
    code: '8570',
    name: 'Anzegem',
  },
  {
    code: '8570',
    name: 'Gijzelbrechtegem',
  },
  {
    code: '8570',
    name: 'Ingooigem',
  },
  {
    code: '8570',
    name: 'Vichte',
  },
  {
    code: '8572',
    name: 'Kaster',
  },
  {
    code: '8573',
    name: 'Tiegem',
  },
  {
    code: '8580',
    name: 'Avelgem',
  },
  {
    code: '8581',
    name: 'Kerkhove',
  },
  {
    code: '8581',
    name: 'Waarmaarde',
  },
  {
    code: '8582',
    name: 'Outrijve',
    nameNL: 'Outrijve',
    nameFR: 'Autrijve',
  },
  {
    code: '8583',
    name: 'Bossuit',
  },
  {
    code: '8587',
    name: 'Helkijn',
  },
  {
    code: '8587',
    name: 'Spiere',
    nameNL: 'Spiere',
    nameFR: 'Espierres',
  },
  {
    code: '8587',
    name: 'Spiere-Helkijn',
    nameNL: 'Spiere-Helkijn',
    nameFR: 'Espierres-Helchin',
  },
  {
    code: '8600',
    name: 'Beerst',
  },
  {
    code: '8600',
    name: 'Diksmuide',
    nameNL: 'Diksmuide',
    nameFR: 'Dixmude',
  },
  {
    code: '8600',
    name: 'Driekapellen',
  },
  {
    code: '8600',
    name: 'Esen',
    nameNL: 'Esen',
    nameFR: 'Eessen',
  },
  {
    code: '8600',
    name: 'Kaaskerke',
  },
  {
    code: '8600',
    name: 'Keiem',
  },
  {
    code: '8600',
    name: 'Lampernisse',
  },
  {
    code: '8600',
    name: 'Leke',
  },
  {
    code: '8600',
    name: 'Nieuwkapelle',
    nameNL: 'Nieuwkapelle',
    nameFR: 'Nieucapelle',
  },
  {
    code: '8600',
    name: 'Oostkerke',
  },
  {
    code: '8600',
    name: 'Oudekapelle',
  },
  {
    code: '8600',
    name: 'Pervijze',
  },
  {
    code: '8600',
    name: 'Sint-Jacobs-Kapelle',
    nameNL: 'Sint-Jacobs-Kapelle',
    nameFR: 'Saint-Jacques-Capelle',
  },
  {
    code: '8600',
    name: 'Stuivekenskerke',
  },
  {
    code: '8600',
    name: 'Vladslo',
  },
  {
    code: '8600',
    name: 'Woumen',
  },
  {
    code: '8610',
    name: 'Handzame',
  },
  {
    code: '8610',
    name: 'Kortemark',
  },
  {
    code: '8610',
    name: 'Werken',
  },
  {
    code: '8610',
    name: 'Zarren',
  },
  {
    code: '8620',
    name: 'Nieuwpoort',
    nameNL: 'Nieuwpoort',
    nameFR: 'Nieuport',
  },
  {
    code: '8620',
    name: 'Ramskapelle',
  },
  {
    code: '8620',
    name: 'Sint-Joris',
    nameNL: 'Sint-Joris',
    nameFR: 'Saint-Georges',
  },
  {
    code: '8630',
    name: 'Avekapelle',
    nameNL: 'Avekapelle',
    nameFR: 'Avecappelle',
  },
  {
    code: '8630',
    name: 'Booitshoeke',
  },
  {
    code: '8630',
    name: 'Bulskamp',
  },
  {
    code: '8630',
    name: 'De Moeren',
  },
  {
    code: '8630',
    name: 'Eggewaartskapelle',
  },
  {
    code: '8630',
    name: 'Houtem',
  },
  {
    code: '8630',
    name: 'Steenkerke',
  },
  {
    code: '8630',
    name: 'Veurne',
    nameNL: 'Veurne',
    nameFR: 'Furnes',
  },
  {
    code: '8630',
    name: 'Vinkem',
  },
  {
    code: '8630',
    name: 'Wulveringem',
  },
  {
    code: '8630',
    name: 'Zoutenaaie',
  },
  {
    code: '8640',
    name: 'Oostvleteren',
  },
  {
    code: '8640',
    name: 'Vleteren',
  },
  {
    code: '8640',
    name: 'Westvleteren',
  },
  {
    code: '8640',
    name: 'Woesten',
  },
  {
    code: '8647',
    name: 'Lo',
  },
  {
    code: '8647',
    name: 'Lo-Reninge',
  },
  {
    code: '8647',
    name: 'Noordschote',
  },
  {
    code: '8647',
    name: 'Pollinkhove',
  },
  {
    code: '8647',
    name: 'Reninge',
  },
  {
    code: '8650',
    name: 'Houthulst',
  },
  {
    code: '8650',
    name: 'Klerken',
  },
  {
    code: '8650',
    name: 'Merkem',
  },
  {
    code: '8660',
    name: 'Adinkerke',
  },
  {
    code: '8660',
    name: 'De Panne',
    nameNL: 'De Panne',
    nameFR: 'La Panne',
  },
  {
    code: '8670',
    name: 'Koksijde',
  },
  {
    code: '8670',
    name: 'Oostduinkerke',
  },
  {
    code: '8670',
    name: 'Wulpen',
  },
  {
    code: '8680',
    name: 'Bovekerke',
  },
  {
    code: '8680',
    name: 'Koekelare',
  },
  {
    code: '8680',
    name: 'Zande',
  },
  {
    code: '8690',
    name: 'Alveringem',
  },
  {
    code: '8690',
    name: 'Hoogstade',
  },
  {
    code: '8690',
    name: 'Oeren',
  },
  {
    code: '8690',
    name: 'Sint-Rijkers',
    nameNL: 'Sint-Rijkers',
    nameFR: 'Saint-Riquier',
  },
  {
    code: '8691',
    name: 'Beveren-Aan-De-Ijzer',
  },
  {
    code: '8691',
    name: 'Gijverinkhove',
  },
  {
    code: '8691',
    name: 'Izenberge',
  },
  {
    code: '8691',
    name: 'Leisele',
  },
  {
    code: '8691',
    name: 'Stavele',
  },
  {
    code: '8700',
    name: 'Aarsele',
  },
  {
    code: '8700',
    name: 'Kanegem',
  },
  {
    code: '8700',
    name: 'Schuiferskapelle',
  },
  {
    code: '8700',
    name: 'Tielt',
  },
  {
    code: '8710',
    name: 'Ooigem',
  },
  {
    code: '8710',
    name: 'Sint-Baafs-Vijve',
    nameNL: 'Sint-Baafs-Vijve',
    nameFR: 'Vive-Saint-Bavon',
  },
  {
    code: '8710',
    name: 'Wielsbeke',
  },
  {
    code: '8720',
    name: 'Dentergem',
  },
  {
    code: '8720',
    name: 'Markegem',
  },
  {
    code: '8720',
    name: 'Oeselgem',
  },
  {
    code: '8720',
    name: 'Wakken',
  },
  {
    code: '8730',
    name: 'Beernem',
  },
  {
    code: '8730',
    name: 'Oedelem',
  },
  {
    code: '8730',
    name: 'Sint-Joris',
  },
  {
    code: '8740',
    name: 'Egem',
  },
  {
    code: '8740',
    name: 'Pittem',
  },
  {
    code: '8750',
    name: 'Wingene',
  },
  {
    code: '8750',
    name: 'Zwevezele',
  },
  {
    code: '8755',
    name: 'Wingene',
  },
  {
    code: '8760',
    name: 'Tielt',
  },
  {
    code: '8770',
    name: 'Ingelmunster',
  },
  {
    code: '8780',
    name: 'Oostrozebeke',
  },
  {
    code: '8790',
    name: 'Waregem',
  },
  {
    code: '8791',
    name: 'Beveren',
  },
  {
    code: '8792',
    name: 'Desselgem',
  },
  {
    code: '8793',
    name: 'Sint-Eloois-Vijve',
    nameNL: 'Sint-Eloois-Vijve',
    nameFR: 'Vive-Saint-Eloi',
  },
  {
    code: '8800',
    name: 'Beveren',
  },
  {
    code: '8800',
    name: 'Oekene',
  },
  {
    code: '8800',
    name: 'Roeselare',
    nameNL: 'Roeselare',
    nameFR: 'Roulers',
  },
  {
    code: '8800',
    name: 'Rumbeke',
  },
  {
    code: '8810',
    name: 'Lichtervelde',
  },
  {
    code: '8820',
    name: 'Torhout',
    nameNL: 'Torhout',
    nameFR: 'Thourout',
  },
  {
    code: '8830',
    name: 'Gits',
  },
  {
    code: '8830',
    name: 'Hooglede',
  },
  {
    code: '8840',
    name: 'Oostnieuwkerke',
  },
  {
    code: '8840',
    name: 'Staden',
  },
  {
    code: '8840',
    name: 'Westrozebeke',
  },
  {
    code: '8850',
    name: 'Ardooie',
  },
  {
    code: '8851',
    name: 'Koolskamp',
  },
  {
    code: '8860',
    name: 'Lendelede',
  },
  {
    code: '8870',
    name: 'Emelgem',
  },
  {
    code: '8870',
    name: 'Izegem',
  },
  {
    code: '8870',
    name: 'Kachtem',
  },
  {
    code: '8880',
    name: 'Ledegem',
  },
  {
    code: '8880',
    name: 'Rollegem-Kapelle',
  },
  {
    code: '8880',
    name: 'Sint-Eloois-Winkel',
    nameNL: 'Sint-Eloois-Winkel',
    nameFR: 'Winckel-Saint-Eloi',
  },
  {
    code: '8890',
    name: 'Dadizele',
  },
  {
    code: '8890',
    name: 'Moorslede',
  },
  {
    code: '8900',
    name: 'Brielen',
  },
  {
    code: '8900',
    name: 'Dikkebus',
  },
  {
    code: '8900',
    name: 'Ieper',
    nameNL: 'Ieper',
    nameFR: 'Ypres',
  },
  {
    code: '8900',
    name: 'Sint-Jan',
    nameNL: 'Sint-Jan',
    nameFR: 'Saint-Jean',
  },
  {
    code: '8902',
    name: 'Hollebeke',
  },
  {
    code: '8902',
    name: 'Voormezele',
  },
  {
    code: '8902',
    name: 'Zillebeke',
  },
  {
    code: '8904',
    name: 'Boezinge',
  },
  {
    code: '8904',
    name: 'Zuidschote',
  },
  {
    code: '8906',
    name: 'Elverdinge',
  },
  {
    code: '8908',
    name: 'Vlamertinge',
  },
  {
    code: '8920',
    name: 'Bikschote',
    nameNL: 'Bikschote',
    nameFR: 'Bixcote',
  },
  {
    code: '8920',
    name: 'Langemark',
  },
  {
    code: '8920',
    name: 'Langemark-Poelkapelle',
  },
  {
    code: '8920',
    name: 'Poelkapelle',
  },
  {
    code: '8930',
    name: 'Lauwe',
  },
  {
    code: '8930',
    name: 'Menen',
    nameNL: 'Menen',
    nameFR: 'Menin',
  },
  {
    code: '8930',
    name: 'Rekkem',
    nameNL: 'Rekkem',
    nameFR: 'Recheim',
  },
  {
    code: '8940',
    name: 'Geluwe',
  },
  {
    code: '8940',
    name: 'Wervik',
  },
  {
    code: '8950',
    name: 'Heuvelland',
  },
  {
    code: '8950',
    name: 'Nieuwkerke',
    nameNL: 'Nieuwkerke',
    nameFR: 'Neuve-Eglise',
  },
  {
    code: '8951',
    name: 'Dranouter',
  },
  {
    code: '8952',
    name: 'Wulvergem',
  },
  {
    code: '8953',
    name: 'Wijtschate',
  },
  {
    code: '8954',
    name: 'Westouter',
  },
  {
    code: '8956',
    name: 'Kemmel',
  },
  {
    code: '8957',
    name: 'Mesen',
    nameNL: 'Mesen',
    nameFR: 'Messines',
  },
  {
    code: '8958',
    name: 'Loker',
    nameNL: 'Loker',
    nameFR: 'Locre',
  },
  {
    code: '8970',
    name: 'Poperinge',
  },
  {
    code: '8970',
    name: 'Reningelst',
  },
  {
    code: '8972',
    name: 'Krombeke',
  },
  {
    code: '8972',
    name: 'Proven',
  },
  {
    code: '8972',
    name: 'Roesbrugge-Haringe',
  },
  {
    code: '8978',
    name: 'Watou',
  },
  {
    code: '8980',
    name: 'Beselare',
  },
  {
    code: '8980',
    name: 'Geluveld',
  },
  {
    code: '8980',
    name: 'Passendale',
  },
  {
    code: '8980',
    name: 'Zandvoorde',
  },
  {
    code: '8980',
    name: 'Zonnebeke',
  },
  {
    code: '9000',
    name: 'Gent',
    nameNL: 'Gent',
    nameFR: 'Gand',
  },
  {
    code: '9030',
    name: 'Mariakerke',
  },
  {
    code: '9031',
    name: 'Drongen',
    nameNL: 'Drongen',
    nameFR: 'Tronchiennes',
  },
  {
    code: '9032',
    name: 'Wondelgem',
  },
  {
    code: '9040',
    name: 'Sint-Amandsberg',
    nameNL: 'Sint-Amandsberg',
    nameFR: 'Mont-Saint-Amand',
  },
  {
    code: '9041',
    name: 'Oostakker',
  },
  {
    code: '9042',
    name: 'Desteldonk',
  },
  {
    code: '9042',
    name: 'Mendonk',
  },
  {
    code: '9042',
    name: 'Sint-Kruis-Winkel',
    nameNL: 'Sint-Kruis-Winkel',
    nameFR: 'Winckel-Sainte-Croix',
  },
  {
    code: '9050',
    name: 'Gentbrugge',
  },
  {
    code: '9050',
    name: 'Ledeberg',
  },
  {
    code: '9051',
    name: 'Afsnee',
  },
  {
    code: '9051',
    name: 'Sint-Denijs-Westrem',
    nameNL: 'Sint-Denijs-Westrem',
    nameFR: 'Saint-Denis-Westrem',
  },
  {
    code: '9052',
    name: 'Zwijnaarde',
  },
  {
    code: '9060',
    name: 'Zelzate',
  },
  {
    code: '9070',
    name: 'Destelbergen',
  },
  {
    code: '9070',
    name: 'Heusden',
  },
  {
    code: '9075',
    name: 'CSM Gent X',
  },
  {
    code: '9080',
    name: 'Beervelde',
  },
  {
    code: '9080',
    name: 'Lochristi',
  },
  {
    code: '9080',
    name: 'Zaffelare',
  },
  {
    code: '9080',
    name: 'Zeveneken',
  },
  {
    code: '9090',
    name: 'Gontrode',
  },
  {
    code: '9090',
    name: 'Merelbeke-Melle',
  },
  {
    code: '9099',
    name: 'Gent X',
  },
  {
    code: '9100',
    name: 'Nieuwkerken-Waas',
  },
  {
    code: '9100',
    name: 'Sint-Niklaas',
    nameNL: 'Sint-Niklaas',
    nameFR: 'Saint-Nicolas',
  },
  {
    code: '9111',
    name: 'Belsele',
  },
  {
    code: '9112',
    name: 'Sinaai-Waas',
  },
  {
    code: '9120',
    name: 'Beveren-Kruibeke-Zwijndrecht',
  },
  {
    code: '9120',
    name: 'Haasdonk',
  },
  {
    code: '9120',
    name: 'Kallo',
  },
  {
    code: '9120',
    name: 'Melsele',
  },
  {
    code: '9120',
    name: 'Vrasene',
  },
  {
    code: '9130',
    name: 'Beveren-Kruibeke-Zwijndrecht',
  },
  {
    code: '9130',
    name: 'Doel',
  },
  {
    code: '9130',
    name: 'Kallo',
  },
  {
    code: '9130',
    name: 'Kieldrecht',
  },
  {
    code: '9130',
    name: 'Verrebroek',
  },
  {
    code: '9140',
    name: 'Elversele',
  },
  {
    code: '9140',
    name: 'Steendorp',
  },
  {
    code: '9140',
    name: 'Temse',
    nameNL: 'Temse',
    nameFR: 'Tamise',
  },
  {
    code: '9140',
    name: 'Tielrode',
  },
  {
    code: '9150',
    name: 'Bazel',
  },
  {
    code: '9150',
    name: 'Beveren-Kruibeke-Zwijndrecht',
  },
  {
    code: '9150',
    name: 'Rupelmonde',
  },
  {
    code: '9160',
    name: 'Daknam',
  },
  {
    code: '9160',
    name: 'Eksaarde',
  },
  {
    code: '9160',
    name: 'Lokeren',
  },
  {
    code: '9170',
    name: 'De Klinge',
  },
  {
    code: '9170',
    name: 'Meerdonk',
  },
  {
    code: '9170',
    name: 'Sint-Gillis-Waas',
    nameNL: 'Sint-Gillis-Waas',
    nameFR: 'Saint-Gilles-Waes',
  },
  {
    code: '9170',
    name: 'Sint-Pauwels',
    nameNL: 'Sint-Pauwels',
    nameFR: 'Saint-Paul',
  },
  {
    code: '9180',
    name: 'Lokeren',
  },
  {
    code: '9185',
    name: 'Lochristi',
  },
  {
    code: '9190',
    name: 'Kemzeke',
  },
  {
    code: '9190',
    name: 'Stekene',
  },
  {
    code: '9200',
    name: 'Appels',
  },
  {
    code: '9200',
    name: 'Baasrode',
  },
  {
    code: '9200',
    name: 'Dendermonde',
  },
  {
    code: '9200',
    name: 'Grembergen',
  },
  {
    code: '9200',
    name: 'Mespelare',
  },
  {
    code: '9200',
    name: 'Oudegem',
  },
  {
    code: '9200',
    name: 'Schoonaarde',
  },
  {
    code: '9200',
    name: 'Sint-Gillis-Dendermonde',
  },
  {
    code: '9220',
    name: 'Hamme',
  },
  {
    code: '9220',
    name: 'Moerzeke',
  },
  {
    code: '9230',
    name: 'Massemen',
  },
  {
    code: '9230',
    name: 'Westrem',
  },
  {
    code: '9230',
    name: 'Wetteren',
  },
  {
    code: '9240',
    name: 'Zele',
  },
  {
    code: '9250',
    name: 'Waasmunster',
  },
  {
    code: '9255',
    name: 'Buggenhout',
  },
  {
    code: '9255',
    name: 'Opdorp',
  },
  {
    code: '9260',
    name: 'Schellebelle',
  },
  {
    code: '9260',
    name: 'Serskamp',
    nameNL: 'Serskamp',
    nameFR: 'Cherskamp',
  },
  {
    code: '9260',
    name: 'Wichelen',
  },
  {
    code: '9270',
    name: 'Kalken',
  },
  {
    code: '9270',
    name: 'Laarne',
  },
  {
    code: '9280',
    name: 'Denderbelle',
  },
  {
    code: '9280',
    name: 'Lebbeke',
  },
  {
    code: '9280',
    name: 'Wieze',
  },
  {
    code: '9290',
    name: 'Berlare',
  },
  {
    code: '9290',
    name: 'Overmere',
  },
  {
    code: '9290',
    name: 'Uitbergen',
  },
  {
    code: '9300',
    name: 'Aalst',
    nameNL: 'Aalst',
    nameFR: 'Alost',
  },
  {
    code: '9308',
    name: 'Gijzegem',
  },
  {
    code: '9308',
    name: 'Hofstade',
  },
  {
    code: '9310',
    name: 'Baardegem',
  },
  {
    code: '9310',
    name: 'Herdersem',
  },
  {
    code: '9310',
    name: 'Meldert',
  },
  {
    code: '9310',
    name: 'Moorsel',
  },
  {
    code: '9320',
    name: 'Erembodegem',
  },
  {
    code: '9320',
    name: 'Nieuwerkerken',
  },
  {
    code: '9340',
    name: 'Impe',
  },
  {
    code: '9340',
    name: 'Lede',
  },
  {
    code: '9340',
    name: 'Oordegem',
  },
  {
    code: '9340',
    name: 'Smetlede',
  },
  {
    code: '9340',
    name: 'Wanzele',
  },
  {
    code: '9400',
    name: 'Appelterre-Eichem',
  },
  {
    code: '9400',
    name: 'Denderwindeke',
  },
  {
    code: '9400',
    name: 'Lieferinge',
  },
  {
    code: '9400',
    name: 'Nederhasselt',
  },
  {
    code: '9400',
    name: 'Ninove',
  },
  {
    code: '9400',
    name: 'Okegem',
  },
  {
    code: '9400',
    name: 'Voorde',
  },
  {
    code: '9401',
    name: 'Pollare',
  },
  {
    code: '9402',
    name: 'Meerbeke',
  },
  {
    code: '9403',
    name: 'Neigem',
  },
  {
    code: '9404',
    name: 'Aspelare',
  },
  {
    code: '9406',
    name: 'Outer',
    nameNL: 'Outer',
    nameFR: 'Oultre',
  },
  {
    code: '9420',
    name: 'Aaigem',
  },
  {
    code: '9420',
    name: 'Bambrugge',
  },
  {
    code: '9420',
    name: 'Burst',
  },
  {
    code: '9420',
    name: 'Erondegem',
  },
  {
    code: '9420',
    name: 'Erpe',
  },
  {
    code: '9420',
    name: 'Erpe-Mere',
  },
  {
    code: '9420',
    name: 'Mere',
  },
  {
    code: '9420',
    name: 'Ottergem',
  },
  {
    code: '9420',
    name: 'Vlekkem',
  },
  {
    code: '9450',
    name: 'Denderhoutem',
  },
  {
    code: '9450',
    name: 'Haaltert',
  },
  {
    code: '9450',
    name: 'Heldergem',
  },
  {
    code: '9451',
    name: 'Kerksken',
  },
  {
    code: '9470',
    name: 'Denderleeuw',
  },
  {
    code: '9472',
    name: 'Iddergem',
  },
  {
    code: '9473',
    name: 'Welle',
  },
  {
    code: '9500',
    name: 'Geraardsbergen',
    nameNL: 'Geraardsbergen',
    nameFR: 'Grammont',
  },
  {
    code: '9500',
    name: 'Goeferdinge',
  },
  {
    code: '9500',
    name: 'Lokeren',
  },
  {
    code: '9500',
    name: 'Nederboelare',
  },
  {
    code: '9500',
    name: 'Onkerzele',
  },
  {
    code: '9500',
    name: 'Ophasselt',
  },
  {
    code: '9500',
    name: 'Overboelare',
  },
  {
    code: '9500',
    name: 'Viane',
  },
  {
    code: '9500',
    name: 'Zarlardinge',
  },
  {
    code: '9506',
    name: 'Grimminge',
  },
  {
    code: '9506',
    name: 'Idegem',
  },
  {
    code: '9506',
    name: 'Nieuwenhove',
  },
  {
    code: '9506',
    name: 'Schendelbeke',
  },
  {
    code: '9506',
    name: 'Smeerebbe-Vloerzegem',
  },
  {
    code: '9506',
    name: 'Waarbeke',
  },
  {
    code: '9506',
    name: 'Zandbergen',
  },
  {
    code: '9520',
    name: 'Bavegem',
  },
  {
    code: '9520',
    name: 'Oombergen',
  },
  {
    code: '9520',
    name: 'Sint-Lievens-Houtem',
    nameNL: 'Sint-Lievens-Houtem',
    nameFR: 'Houtem-Saint-Liévin',
  },
  {
    code: '9520',
    name: 'Vlierzele',
  },
  {
    code: '9520',
    name: 'Zonnegem',
  },
  {
    code: '9521',
    name: 'Letterhoutem',
  },
  {
    code: '9550',
    name: 'Herzele',
  },
  {
    code: '9550',
    name: 'Hillegem',
  },
  {
    code: '9550',
    name: 'Sint-Antelinks',
  },
  {
    code: '9550',
    name: 'Sint-Lievens-Esse',
    nameNL: 'Sint-Lievens-Esse',
    nameFR: 'Essche-St-Liévin',
  },
  {
    code: '9550',
    name: 'Steenhuize-Wijnhuize',
  },
  {
    code: '9550',
    name: 'Woubrechtegem',
  },
  {
    code: '9551',
    name: 'Ressegem',
  },
  {
    code: '9552',
    name: 'Borsbeke',
  },
  {
    code: '9570',
    name: 'Deftinge',
  },
  {
    code: '9570',
    name: 'Lierde',
  },
  {
    code: '9570',
    name: 'Sint-Maria-Lierde',
    nameNL: 'Sint-Maria-Lierde',
    nameFR: 'Lierde-Sainte-Marie',
  },
  {
    code: '9571',
    name: 'Hemelveerdegem',
  },
  {
    code: '9572',
    name: 'Sint-Martens-Lierde',
  },
  {
    code: '9600',
    name: 'Ronse',
    nameNL: 'Ronse',
    nameFR: 'Renaix',
  },
  {
    code: '9620',
    name: 'Elene',
  },
  {
    code: '9620',
    name: 'Erwetegem',
  },
  {
    code: '9620',
    name: 'Godveerdegem',
  },
  {
    code: '9620',
    name: 'Grotenberge',
  },
  {
    code: '9620',
    name: 'Leeuwergem',
  },
  {
    code: '9620',
    name: 'Oombergen',
  },
  {
    code: '9620',
    name: 'Sint-Goriks-Oudenhove',
    nameNL: 'Sint-Goriks-Oudenhove',
    nameFR: 'Audenhove-Saint-Géry',
  },
  {
    code: '9620',
    name: 'Sint-Maria-Oudenhove',
    nameNL: 'Sint-Maria-Oudenhove',
    nameFR: 'Audenhove-Sainte-Marie',
  },
  {
    code: '9620',
    name: 'Strijpen',
  },
  {
    code: '9620',
    name: 'Velzeke-Ruddershove',
    nameNL: 'Velzeke-Ruddershove',
    nameFR: 'Velsique-Ruddershove',
  },
  {
    code: '9620',
    name: 'Zottegem',
  },
  {
    code: '9630',
    name: 'Beerlegem',
  },
  {
    code: '9630',
    name: 'Dikkele',
  },
  {
    code: '9630',
    name: 'Hundelgem',
  },
  {
    code: '9630',
    name: 'Meilegem',
  },
  {
    code: '9630',
    name: 'Munkzwalm',
  },
  {
    code: '9630',
    name: 'Paulatem',
  },
  {
    code: '9630',
    name: 'Roborst',
  },
  {
    code: '9630',
    name: 'Rozebeke',
  },
  {
    code: '9630',
    name: 'Sint-Blasius-Boekel',
    nameNL: 'Sint-Blasius-Boekel',
    nameFR: 'Boucle-Saint-Blaise',
  },
  {
    code: '9630',
    name: 'Sint-Denijs-Boekel',
    nameNL: 'Sint-Denijs-Boekel',
    nameFR: 'Boucle-Saint-Denis',
  },
  {
    code: '9630',
    name: 'Sint-Maria-Latem',
    nameNL: 'Sint-Maria-Latem',
    nameFR: 'Lathem-Sainte-Marie',
  },
  {
    code: '9630',
    name: 'Zwalm',
  },
  {
    code: '9636',
    name: 'Nederzwalm-Hermelgem',
  },
  {
    code: '9660',
    name: 'Brakel',
  },
  {
    code: '9660',
    name: 'Elst',
  },
  {
    code: '9660',
    name: 'Everbeek',
  },
  {
    code: '9660',
    name: 'Michelbeke',
  },
  {
    code: '9660',
    name: 'Nederbrakel',
  },
  {
    code: '9660',
    name: 'Opbrakel',
  },
  {
    code: '9660',
    name: 'Sint-Maria-Oudenhove',
    nameNL: 'Sint-Maria-Oudenhove',
    nameFR: 'Audenhove-Sainte-Marie',
  },
  {
    code: '9660',
    name: 'Zegelsem',
  },
  {
    code: '9661',
    name: 'Parike',
  },
  {
    code: '9667',
    name: 'Horebeke',
  },
  {
    code: '9667',
    name: 'Sint-Kornelis-Horebeke',
    nameNL: 'Sint-Kornelis-Horebeke',
    nameFR: 'Horebeke-Saint-Corneille',
  },
  {
    code: '9667',
    name: 'Sint-Maria-Horebeke',
    nameNL: 'Sint-Maria-Horebeke',
    nameFR: 'Horebeke-Sainte-Marie',
  },
  {
    code: '9680',
    name: 'Etikhove',
  },
  {
    code: '9680',
    name: 'Maarke-Kerkem',
  },
  {
    code: '9680',
    name: 'Maarkedal',
  },
  {
    code: '9681',
    name: 'Nukerke',
  },
  {
    code: '9688',
    name: 'Schorisse',
    nameNL: 'Schorisse',
    nameFR: 'Escornaix',
  },
  {
    code: '9690',
    name: 'Berchem',
  },
  {
    code: '9690',
    name: 'Kluisbergen',
    nameNL: 'Kluisbergen',
    nameFR: "(niet Mont de l'Enclus ! )",
  },
  {
    code: '9690',
    name: 'Kwaremont',
    nameNL: 'Kwaremont',
    nameFR: 'Quaremont',
  },
  {
    code: '9690',
    name: 'Ruien',
  },
  {
    code: '9690',
    name: 'Zulzeke',
    nameNL: 'Zulzeke',
    nameFR: 'Sulsique',
  },
  {
    code: '9700',
    name: 'Bevere',
  },
  {
    code: '9700',
    name: 'Edelare',
  },
  {
    code: '9700',
    name: 'Eine',
  },
  {
    code: '9700',
    name: 'Ename',
  },
  {
    code: '9700',
    name: 'Heurne',
  },
  {
    code: '9700',
    name: 'Leupegem',
  },
  {
    code: '9700',
    name: 'Mater',
  },
  {
    code: '9700',
    name: 'Melden',
  },
  {
    code: '9700',
    name: 'Mullem',
  },
  {
    code: '9700',
    name: 'Nederename',
  },
  {
    code: '9700',
    name: 'Ooike',
  },
  {
    code: '9700',
    name: 'Oudenaarde',
    nameNL: 'Oudenaarde',
    nameFR: 'Audenarde',
  },
  {
    code: '9700',
    name: 'Volkegem',
  },
  {
    code: '9700',
    name: 'Welden',
  },
  {
    code: '9750',
    name: 'Huise',
    nameNL: 'Huise',
    nameFR: 'Huysse',
  },
  {
    code: '9750',
    name: 'Ouwegem',
    nameNL: 'Ouwegem',
    nameFR: 'Auwegem',
  },
  {
    code: '9750',
    name: 'Zingem',
  },
  {
    code: '9770',
    name: 'Zingem',
  },
  {
    code: '9771',
    name: 'Nokere',
  },
  {
    code: '9772',
    name: 'Wannegem-Lede',
  },
  {
    code: '9790',
    name: 'Elsegem',
  },
  {
    code: '9790',
    name: 'Moregem',
  },
  {
    code: '9790',
    name: 'Ooike',
  },
  {
    code: '9790',
    name: 'Petegem-Aan-De-Schelde',
  },
  {
    code: '9790',
    name: 'Wortegem',
  },
  {
    code: '9790',
    name: 'Wortegem-Petegem',
  },
  {
    code: '9800',
    name: 'Astene',
  },
  {
    code: '9800',
    name: 'Bachte-Maria-Leerne',
  },
  {
    code: '9800',
    name: 'Deinze',
  },
  {
    code: '9800',
    name: 'Gottem',
  },
  {
    code: '9800',
    name: 'Grammene',
  },
  {
    code: '9800',
    name: 'Meigem',
  },
  {
    code: '9800',
    name: 'Petegem-Aan-De-Leie',
  },
  {
    code: '9800',
    name: 'Sint-Martens-Leerne',
    nameNL: 'Sint-Martens-Leerne',
    nameFR: 'Leerne-Saint-Martin',
  },
  {
    code: '9800',
    name: 'Vinkt',
  },
  {
    code: '9800',
    name: 'Wontergem',
  },
  {
    code: '9800',
    name: 'Zeveren',
  },
  {
    code: '9810',
    name: 'Eke',
  },
  {
    code: '9810',
    name: 'Nazareth-De Pinte',
  },
  {
    code: '9820',
    name: 'Bottelare',
  },
  {
    code: '9820',
    name: 'Lemberge',
  },
  {
    code: '9820',
    name: 'Melsen',
  },
  {
    code: '9820',
    name: 'Merelbeke-Melle',
  },
  {
    code: '9820',
    name: 'Munte',
  },
  {
    code: '9820',
    name: 'Schelderode',
  },
  {
    code: '9830',
    name: 'Sint-Martens-Latem',
    nameNL: 'Sint-Martens-Latem',
    nameFR: 'Lathem-Saint-Martin',
  },
  {
    code: '9831',
    name: 'Deurle',
  },
  {
    code: '9840',
    name: 'Nazareth-De Pinte',
    nameNL: 'Nazareth-De Pinte',
    nameFR: 'Nazareth-La Pinte',
  },
  {
    code: '9840',
    name: 'Zevergem',
  },
  {
    code: '9850',
    name: 'Hansbeke',
  },
  {
    code: '9850',
    name: 'Landegem',
  },
  {
    code: '9850',
    name: 'Merendree',
  },
  {
    code: '9850',
    name: 'Deinze',
  },
  {
    code: '9850',
    name: 'Poesele',
  },
  {
    code: '9850',
    name: 'Vosselare',
  },
  {
    code: '9860',
    name: 'Balegem',
  },
  {
    code: '9860',
    name: 'Gijzenzele',
  },
  {
    code: '9860',
    name: 'Landskouter',
  },
  {
    code: '9860',
    name: 'Moortsele',
  },
  {
    code: '9860',
    name: 'Oosterzele',
  },
  {
    code: '9860',
    name: 'Scheldewindeke',
  },
  {
    code: '9870',
    name: 'Machelen',
  },
  {
    code: '9870',
    name: 'Olsene',
  },
  {
    code: '9870',
    name: 'Zulte',
  },
  {
    code: '9880',
    name: 'Aalter',
  },
  {
    code: '9880',
    name: 'Lotenhulle',
  },
  {
    code: '9880',
    name: 'Poeke',
    nameNL: 'Poeke',
    nameFR: 'Poucke / Poucques',
  },
  {
    code: '9881',
    name: 'Bellem',
  },
  {
    code: '9890',
    name: 'Asper',
  },
  {
    code: '9890',
    name: 'Baaigem',
  },
  {
    code: '9890',
    name: 'Dikkelvenne',
  },
  {
    code: '9890',
    name: 'Gavere',
  },
  {
    code: '9890',
    name: 'Semmerzake',
  },
  {
    code: '9890',
    name: 'Vurste',
  },
  {
    code: '9900',
    name: 'Eeklo',
  },
  {
    code: '9910',
    name: 'Aalter',
  },
  {
    code: '9910',
    name: 'Ursel',
  },
  {
    code: '9920',
    name: 'Lievegem',
  },
  {
    code: '9921',
    name: 'Vinderhoute',
  },
  {
    code: '9930',
    name: 'Lievegem',
  },
  {
    code: '9931',
    name: 'Oostwinkel',
  },
  {
    code: '9932',
    name: 'Ronsele',
  },
  {
    code: '9940',
    name: 'Ertvelde',
  },
  {
    code: '9940',
    name: 'Evergem',
  },
  {
    code: '9940',
    name: 'Kluizen',
  },
  {
    code: '9940',
    name: 'Sleidinge',
  },
  {
    code: '9950',
    name: 'Lievegem',
  },
  {
    code: '9960',
    name: 'Assenede',
  },
  {
    code: '9961',
    name: 'Boekhoute',
  },
  {
    code: '9968',
    name: 'Bassevelde',
  },
  {
    code: '9968',
    name: 'Oosteeklo',
  },
  {
    code: '9970',
    name: 'Kaprijke',
  },
  {
    code: '9971',
    name: 'Lembeke',
  },
  {
    code: '9980',
    name: 'Sint-Laureins',
    nameNL: 'Sint-Laureins',
    nameFR: 'Saint-Laurent',
  },
  {
    code: '9981',
    name: 'Sint-Margriete',
    nameNL: 'Sint-Margriete',
    nameFR: 'Sainte-Marguerite',
  },
  {
    code: '9982',
    name: 'Sint-Jan-In-Eremo',
    nameNL: 'Sint-Jan-in-Eremo',
    nameFR: 'Saint-Jean-in-Eremo',
  },
  {
    code: '9988',
    name: 'Waterland-Oudeman',
  },
  {
    code: '9988',
    name: 'Watervliet',
  },
  {
    code: '9990',
    name: 'Maldegem',
  },
  {
    code: '9991',
    name: 'Adegem',
  },
  {
    code: '9992',
    name: 'Middelburg',
  },
]);
